import { DragEvent, lazy, memo, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import "./Grid.css";
import SCHEME_ELEMENTS from "../../Functions/getElements";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight, faArrowDown, faArrowLeft, faArrowRight, faArrowUp, faBoltLightning, faBookOpen, faBug, faCheck, faEllipsis, faFlagCheckered, faMinus, faPlay, faPlug, faPlus, faRotateLeft, faRotateRight, faScissors, faScrewdriver, faSearchMinus, faSearchPlus, faTimes } from "@fortawesome/free-solid-svg-icons";
import OptionsMenu from "../OptionsMenu/OptionsMenu";
import SignsMenu from "../SignsMenu/SignsMenu";
import zoomFunc from "../../Functions/zoomFunction";
import { useCookies } from "react-cookie";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import contactNormalDeschis from "../../imgs/contact_normal_deschis.svg";
import generatorInaltaIcon from "../../imgs/inalta_tensiune/generator_deschis_inalta_tensiune.svg";
import derivatie_din_conductor_punctat from "../../imgs/derivatie_din_conductor.svg";
import bobinaReleu from "../../imgs/bobina_releu.svg";
import buton_cu_revenire from "../../imgs/buton_cu_revenire.svg";
import motor_asincron_trifazat_cu_rotor_cu_inele from "../../imgs/motor_asincron_trifazat_cu_rotor_cu_inele.svg";
import sirDeClame from "../../imgs/sir_de_clame.svg";
import { faCopy, faLightbulb, faObjectUngroup, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import aparatDeMasura from "../../imgs/aparat_de_masura.svg";
import screwDriver from "../../imgs/screw-driver.png";
import useContextMenu from "../../Hooks/useContextMenu";
import rightClickData from "./rightClickData";
import GridElement from "./GridElement";
import comutator_bipolar from "../../imgs/comutator_bipolar.svg";
import priza_pentru_tensiune_redusa_de_protectie from "../../imgs/priza_pentru_tensiune_redusa_de_protectie.svg";
import siguranta from "../../imgs/siguranta.svg";

const buzzerSound = require("../../sounds/buzzer.mp3");
const screwSound = require("../../sounds/screw.mp3");

const CATEGORIES = ["conductors", "contacts", "protections", "switches", "bobines", "sockets", "engines", "high-tension", "others"];

// console.log = () => {};

let fromSimulationPressForce : number = 0;


const PrintColumns = memo((props : any) => {

    const COLUMNS = useMemo(() => props?.columns || 28, []);
    const rowIdx = useMemo(() => props?.rowIdx || 0, []);
    const page = useMemo(() => props?.page || 1, []);
    const columnsArr = useMemo(() => new Array(COLUMNS).fill(0), []);

    
  
    return (
        <>
            {columnsArr.map((_ : number, idx : any) => {
                const otherProps = {
                    row: idx,
                    column: rowIdx
                };

                let electricityLine = new Array(5);
                let hasCurrent = new Array(5);

                Object.keys(props?.currentElectricity || {}).forEach((key : string) => {
                    const [ keyIdx, keyRowIdx, keySignIdx, keyPage, keyCurrLine ] = key.split("_");
                    if (Number(keyIdx) === idx && Number(keyRowIdx) === rowIdx && Number(keyPage) === page) {
                        const value = props?.currentElectricity?.[key];
                        if (value) {
                            electricityLine[Number(keySignIdx)] = keyCurrLine;
                            hasCurrent[Number(keySignIdx)] = true;
                        } else hasCurrent[Number(keySignIdx)] = false;
                    }
                });  
                

                Object.keys(props?.consumersMap || {}).forEach((key : string) => {
                    const [ keyIdx, keyRowIdx, keySignIdx, keyPage ] = key.split("_");
                    if (Number(keyIdx) === idx && Number(keyRowIdx) === rowIdx && Number(keyPage) === page) {
                        const value = props?.consumersMap?.[key]?.isCurrent;

                        const signObject = props?.findSignObject(idx, rowIdx);
                        
                        const phaseLines = props?.consumersMap?.[key].lines.filter((line : { tension: number }) => line.tension !== 3).length;
                        const isSemiSpin = signObject?.names[keySignIdx].name.includes("motor") && phaseLines < 3 && phaseLines > 0;
                        if (isSemiSpin) {
                            setTimeout(() => {
                                const currentThermalRelays = props?.thermalRelays ?? [];
                                const currentThermalRelay = currentThermalRelays.find((thermalRelay : { consumer: { x: number, y: number, page: number } }) => thermalRelay?.consumer?.x === Number(keyIdx) && thermalRelay?.consumer?.y === Number(keyRowIdx) && thermalRelay?.consumer?.page === Number(keyPage));
                                if (currentThermalRelay) {
                                    currentThermalRelay.relays.forEach((relay : string) => {
                                        const currentElements = props?.findSignsObjectByName(relay);
                                        currentElements.forEach((element : { x: number, y: number, page:number, names: Array<{name: string}> }) => {
                                             if (element?.names?.some((name) => name.name.includes("contact") || name.name.includes("intreruptor"))) {
                                                props?.simulationPress(element.x, element.y, element.names);
                                                setTimeout(() => {
                                                    props?.simulationPress(element.x, element.y, element.names);
                                                }, 500)
                                             }
                                        });
                                    });
                                }
                            }, 2000);
                           
                        }

                        electricityLine[Number(keySignIdx)] = `consumer ${isSemiSpin ? "semi-spin" : signObject?.names[keySignIdx].name.includes("motor") && value ? "spin" : ""}`;
                        if (value) {  
                            hasCurrent[Number(keySignIdx)] = true;
                        } else hasCurrent[Number(keySignIdx)] = false;
                    }
                });  

                

                // console.log(electricityLine);


                return <GridElement 
                    {...props}
                    idx={idx}
                    otherProps={otherProps}
                    hasCurrent={hasCurrent}
                    electricityLine={electricityLine}
                    key={idx}
                />;
            })}
        </>
    );
});

const PrintRows = memo((props : any ) => {
    const { rowRef, ROWS } = props;
    const rowsElements = useMemo(() => new Array(ROWS).fill(0), []);
    return (
        <>
            {rowsElements.map((_ : number, idx: number) => (
                <div className="row" key={idx} ref={ref => rowRef.current[idx] = ref}>
                    <PrintColumns
                        {...props}
                        rowIdx={idx}
                        idx={idx}
                    />
                </div>
            ))}
        </>
    );

});

const TENSION_NUMBER = 230;

const Grid = ({ useStore, data, page, removePage, printSchemes, totalPages, projectId, category, format, isSimulation, projectName, debugSchemeNumber, teacherVar, gridColumns, gridRows }: { isSimulation: boolean, useStore: any, debugSchemeNumber: any, data: any, totalPages: number | null, page: number, projectId: string | null, category: string, format: string, projectName: string, removePage: ((pg: number) => void) | null, printSchemes: (() => void) | null, teacherVar: boolean, gridColumns?: number, gridRows?: number }) => {

    const buzzerSoundRef = useRef<HTMLAudioElement>(null);
    const screwSoundRef = useRef<HTMLAudioElement>(null);
    const isTeacher = useMemo(() => data.userData.type === "teacher" && teacherVar, []);
    // gridColumns / gridRows override the format defaults — used by the
    // high-tension training scheme to spread the bays over a wider canvas.
    const ROWS = gridRows ?? (format === "A4" ? 20 : format === "A3" ? 28 : 20);
    const COLUMNS = gridColumns ?? (format === "A4" ? 28 : format === "A3" ? 40 : 28);
    const LONG_PRESS_DELAY = 1500;
    const currParams = useParams();
    const sessionId = currParams?.sessionId;
    const schemeNumber = currParams?.schemeNumber;
    const location = useLocation();

    const pageRef = useRef<HTMLDivElement>(null);
    const cellRef = useRef<Array<HTMLDivElement | null>>([]);
    const dotsRef = useRef<Array<HTMLDivElement>>([]);
    const rowRef = useRef<Array<HTMLDivElement | null>>([]);
    const printRef = useRef<HTMLDivElement>(null);
    const deviceScreenRef = useRef<any>(null);
    const projectNameRef = useRef<HTMLDivElement>(null);
    const pageNumberRef = useRef<HTMLDivElement>(null);
    const nameContainerRef = useRef<HTMLDivElement>(null);
    const addElementsRef = useRef<HTMLDivElement>(null);
    const addSignsContainerRef = useRef<HTMLDivElement>(null);

    const [cookies, setCookie] = useCookies();
    

    const [currElements, setCurrentElements] = useState<Array<{ row: number, col: number, type: 'string' }> | Array<null>>([]);
    const [dragElement, setDragElement] = useState<HTMLDivElement | null>();
    const [lastDrag, setLastDrag] = useState<HTMLDivElement | null>();
    const [firstElementPos, setFirstElementPos] = useState<number | null>();
    const [lastElementPos, setLastElementPos] = useState<number | null>();
    const [firstEmptyCell, setFirstEmptyCell] = useState<{ x: number, y: number, page: number } | null>(null);

 
    const [dragElementRow, setDragElementRow] = useState<number | null>(null);
    const [dragElementColumn, setDragElementColumn] = useState<number | null>(null);
    const [columns, setColumns] = useState<Array<number>>(new Array(COLUMNS).fill(0));
    const [signTextAlignment, setSignTextAlignment] = useState<string>("");
    const [nameSignMenu, setNameSignMenu] = useState<boolean>(false);
    const [activeDots, setActiveDots] = useState<any>(null);
    const [defectsButton, setDefectsButton] = useState<boolean>(false);
    const [activeDot, setActiveDot] = useState<any>(null);
    const [defects, setDefects] = useState<Array<{ element: any, type: string, screw: number | null }>>([]);
    const [elementsWindowScrollX, setElementsWindowScrollX] = useState<number>(0);

    const [signs, addSign, removeSign, replaceSign] = [useStore((state: any) => state.elements), useStore((state: any) => state.addSign), useStore((state: any) => state.removeSign), useStore((state: any) => state.replaceSign)];

    // O(1) coordinate lookup. findSign/findSignObject and the electricity
    // flood previously scanned the whole elements array for every cell — on a
    // full grid that meant hundreds of thousands of comparisons per click.
    // Duplicate coordinates keep the entry with the most names (same rule as
    // the old filter+reduce in findSign).
    const signsIndex = useMemo(() => {
        const index = new Map<string, any>();
        signs.forEach((sign : any) => {
            const key = `${sign.x}_${sign.y}_${sign.page}`;
            const existing = index.get(key);
            if (!existing || (sign?.names?.length || 0) > (existing?.names?.length || 0)) index.set(key, sign);
        });
        return index;
    }, [signs]);
    const findAt = (x : number, y : number, pg : number) => signsIndex.get(`${x}_${y}_${pg}`);

    const changeIsLockedSign = useStore((state: any) => state.changeIsLockedSign);
    const changeIsSelectedSign = useStore((state: any) => state.changeIsSelectedSign);
    const changeSignPosition = useStore((state: any) => state.changeSignPosition);
    const addSignMenu = useStore((state: any) => state.addSignMenu);
    const changeAddSignMenu = useStore((state: any) => state.changeAddSignMenu);
    const removeSelectedSign = useStore((state: any) => state.removeSelectedSign);
    const changeSelectedCell = useStore((state: any) => state.changeSelectedCell);
    const changeCellName = useStore((state: any) => state.changeSignName);
    const isImageLocked = useStore((state: any) => state.lockImage);
    const [singleElementDrag, setSingleElementDrag] = useState<boolean>(false);
    const printCall = useStore((state: any) => state.printCall);
    const changeGridActivated = useStore((state: any) => state.changeGrid);
    const isGridActivated = useStore((state: any) => state.isGrid);
    const isSelected = useStore((state: any) => state.elements.find((element: any) => element.isSelectedSign));
    const language = useStore((state: any) => state.language);
    const changeEditMenu = useStore((state: any) => state.changeEditMenu);
    const changeOpenMenu = useStore((state: any) => state.changeOpenMenu);
    const schemeStructure = useStore((state: any) => state.schemeStructure);
    const changeSchemeStructure = useStore((state: any) => state.changeSchemeStructure);
    const changeOpenSchemeStructure = useStore((state: any) => state.changeOpenSchemeStructure);
    const changeScrewSchemeStructure = useStore((state: any) => state.changeScrewSchemeStructure);
    const changeSolvedSchemeStructure = useStore((state: any) => state.changeSolvedSchemeStructure);
    const changeSignTextPosition = useStore((state: any) => state.changeSignTextPosition);
    const flipSign = useStore((state: any) => state.flipSign);
    const [deviceDrag, setDeviceDrag] = useState<boolean>(false);
    const isCurrentOnScheme = useStore((state : any) => state.current);
    const [initialSigns, setInitialSigns] = useState(signs);
    

    const [screw, setScrew] = useState<any>(0);
    const [unscrew, setUnscrew] = useState<any>(0);
    const [simulation, setSimulation] = useState<boolean>(isSimulation || false);

    const activeEditMenu = useStore((state: any) => state.activeEditMenu);
    const isGrid = useStore((state: any) => state.isGrid );

    useEffect(() => {
        if (category !== "0") return;
        // changeGridActivated(window.history.state?.isGrid !== null && window.history.state?.isGrid !== isGrid ? !isGrid : isGrid);
    }, []);

    // const alignmentOptions = language === "ro" ? ["Stanga-Sus", "Centru-Sus", "Dreapta-Sus", "Stanga-Centru", "Centru-Centru", "Dreapta-Centru", "Stanga-Jos", "Centru-Jos", "Dreapta-Jos"] : ["Top-Left", "Top-Center", "Top-Right", "Center-Left", "Center-Center", "Center-Right", "Bottom-Left", "Bottom-Center", "Bottom-Right"];
    // const alignmentClassList = ["top-left", "top-center", "top-right", "center-left", "center-center", "center-right", "bottom-left", "bottom-center", "bottom-right"];
    // const [alignmentIdx, setAlignmentIdx] = useState(isSelected ? alignmentOptions.indexOf(isSelected.textAlignment) || 0 : 0);
    const [texts, setTexts] = useState<any>(isSelected ? isSelected.texts || [] : "");
    const [signFontSize, setSignFontSize] = useState("14");

    const defectsOptions = cookies.language === "en" ? ["Lack of tension", "Short circuit"] : ["Lipsa tensiune", "Scurt circuit"];
    const [activeDefectsOption, setActiveDefectsOption] = useState<boolean>(false);
    const [activeDefectsOptionType, setActiveDefectsOptionType] = useState<string>(cookies?.language === "en" ? "Lack of tension" : "Lipsa tensiune");
    const [defectsResponse, setDefectsResponse] = useState<any>(null);
    const [problemsSolved, setProblemsSolved] = useState<any>();
    const [notes, setNotes] = useState<string>("");
    const [logs, setLogs] = useState<Array<any>>([]);
    const [scrollX, setScrollX] = useState<number>(0);
    const [scrollY, setScrollY] = useState<number>(0);
    const [schemeMap, setSchemeMap] = useState<Array<{ point: number, sign: string, line: string, problem: string | null }>>([]);
    const [sessionData, setSessionData] = useState<{ problems: any } | null>(null);
    const [currentProjectName, setCurrentProjectName] = useState<string>(projectName);
    const [projectData, setProjectData] = useState<any>(null);
    const [projectDataSaved, setProjectDataSaved] = useState<boolean>(false);
    const [copiedElement, setCopiedElement] = useState<{ x: number, y: number, names: Array<any>, flip: number, texts: any, signColor: string | null } | null>(null);
    const [cuttedElement, setCuttedElement] = useState<{ x: number, y: number, names: Array<any>, flip: number, texts: any, signColor: string | null } | null>(null);
    const [copiedElements, setCopiedElements] = useState<Array<{ x: number, y: number, names: Array<any>, flip: number, texts: any, signColor: string | null }> | null>(null);
    const [cuttedElements, setCuttedElements] = useState<Array<{ x: number, y: number, names: Array<any>, flip: number, texts: any, signColor: string | null }> | null>(null);
    const [multipleSelectedCells, setMultipleSelectedCells] = useState<Array<{ x: number, y: number, sign: {  
        x: number, 
        y : number, 
        texts: Array<{ name: string, flip: number, positionX: number, positionY: number, fontSize: number, fontWeight: number, color: string }> | []
        isSelectedSign: boolean, 
        isLockedSign: boolean, 
        names: Array<any>,
        flip: number,
        page: number | 1,
        hasCurrent: boolean,
        
    } } | boolean> | boolean>(false);

    // Measurment device state
    const [showMeasurmentDevice, setShowMeasurmentDevice] = useState<boolean>(false);
    const [deviceValue, setDeviceValue] = useState<number | string>("");
    const [activeOptionAdd, setActiveOptionAdd] = useState<number | null>(null);
    const [activeSubCategoryAdd, setActiveSubCategoryAdd] = useState<string | null>(null);

    const [deviceActiveOption, setDeviceActiveOption] = useState<string>("off");
    const [currentElectricity, setCurrentElectricity] = useState<any>({});

    const markedMap : any = useMemo(() => new Object(), []);
    let electricityArr : any = useMemo(() => new Object(), []);
    let consumersArr : any = useMemo(() => new Object(), []);
    let initialConsumersArr : any = useMemo(() => new Object(), []);


    const [consumersMap, setConsumersMap] = useState<any>({});
    const [lastConsumersMap, setLastConsumersMap] = useState<any>({});

    // useEffect(() => {
    //     localStorage.setItem(`signs-${projectId}`, JSON.stringify(signs));
    // }, [signs]);

    useEffect(() => {
    }, [multipleSelectedCells]);

    useEffect(() => {
    }, [signs]);

    const [thermalRelays, setThermalRelays] = useState<{
        relays: Array<string>,
        consumer: { x: number, y: number, page: number }
    }[]>([{ relays: [], consumer: { x: -1, y: -1, page: -1 } }]);


    const isCompatible = (line : {x : number, y : number, page : number, flip : number, names : Array<any>, signPosition : string}, direction : string) => {
        const flip = line?.flip || 0;
        const names = line?.names || [];

        if (!names.length) return -1;
        
        return names.findIndex(name => {
            if (name.name.includes("actionare_prin_apasare_automentinere") || name.name.includes("automentinere_stanga")) {

                if (Number(flip + name.flip) === 0) return direction === "top" || direction === "bottom";
                else if (Number(flip + name.flip) === 90) return direction === "left" || direction === "right";
                else if (Number(flip + name.flip) === 180) return direction === "top" || direction === "bottom";
                else if (Number(flip + name.flip) === 270) return direction === "left" || direction === "right";
                
            } else if (name.name.includes("automentinere")) { 
    
                if (Number(flip + name.flip) === 0) return direction === "right";
                else if (Number(flip + name.flip) === 90) return direction === "bottom";
                else if (Number(flip + name.flip) === 180) return direction === "left";
                else if (Number(flip + name.flip) === 270) return direction === "top";
    
            } else if (name.name.includes("conductor_lung") || name.name.includes("conductor_scurt")) {

                if (Number(flip + name.flip) === 90 || Number(flip + name.flip) === 270) return direction === "top" || direction === "bottom";
                else return direction === "left" || direction === "right";
    
            } else if (name.name.includes("conductor_diagonal_45")) {
                
                if (Number(flip + name.flip) === 90 || Number(flip + name.flip) === 270) return direction === "top-left" || direction === "bottom-right";
                else return direction === "top-right" || direction === "bottom-left";
    
            } else if (name.name.includes("conductor_diagonal_135")) {
    
                if (Number(flip + name.flip) === 90 || Number(flip + name.flip) === 270) return direction === "top-right" || direction === "bottom-left";
                else return direction === "top-left" || direction === "bottom-right";
    
            } else if (name.name.includes("conductor_oblic_45")) {
    
                if (Number(flip + name.flip) === 0) return direction === "top-right" || direction === "bottom";
                else if (Number(flip + name.flip) === 90) return direction === "bottom-right" || direction === "left";
                else if (Number(flip + name.flip) === 180) return direction === "bottom-left" || direction === "top";
                else if (Number(flip + name.flip) === 270) return direction === "top-left" || direction === "right";
    
            } else if (name.name.includes("conductor_oblic_135")) {
    
                if (Number(flip + name.flip) === 0) return direction === "top-left" || direction === "bottom";
                else if (Number(flip + name.flip) === 90) return direction === "top-right" || direction === "left";
                else if (Number(flip + name.flip) === 180) return direction === "bottom-right" || direction === "top";
                else if (Number(flip + name.flip) === 270) return direction === "bottom-left" || direction === "right";
    
            } else if (name.name.includes("colt_stanga_sus")) {
    
                if (Number(flip + name.flip) === 0) return direction === "left" || direction === "top";
                else if (Number(flip + name.flip) === 90) return direction === "right" || direction === "top";
                else if (Number(flip + name.flip) === 180) return direction === "right" || direction === "bottom";
                else if (Number(flip + name.flip) === 270) return direction === "left" || direction === "bottom";
    
            } else if (name.name.includes("colt_stanga_jos")) {
    
                if (Number(flip + name.flip) === 0) return direction === "left" || direction === "bottom";
                else if (Number(flip + name.flip) === 90) return direction === "left" || direction === "top";
                else if (Number(flip + name.flip) === 180) return direction === "right" || direction === "top";
                else if (Number(flip + name.flip) === 270) return direction === "right" || direction === "bottom";
     
            } else if (name.name.includes("colt_dreapta_sus")) {
    
                if (Number(flip + name.flip) === 0) return direction === "right" || direction === "top";
                else if (Number(flip + name.flip) === 90) return direction === "right" || direction === "bottom";
                else if (Number(flip + name.flip) === 180) return direction === "left" || direction === "bottom";
                else if (Number(flip + name.flip) === 270) return direction === "left" || direction === "top";
    
            } else if (name.name.includes("colt_dreapta_jos")) {
    
                if (Number(flip + name.flip) === 0) return direction === "right" || direction === "bottom";
                else if (Number(flip + name.flip) === 90) return direction === "left" || direction === "bottom";
                else if (Number(flip + name.flip) === 180) return direction === "left" || direction === "top";
                else if (Number(flip + name.flip) === 270) return direction === "right" || direction === "top";
    
            } else if (name.name.includes("derivatie_din_conductor")) {

                
                if (Number(flip + name.flip) === 0) return direction === "top" || direction === "left" || direction === "right";
                else if (Number(flip + name.flip) === 90) return direction === "right" || direction === "bottom" || direction === "top";
                else if (Number(flip + name.flip) === 180) return direction === "left" || direction === "right" || direction === "bottom";
                else if (Number(flip + name.flip) === 270) return direction === "bottom" || direction === "left" || direction === "top";
    
            } else if (name.name.includes("semi_cruce")) {
    
                if (Number(flip + name.flip) === 0) return direction === "top" || direction === "left" || direction === "bottom";
                else if (Number(flip + name.flip) === 90) return direction === "left" || direction === "right" || direction === "top";
                else if (Number(flip + name.flip) === 180) {
                   
                    return direction === "right" || direction === "top" || direction === "bottom";
                }
                else if (Number(flip + name.flip) === 270) return direction === "right" || direction === "left" || direction === "bottom";
    
            } else if (name.name.includes("cruce")) return direction === "left" || direction === "right" || direction === "top" || direction === "bottom";
            else if  (name.name.includes("motor")) {
                return true;
            }
            else {
                if (Number(flip + name.flip) === 90 || Number(flip + name.flip) === 270) return direction === "left" || direction === "right";
                else return direction === "bottom" || direction === "top";
            }
        });

    };


    const getTopNeighbour = (x : number, y : number, page : number, current: boolean, line: string, foundConsumer: boolean, pressForce : boolean) => {
        const prevElement = findAt(x, y, page);
        const element = findAt(x, y - 1, page);
        const nameIdx = isCompatible(element, "top");


        if (!element || nameIdx === -1) return;


        if (element) {
            if (!markedMap?.[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]) {

                Object.assign(markedMap, {[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]: true});
    
                getNeighbours(element, nameIdx, current, line, "top", foundConsumer, pressForce);  
            } else {
                if (electricityArr?.[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`] === false && current) {
                    getNeighbours(element, nameIdx, true, line, "top", foundConsumer, pressForce);
                }
            }
        }

        
    };

    const getBottomNeighbour = (x : number, y : number, page : number, current: boolean, line: string, foudConsumer: boolean, pressForce : boolean) => {
        const prevElement = findAt(x, y, page);
        const element = findAt(x, y + 1, page);

        const nameIdx = isCompatible(element, "bottom");

        if (!element || nameIdx === -1) {
            return;
        }

        if (element) {
            if (!markedMap?.[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]) {

                Object.assign(markedMap, {[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]: true});
    
                getNeighbours(element, nameIdx, current, line, "bottom", foudConsumer, pressForce);
            } else {
                if (electricityArr?.[`${element.x}_${element.y}_${element.page}_${line}`] === false && current) {
                    getNeighbours(element, nameIdx, true, line, "bottom", foudConsumer, pressForce);
                }
            }
        }
    };

    const getLeftNeighbour = (x: number, y: number, page: number, current: boolean, line: string, foundConsumer: boolean, pressForce : boolean) => {
        const prevElement = findAt(x, y, page);
        const element = findAt(x - 1, y, page);
        const nameIdx = isCompatible(element, "left");
        if (!element || nameIdx === -1) return;


        if (element) {

            
            if (!markedMap?.[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]) {

                
                Object.assign(markedMap, {[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]: true});
    
                getNeighbours(element, nameIdx, current, line, "left", foundConsumer, pressForce);
            } else {
                if (electricityArr?.[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`] === false && current) {
                    getNeighbours(element, nameIdx, true, line, "left", foundConsumer, pressForce);
                }
            }
        }
    };

    const getRightNeighbour = (x: number, y: number, page: number, current: boolean, line: string, foundConsumer: boolean, pressForce : boolean) => {
        const prevElement = findAt(x, y, page);
        const element = findAt(x + 1, y, page);
        const nameIdx = isCompatible(element, "right");
        
        if (!element || nameIdx === -1) return;

            if (element) {
                if (!markedMap?.[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]) {
    
                    Object.assign(markedMap, {[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]: true});
        
                    getNeighbours(element, nameIdx, current, line, "right", foundConsumer, pressForce);
                } else {
                    if (electricityArr?.[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`] === false && current) {
                        getNeighbours(element, nameIdx, true, line, "right", foundConsumer, pressForce);
                    }
                }
            }
    };

    const getCornerTopLeftNeighbour = (x: number, y: number, page: number, current: boolean, line: string, fromAutomention : boolean = false, foundConsumer : boolean, pressForce : boolean) => {
        const prevElement = findAt(x, y, page);
        const element = findAt(x - 1, y - 1, page);
        const nameIdx = isCompatible(element, fromAutomention ? "top" : "top-left");
        if (!element || nameIdx === -1) return;

        

        if (element) {
            if (!markedMap?.[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]) {
                Object.assign(markedMap, {[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]: true});
    
                getNeighbours(element, nameIdx, current, line, fromAutomention ? "top" : "top-left", foundConsumer, pressForce);
            } else {
                if (electricityArr?.[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`] === false && current) {
                    getNeighbours(element, nameIdx, true, line, fromAutomention ? "top" : "top-left", foundConsumer, pressForce);
                }
            }
        }
    };

    const getCornerTopRightNeighbour = (x: number, y: number, page: number, current: boolean, line: string, fromAutomention : boolean = false, foundConsumer: boolean, pressForce : boolean) => {
        const prevElement = findAt(x, y, page);
        const element = findAt(x + 1, y - 1, page);
        const nameIdx = isCompatible(element, fromAutomention ? "top" : "top-right");
        if (!element || nameIdx === -1) return;

        if (element) {
            if (!markedMap?.[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]) {
                Object.assign(markedMap, {[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]: true});
    
                getNeighbours(element, nameIdx, current, line, fromAutomention ? "top" : "top-right", foundConsumer, pressForce);
            } else {
                if (electricityArr?.[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`] === false && current) {
                    getNeighbours(element, nameIdx, true, line, fromAutomention ? "top" : "top-right", foundConsumer, pressForce);
                }
            }
        }
    };

    const getCornerBottomLeftNeighbour = (x: number, y: number, page: number, current: boolean, line: string, fromAutomention: boolean = false, foundConsumer: boolean, pressForce : boolean) => {
        const prevElement = findAt(x, y, page);
        const element = findAt(x - 1, y + 1, page);
        const nameIdx = isCompatible(element, fromAutomention ? "bottom" : "bottom-left");
        if (!element || nameIdx === -1) return;

        if (element) {
            if (!markedMap?.[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]) {
                Object.assign(markedMap, {[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]: true});

                getNeighbours(element, nameIdx, current, line, fromAutomention ? "bottom" : "bottom-left", foundConsumer, pressForce);
            } else {

                if (currentElectricity?.[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`] === false && current) {
                    getNeighbours(element, nameIdx, true, line, fromAutomention ? "bottom" : "bottom-left", foundConsumer, pressForce);
                }
            }
        }
    };

    const getCornerBottomRightNeighbour = (x: number, y: number, page: number, current: boolean, line: string, fromAutomention : boolean = false, foundConsumer: boolean, pressForce : boolean) => {
        const prevElement = findAt(x, y, page);
        const element = findAt(x + 1, y + 1, page);
        const nameIdx = isCompatible(element, fromAutomention ? "bottom" : "bottom-right");
        if (!element || nameIdx === -1) return;

        if (element) {
            if (!markedMap?.[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]) {
                Object.assign(markedMap, {[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`]: true});
                getNeighbours(element, nameIdx, current, line, fromAutomention ? "bottom" : "bottom-right", foundConsumer, pressForce);
            } else {

                if (currentElectricity?.[`${element.x}_${element.y}_${nameIdx}_${element.page}_${line}`] === false && current) {

                    getNeighbours(element, nameIdx, true, line, fromAutomention ? "bottom" : "bottom-right", foundConsumer, pressForce);
                }
            }
        }
    };

    const findIdxOfSign = (names: any, currentName: string) : number => {
        let idx : number = -1;
        names.forEach((name : { name: string }, nameIdx: number) => name.name.includes(currentName) ? idx = nameIdx : null);
        return idx;
    };

    const isGenerator = (name: string) => {
        return name.includes("generator") || name.includes("baterie") || name.includes("conductor_lung_sageata");
    };

    // Get Electricity in scheme

    const getNeighbours = (line : {x : number, y : number, page : number, flip : number, names : Array<any>, signPosition : string}, nameIdx: number, isCurrent: boolean, electricLine: string, direction : string, foundConsumer: boolean, pressForce : boolean) => {
        
        const { x, y, page, flip, names, signPosition } = line;
        
            const name = names[nameIdx];
            if (name.name.includes("conductor_lung_sageata_final")) {
                Object.assign(electricityArr, {[`${x}_${y}_${nameIdx}_${page}_${electricLine}`]: isCurrent});
            }        

            const signObject = findSignObject(line.x, line.y);
            if (signObject.texts.length) {
                if (name.name.includes("releu_termic")) {

                    setThermalRelays(arr => {
                        return arr.map((relay, idx) => {
                            if (idx === arr.length - 1) {
                                const currentRelays = relay?.relays ?? [];
                                const currentTexts = signObject.texts.map((text : { name: string }) => text.name).filter((text : string) => isNaN(Number(text))) ?? [];
                                return {...relay, relays: [...relay.relays, ...currentTexts]};
                            }

                            return relay;
                           
                        }).filter((relay) => {
                            return relay.relays.length !== 0;
                        });
                    });
                }
            }

         

            const oldCurrentState = consumersArr[`${x}_${y}_${nameIdx}_${page}`]?.isCurrent || false;

            if ((name.name.includes("indicator_luminos") || name.name.includes("bobina_releu") || name.name.includes("motor") || name.name.includes("conductor_lung_sageata_final") || name.name.includes("actionare_electromecanica_cu_temporizare") || name.name.includes("consumator"))) {
                if (isCurrent) {

                    if (consumersArr?.[`${x}_${y}_${nameIdx}_${page}`]) {
                        const newLines = [...consumersArr?.[`${x}_${y}_${nameIdx}_${page}`].lines, {
                            electricLine: electricLine,
                            tension: electricLine.toLowerCase() === "l1" || electricLine.toLowerCase() === "l2" || electricLine.toLowerCase() === "l3" ? 230 : electricLine.toLowerCase() === "pe" ? 3 : 0
                        }];

                        let difference = 0, numberOfPhases = 0;

                        newLines.forEach((line : { tension: number }) => {
                            if (line.tension === TENSION_NUMBER) numberOfPhases++;
                            difference -= line.tension;
                        });

                        const customNewLines = newLines.filter(line => line.tension !== 3);

                        difference = Math.abs(difference);

                        // HT consumer is single-line: energized as soon as any live line reaches it.
                        const currentState = name.name.includes("consumator") ? true : customNewLines.length - numberOfPhases === (name.name.includes("motor") ? 0 : 1) && difference / numberOfPhases >= TENSION_NUMBER / 2;


                        Object.assign(consumersArr[`${x}_${y}_${nameIdx}_${page}`], {
                            sources: consumersArr[`${x}_${y}_${nameIdx}_${page}`].sources + 1,
                            lines: newLines,
                            isCurrent: currentState,
                        });

                        if (initialConsumersArr?.[`${x}_${y}_${nameIdx}_${page}`] == null) {
                            Object.assign(initialConsumersArr, { [`${x}_${y}_${nameIdx}_${page}`]: currentState});
                        }


                        if ((name.name.includes("bobina_releu") || name.name.includes("actionare_electromecanica_cu_temporizare"))) {
                            console.warn("1");

                            setTimeout(() => {
                                const currentTexts = findSignObject(x, y, page)?.texts || [];
                                currentTexts.forEach((text : { name: string }) => {
                                    const sameNameSigns = findSignsObjectByName(text.name);
                                    sameNameSigns.forEach((sameNameSign : { x: number, y: number, names: Array<any> }) => {
                                        let index = 0;
    
    
                                        while (findSignObject(sameNameSign.x + index + 1, sameNameSign.y)?.names?.some((name) => 
                                            (name.name.includes("contact") || name.name.includes('intreruptor')) &&
                                            !name.name.includes("automentinere")
                                        )) index++;

                                        if (!needsBobineChange(sameNameSign.x, sameNameSign.y, sameNameSign.names, initialConsumersArr?.[`${x}_${y}_${nameIdx}_${page}`] === currentState)) console.log(index, sameNameSign.names);

                                        

                                        if (needsBobineChange(sameNameSign.x, sameNameSign.y, sameNameSign.names, initialConsumersArr?.[`${x}_${y}_${nameIdx}_${page}`] === currentState)) {
                                            for (let i = 0; i <= index; i++) {
                                                simulationPressForce(sameNameSign.x + i, sameNameSign.y, sameNameSign.names, initialConsumersArr?.[`${x}_${y}_${nameIdx}_${page}`] === currentState);
                                            
    
                                            }
                                        }

                                           
                                        

                                      
                                    });
                                });
                            }, name.name.includes("actionare_electromecanica_cu_temporizare") ? 15000 : 0);
                        }

                    }
                    else {
                        Object.assign(consumersArr, {[`${x}_${y}_${nameIdx}_${page}`]: {
                            sources: 1,
                            lines: [{
                                electricLine: electricLine,
                                tension: electricLine.toLowerCase() === "l1" || electricLine.toLowerCase() === "l2" || electricLine.toLowerCase() === "l3" ? 230 : electricLine.toLowerCase() === "pe" ? 3 : 0
                            }],
                            // HT consumer is single-line: the first live line already energizes it
                            // (low-tension consumers need their full phase set, so they start false).
                            isCurrent: name.name.includes("consumator") && name.name.includes("inalta")
                        }});

                        if (initialConsumersArr?.[`${x}_${y}_${nameIdx}_${page}`] == null) {
                            Object.assign(initialConsumersArr, {[`${x}_${y}_${nameIdx}_${page}`]: false});
                        }


                        
                    }

                } else {
                    if (initialConsumersArr?.[`${x}_${y}_${nameIdx}_${page}`] == null) {
                        Object.assign(initialConsumersArr, {[`${x}_${y}_${nameIdx}_${page}`]: false});
                    }


                    if ((name.name.includes("bobina_releu") || name.name.includes("actionare_electromecanica_cu_temporizare")) && oldCurrentState !== undefined && oldCurrentState !== consumersArr[`${x}_${y}_${nameIdx}_${page}`].isCurrent) {
                        console.warn("3");

                        setTimeout(() => {
                            const currentTexts = findSignObject(x, y, page)?.texts || [];
                           currentTexts.forEach((text : { name: string }) => {
                                const sameNameSigns = findSignsObjectByName(text.name);
                                sameNameSigns.forEach((sameNameSign : { x: number, y: number, names: Array<any> }) => {
                                    let index = 0;
    
    
                                    while (findSignObject(sameNameSign.x + index + 1, sameNameSign.y)?.names?.some((name) => 
                                        (name.name.includes("contact") || name.name.includes('intreruptor')) &&
                                        !name.name.includes("automentinere")
                                    )) index++;
                                    if (needsBobineChange(sameNameSign.x, sameNameSign.y, sameNameSign.names, initialConsumersArr?.[`${x}_${y}_${nameIdx}_${page}`] === false)) {
                                        for (let i = 0; i <= index; i++) {
                                            simulationPressForce(sameNameSign.x + i, sameNameSign.y, sameNameSign.names, initialConsumersArr?.[`${x}_${y}_${nameIdx}_${page}`] === false);
        
                                        }
                                    }
                                 
                                });
                           });
                        },  name.name.includes("actionare_electromecanica_cu_temporizare") ? 15000 : 0)
                       
                    }

                    delete consumersArr?.[`${x}_${y}_${nameIdx}_${page}`];
                }

                foundConsumer = true;
                setThermalRelays(arr => {
                    return [...arr.map((relay, idx) => {
                        if (idx === arr.length - 1) {
                            return {...relay, consumer: {
                                x: x,
                                y: y,
                                page: page
                            }}
                        }

                        return relay;
                        
                    }), {
                        relays: [],
                        consumer: {
                            x: -1,
                            y: -1,
                            page: -1
                        }
                    }];
                });
                
                return;
            }

            if (name.name.includes("contur") || (isGenerator(name.name) && foundConsumer)) return;
    
            let current = isCurrent;
    

            
                if (name.name.includes("deschis")) {
                    
                    // changeHasCurrent(x, y, page, false);
                    Object.assign(electricityArr, {[`${x}_${y}_${nameIdx}_${page}_${electricLine}`]: false});
                    current = false;
                    if (isCurrent && (name.name.includes("actionare_prin_apasare_automentinere") || name.name.includes("automentinere_stanga"))) {
                        const nextSign = findSignObject(line.x + 1, line.y);
                        
                        if (nextSign) getNeighbours(nextSign, nameIdx, true, electricLine, "bottom", foundConsumer, pressForce);
                    }
                    return;
        
                } else if (!name.name.includes("baterie") && !name.name.includes("generator") && !foundConsumer) {
                    // setElectricityMap(curr => {...curr, []});
                    // changeHasCurrent(x, y, page, true);
                    Object.assign(electricityArr, {[`${x}_${y}_${nameIdx}_${page}_${electricLine}`]: isCurrent});
                }
        
    
            if (name.name.includes("actionare_prin_apasare_automentinere") || name.name.includes("automentinere_stanga")) {
                const nextSign = findSignObject(line.x + 1, line.y);
                if (nextSign) getNeighbours(nextSign, nameIdx, true, electricLine, "bottom", foundConsumer, pressForce);
    
                
                if (Number(flip + name.flip) === 0) {
                
                    if (direction === "top") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    getRightNeighbour(x, y, page, isCurrent, electricLine, foundConsumer, pressForce);
                    if (direction === "bottom") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 90) {
    
                    if (direction === "left") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "right") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    getBottomNeighbour(x, y, page, isCurrent, electricLine, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 180) {
    
                    if (direction === "top") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "bottom") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    getLeftNeighbour(x, y, page, isCurrent, electricLine, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 270) {
    
                    if (direction === "left") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "right") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    getTopNeighbour(x, y, page, isCurrent, electricLine, foundConsumer, pressForce);
                
                }
    
            } else if (name.name.includes("automentinere")) { 
    
                if (Number(flip + name.flip) === 0) {
    
                    getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    getCornerBottomLeftNeighbour(x, y, page, current, electricLine, true, foundConsumer, pressForce);
                    getCornerTopLeftNeighbour(x, y, page, current, electricLine, true, foundConsumer, pressForce);
    
                } else if (Number(flip + name.flip) === 90) {
    
                    getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    getCornerTopRightNeighbour(x, y, page, current, electricLine, true, foundConsumer, pressForce);
                    getCornerTopLeftNeighbour(x, y, page, current, electricLine, true, foundConsumer, pressForce);
    
                } else if (Number(flip + name.flip) === 180) {
                    
                    getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    getCornerBottomRightNeighbour(x, y, page, current, electricLine, true, foundConsumer, pressForce);
                    getCornerTopRightNeighbour(x, y, page, current, electricLine, true, foundConsumer, pressForce);
    
                } else if (Number(flip + name.flip) === 270) {
    
                    getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    getCornerBottomRightNeighbour(x, y, page, current, electricLine, true, foundConsumer, pressForce);
                    getCornerBottomLeftNeighbour(x, y, page, current, electricLine, true, foundConsumer, pressForce);
               
                }
    
            } else if (name.name.includes("conductor_lung") || name.name.includes("conductor_scurt")) {

                if (Number(flip + name.flip) === 90 || Number(flip + name.flip) === 270) {

                    if (direction === "top") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "bottom") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
    
                } else {
    
                    if (direction === "left") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "right") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
    
                }
    
            } else if (name.name.includes("conductor_diagonal_45")) {
                
                if (Number(flip + name.flip) === 90 || Number(flip + name.flip) === 270) {
    
                    if (direction === "top-left") getCornerTopLeftNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                    if (direction === "bottom-right") getCornerBottomRightNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                
                } else {
    
                    if (direction === "top-right") getCornerTopRightNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                    if (direction === "bottom-left") getCornerBottomLeftNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
               
                }
    
            } else if (name.name.includes("conductor_diagonal_135")) {
    
                if (Number(flip + name.flip) === 90 || Number(flip + name.flip) === 270) {
    
                    if (direction === "top-right") getCornerTopRightNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                    if (direction === "bottom-left") getCornerBottomLeftNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                
                } else {
    
                    if (direction === "top-left") getCornerTopLeftNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                    if (direction === "bottom-right") getCornerBottomRightNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                
                }
    
            } else if (name.name.includes("conductor_oblic_45")) {
    
                if (Number(flip + name.flip) === 0) {
                    
                    if (direction === "top-right") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "bottom") getCornerBottomLeftNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 90) {
    
                    if (direction === "bottom-right") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "left") getCornerTopLeftNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 180) {
    
                    if (direction === "bottom-left") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "top") getCornerTopRightNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 270) {
    
                    if (direction === "top-left") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "right") getCornerBottomRightNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                
                }
    
            } else if (name.name.includes("conductor_oblic_135")) {
    
                if (Number(flip + name.flip) === 0) {
    
                    if (direction === "top-left") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "bottom") getCornerBottomRightNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 90) {
    
                    if (direction === "top-right") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "left") getCornerBottomLeftNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 180) {
    
                    if (direction === "bottom-right") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "top") getCornerTopLeftNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 270) {
    
                    if (direction === "bottom-left") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "right") getCornerTopRightNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                
                }
    
            } else if (name.name.includes("colt_stanga_sus")) {
    
                if (Number(flip + name.flip) === 0) {
    
                    if (direction === "left") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "top") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 90) {
    
                    if (direction === "right") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "top") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 180) {
    
                    if (direction === "right") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "bottom") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 270) {
    
                    if (direction === "left") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "bottom") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                
                }
    
            } else if (name.name.includes("colt_stanga_jos")) {
    
                if (Number(flip + name.flip) === 0) {
    
                    if (direction === "left") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "bottom") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 90) {
    
                    if (direction === "left") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "top") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 180) {
    
                    if (direction === "right") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "top") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);    
                
                } else if (Number(flip + name.flip) === 270) {
    
                    if (direction === "right") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "bottom") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                
                }
     
            } else if (name.name.includes("colt_dreapta_sus")) {
    
                if (Number(flip + name.flip) === 0) {
    
                    if (direction === "right") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "top") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);    
                
                } else if (Number(flip + name.flip) === 90) {
    
                    if (direction === "right") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "bottom") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
               
                } else if (Number(flip + name.flip) === 180) {
    
                    if (direction === "left") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "bottom") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
    
                } else if (Number(flip + name.flip) === 270) {
    
                    if (direction === "left") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "top") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                
                }
    
            } else if (name.name.includes("colt_dreapta_jos")) {
    
                if (Number(flip + name.flip) === 0) {
    
                    if (direction === "right") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "bottom") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 90) {
                    
                    if (direction === "left") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "bottom") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 180) {
    
                    if (direction === "left") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "top") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                
                } else if (Number(flip + name.flip) === 270) {
    
                    if (direction === "right") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "top") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);    
                
                }
    
            } else if (name.name.includes("derivatie_din_conductor")) {
                
                if (Number(flip + name.flip) === 0) {
    
                    if (direction !== "left") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "right") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "top") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
    
                } else if (Number(flip + name.flip) === 90) {
                    
                    if (direction !== "right") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "top") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "bottom") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
    
                } else if (Number(flip + name.flip) === 180) {
                    
                    if (direction !== "right") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "left") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "bottom") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
    
                } else if (Number(flip + name.flip) === 270) {
    
                    if (direction !== "top") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "left") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "bottom") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
    
                }
    
            } else if (name.name.includes("semi_cruce")) {
    
                if (Number(flip + name.flip) === 0) {
    
                    if (direction !== "top") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "left") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "bottom") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
    
                } else if (Number(flip + name.flip) === 90) {
    
                    if (direction !== "left") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "right") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "top") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
    
                } else if (Number(flip + name.flip) === 180) {
                    
                    if (direction !== "right") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "top") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "bottom") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
    
                } else if (Number(flip + name.flip) === 270) {
                    
                    if (direction !== "right") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "left") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction !== "bottom") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
    
                }
    
            } else if (name.name.includes("cruce")) {
    
                if (direction === "left") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                if (direction === "right") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                if (direction === "top") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                if (direction === "bottom") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                
            } else if (name.name.includes("generator")) {
                if (direction === "bottom") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                if (direction === "top") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                if (direction === "left") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                if (direction === "right") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                if (direction === "top-left") getCornerTopLeftNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                if (direction === "top-right") getCornerTopRightNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                if (direction === "bottom-left") getCornerBottomLeftNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);
                if (direction === "bottom-right") getCornerBottomRightNeighbour(x, y, page, current, electricLine, false, foundConsumer, pressForce);

            } else {
                if (Number(flip + name.flip) === 90 || Number(flip + name.flip) === 270) {
                    
                    if (direction === "left") getLeftNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "right") getRightNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                
                } else {
    
                    if (direction === "bottom") getBottomNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                    if (direction === "top") getTopNeighbour(x, y, page, current, electricLine, foundConsumer, pressForce);
                
                }
            }

    };


    const getElectricity = (pressForce : boolean = true) => {
        // if (pressForce && fromSimulationPressForce) alert(fromSimulationPressForce);
        // if (fromSimulationPressForce) {
        //     fromSimulationPressForce--;
        //     return;
        // }
        
        // electricityArr = {};
        Object.keys(electricityArr).forEach(key => {
            delete electricityArr[key];
        });

        Object.keys(markedMap).forEach(key => {
            delete markedMap[key];
        });

        Object.keys(consumersArr).forEach(key => {
            delete consumersArr[key];
        });

        


        
        // High-tension scheme: arrow glyphs (conductor_lung_sageata) are decorative
        // direction markers, NOT current sources — only started generators feed it.
        const htScheme = document.body.classList.contains("ht-scheme");

        const currentLines = signs.filter((sign : { names: Array<any>, page: number }) => {
            if (sign.page !== Number(page)) return;
            if (htScheme) return false;

            if (sign?.names?.some((name : { name: string }) => name.name.includes("conductor_lung_sageata")) && !sign?.names?.some((name: { name: string }) => name.name.includes("conductor_lung_sageata_final")))
                return true;


            return false;
        });

        const currentLinesBattery = signs.filter((sign : { names: Array<any>, page: number }) => {
            if (sign.page !== Number(page)) return;

            if (sign?.names?.some((name : { name: string }) => name.name.includes("baterie")))
                return true;


            return false;
        });

        const currentLinesGenerator = signs.filter((sign : { names: Array<any>, page: number }) => {
            if (sign.page !== Number(page)) return;

            if (sign?.names?.some((name : { name: string }) => name.name.includes("generator")))
                return true;


            return false;
        });

        // First we need to know the Null electrical line
        // DIAGNOSTIC: guard the whole current propagation so a runaway recursion
        // (e.g. a two-source parallel ring) doesn't blank the scheme silently.
        try {
        currentLines.forEach((line : { x: number, y: number, page: number, flip: number, names: Array<any>, signPosition: string }, lineIdx : number) => {
            const leftElement = signs.find((sign : any) => sign.x === line.x && sign.y === line.y && sign.page === line.page);
            const leftElementName = leftElement?.names?.find((currName : { name: string }) => currName.name.includes("conductor_lung_sageata") && !currName.name.includes("conductor_lung_sageata_final"));
            const currentFlip = (line?.flip + (leftElementName?.flip || 0)) % 360;
            if (leftElement && leftElement?.texts?.some((text : { name: string }) => text?.name?.toLowerCase() === "nul" || text?.name?.toLowerCase() === "n")) {
                getNeighbours(line, 0, true, "N", currentFlip === 0 ? "right" : currentFlip === 90 ? "bottom" : currentFlip === 180 ? "left" : "top", false, pressForce);
            }

        });


        currentLinesBattery.forEach((line : { x: number, y: number, page: number, flip: number, names: Array<any>, signPosition: string }, lineIdx : number) => {
            const leftElement = signs.find((sign : any) => sign.x && sign.y === line.y && sign.page === line.page);
            const leftElementName = leftElement?.names?.find((currName : { name: string }) => currName.name.includes("baterie"));
            if (leftElementName) {
                const currentFlip = (line?.flip + (leftElementName?.flip || 0)) % 360;
         
                getNeighbours(line, 0, true, "N", currentFlip === 0 ? "bottom" : currentFlip === 90 ? "left" : currentFlip === 180 ? "top" : "right", false, pressForce);
            }
            
        });


        currentLines.forEach((line : { x: number, y: number, page: number, flip: number, names: Array<any>, signPosition: string }, lineIdx : number) => {
            const leftElement = signs.find((sign : any) => sign.x === line.x && sign.y === line.y && sign.page === line.page);
            const leftElementName = leftElement?.names?.find((currName : { name: string }) => currName.name.includes("conductor_lung_sageata") && !currName.name.includes("conductor_lung_sageata_final"));
                const currentFlip = (line?.flip + (leftElementName?.flip || 0)) % 360;
                if (!(leftElement && leftElement?.texts?.some((text : { name: string }) => text?.name?.toLowerCase() === "nul" || text?.name?.toLowerCase() === "n"))) {
                    
                    getNeighbours(line, 0, true, lineIdx === 0 ? "L1" : lineIdx === 1 ? "L2" : lineIdx === 2 ? "L3" : "PE", currentFlip === 0 ? "right" : currentFlip === 90 ? "bottom" : currentFlip === 180 ? "left" : "top", false, pressForce);
                }
        });

        currentLinesBattery.forEach((line : { x: number, y: number, page: number, flip: number, names: Array<any>, signPosition: string }, lineIdx : number) => {
            const leftElement = signs.find((sign : any) => sign.x === line.x && sign.y === line.y && sign.page === line.page);
            const leftElementName = leftElement?.names?.find((currName : { name: string }) => currName.name.includes("baterie"));
            if (leftElementName) {
                const currentFlip = (line?.flip + (leftElementName?.flip || 0)) % 360;
         
                getNeighbours(line, 0, true, "L1", currentFlip === 0 ? "top" : currentFlip === 90 ? "right" : currentFlip === 180 ? "bottom" : "left", false, pressForce);
            }
            
        });


        currentLinesGenerator.forEach((line : { x: number, y: number, page: number, flip: number, names: Array<any>, signPosition: string }, lineIdx : number) => {
            const leftElement = signs.find((sign : any) => sign.x === line.x && sign.y === line.y && sign.page === line.page);
            const leftElementName = leftElement?.names?.find((currName : { name: string }) => currName.name.includes("generator"));
            if (leftElementName) {
                const currentFlip = (line?.flip + (leftElementName?.flip || 0)) % 360;

                if (leftElementName.name.includes("inalta")) {
                    // High-tension generator: only an ON ("pornit") generator seeds
                    // current. An OFF generator stays green and feeds nothing.
                    if (!leftElementName.name.includes("pornit")) return;

                    // Single line. Colour order per page:
                    // L1(red) -> L2(orange) -> L3(blue) -> N(green) -> PE(yellow),
                    // then distinct extra colours. A cell text "L1".."PE" forces it.
                    const PHASES = ["L1", "L2", "L3", "N", "PE"];
                    const texts = (leftElement?.texts || []).map((t : { name: string }) => (t?.name || "").toUpperCase());
                    let phaseClass = PHASES.find((p) => texts.includes(p)) || null;

                    if (!phaseClass) {
                        const htGens = currentLinesGenerator.filter((g : any) => g.page === line.page &&
                            signs.find((s : any) => s.x === g.x && s.y === g.y && s.page === g.page)?.names?.some((n : { name: string }) => n.name.includes("generator") && n.name.includes("inalta")));
                        const orderIdx = htGens.findIndex((g : any) => g.x === line.x && g.y === line.y && g.page === line.page);
                        phaseClass = PHASES[orderIdx] || `gen-extra-${(((orderIdx - 5) % 5) + 1)}`;
                    }

                    const dir = currentFlip === 0 ? "top" : currentFlip === 90 ? "right" : currentFlip === 180 ? "bottom" : "left";
                    getNeighbours(line, 0, true, phaseClass, dir, false, pressForce);
                    // Colour the generator symbol itself, same as its line.
                    Object.assign(electricityArr, { [`${line.x}_${line.y}_0_${line.page}_${phaseClass}`]: true });
                } else {
                    // Low-tension 3-line generator: keep the original 3-phase emit.
                    getNeighbours(line, 0, true, "L1", currentFlip === 0 ? "top-left" : currentFlip === 90 ? "top-right" : currentFlip === 180 ? "bottom-right" : "bottom-left", false, pressForce);
                    getNeighbours(line, 0, true, "L2", currentFlip === 0 ? "top" : currentFlip === 90 ? "right" : currentFlip === 180 ? "bottom" : "left", false, pressForce);
                    getNeighbours(line, 0, true, "L3", currentFlip === 0 ? "top-right" : currentFlip === 90 ? "bottom-right" : currentFlip === 180 ? "bottom-left" : "top-left", false, pressForce);
                }
            }
        });
        } catch (e : any) {
            // A runaway/looping propagation (seen with two-source parallels) throws
            // a RangeError; surface it instead of blanking the scheme silently.
            console.warn("getElectricity propagation error:", e?.name || e, e?.message || "");
        }

        // electricityArr / consumersArr are persistent (useMemo) objects mutated in
        // place, so pass a fresh shallow copy — otherwise React sees the same
        // reference and skips the re-render, leaving stale colouring until the next
        // click (the "needs a second click to update" bug).
        setCurrentElectricity({ ...electricityArr });
        setConsumersMap({ ...consumersArr });

    };

    useEffect(() => {
    }, [currentElectricity]);

    
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        if (!signs?.length) return;

        // setThermalRelays([{ relays: [], consumer: { x: -1, y: -1 } }]);
      
        getElectricity(fromSimulationPressForce ? false : true);
        
        if (!simulation) setInitialSigns(signs);
        else {
            if (counter === 0) return setCounter(c => c + 1);

            Object.keys(consumersArr).forEach(key => {
                const value = consumersArr[key];
                    const valueSplit = key.split("_");
                    const x = Number(valueSplit[0]);
                    const y = Number(valueSplit[1]);
                    const nameIdx = Number(valueSplit[2]);
                    const name = findSignObject(x, y, page).names[nameIdx];
    
                    if (!value.isCurrent) {
                        if ((name.name.includes("bobina_releu") || name.name.includes("actionare_electromecanica_cu_temporizare"))) {
                            const currentTexts = findSignObject(x, y)?.texts || [];
                            setTimeout(() => {
                                currentTexts.forEach((text : { name: string }) => {
                                    const sameNameSigns = findSignsObjectByName(text.name);
                                    sameNameSigns.forEach((sameNameSign : { x: number, y: number, names: Array<any> }) => {
                                        let index = 0;
            
            
                                        while (findSignObject(sameNameSign.x + index + 1, sameNameSign.y)?.names?.some((name) => 
                                            (name.name.includes("contact") || name.name.includes('intreruptor')) &&
                                            !name.name.includes("automentinere")
                                        )) index++;
                                        
                                        if (needsBobineChange(sameNameSign.x, sameNameSign.y, sameNameSign.names, initialConsumersArr?.[`${x}_${y}_${nameIdx}_${page}`] === false)) {
                                            for (let i = 0; i <= index; i++) {
                                                simulationPressForce(sameNameSign.x + i, sameNameSign.y, sameNameSign.names, initialConsumersArr?.[`${x}_${y}_${nameIdx}_${page}`] === false);
            
                                            }
                                        }
                                      
                                    });
                               });
                            }, name.name.includes("actionare_electromecanica_cu_temporizare") ? 15000 : 0);
                    
                        }
                    }  
            });
        }
    }, [signs, isCurrentOnScheme]);

    useEffect(() => {
    }, [thermalRelays]);

    useEffect(() => {
        Object.keys(initialConsumersArr).forEach(key => {
            delete initialConsumersArr[key];
        });

        if (!simulation) setInitialSigns(signs);
       
    }, [simulation]);
    
    let currPoint = useMemo(() => 1, []);

    useLayoutEffect(() => {
        setTexts(isSelected?.texts || []);
    }, [isSelected]);

    // Students function to get the defects

    const getSessionData = useCallback(async () => {
        if (isTeacher || !sessionId || category !== "2") return;
        try {

            const options = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            };

            const request = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/session/check-id/${data.userData.type === "teacher" ? data.userData.userId : data.userData.teacherId}/${sessionId}`, options);
            const response = await request.json();
            if (!response.success) return null;
            const results = JSON.parse(response.results.results).find((user: { userId: string }) => user.userId === data.userData.userId);
            results.problemsSolved.forEach((problemSolved: { type: string, name: number }) => {
                changeSolvedSchemeStructure(problemSolved.name, true);
            });

            setProblemsSolved(results.problemsSolved);
            setNotes(results.notes);
            setLogs(results.logs);
            setDefectsResponse(results.currentResults);
            setSessionData(response.results);
            return response.results;

        } catch (e) {
        }

    }, []);


    const [problems, setProblems] = useState<Array<any>>([]);
    const [sessionDataExtracted, setSessionDataExtracted] = useState<boolean>(false);

    useEffect(() => {
        if (!sessionData) return;
        const currProblems = JSON.parse(sessionData?.problems || "[]");
        if (!currProblems) return;

        setProblems(currProblems);
        const newSchemeStructure = schemeStructure.map((dot: { dotNumber: number, line: string }) => {
            const currentProblem = currProblems.find((problem : any) => problem.point === dot.dotNumber);
            if (currentProblem) {
                return {...dot,
                    defect: currentProblem.type,
                    screw: currentProblem.screw === null ? 1 : currentProblem.screw,
                    open: false,
                };
            }

            return dot; 
        });


        changeSchemeStructure(newSchemeStructure);

        setSessionDataExtracted(true);
        
        // problemsRead = true;

    }, [sessionData, location.state]);


    let shortCircuitFinished = useMemo(() => false, []);
    let [initialSchemeStructure, setInitialSchemeStructure] = useState<any>(false);

    useEffect(() => {
        if (isTeacher || !sessionDataExtracted || category !== "2") return;
        if (!initialSchemeStructure) setInitialSchemeStructure(schemeStructure);
        let currentInitialSchemeStructure = initialSchemeStructure ? initialSchemeStructure.map((element : any, idx : number) => {
            return {...element, screw: schemeStructure.find((currElement: any) => currElement.dotNumber === element.dotNumber)?.screw};
        }) : schemeStructure;

        if(!currentInitialSchemeStructure.some((element: { defect: string | null, dotNumber: number, solved: boolean }) => (element.defect === "Scurt circuit" && !element.solved) || problems.some((problem: { type: string | null, point: number }) => problem.type === "Scurt circuit" && problem.point.toString() === element.dotNumber.toString()))) return;
        
        const shortCircuitsElements = currentInitialSchemeStructure.filter((element: { dotNumber: number, defect: string | null, solved: boolean }) => {
            const isShortcircuitDefect : boolean = problems.some((problem: { type: string | null, point: number }) => problem.type === "Scurt circuit" && problem.point === element.dotNumber);
            return ((element.defect === "Scurt circuit" || isShortcircuitDefect) && !schemeStructure?.find((currElement: any) => currElement.dotNumber === element.dotNumber)?.solved);
        });


        if (!shortCircuitsElements?.length) return;

        let copySchemeStructure : any = [], aparitionOfShortCircuit = 0;

        for (let idx = currentInitialSchemeStructure.length - 1; idx >= 0; idx--) {
            if (!(aparitionOfShortCircuit > 0 && currentInitialSchemeStructure[idx].dotNumber === 500)) {
                if (currentInitialSchemeStructure[idx].dotNumber === 500) aparitionOfShortCircuit++;
                copySchemeStructure.unshift(currentInitialSchemeStructure[idx]);
            } 
        }
        
        shortCircuitsElements.forEach(async (element: { dotNumber: number, line:  string | null }) => {

            const dotNumber = element.dotNumber;
            // const line = element.line;
            let currIdx : number = -1;
            const newSchemeStructure = [];

            copySchemeStructure.forEach((element: { dotNumber: number }, idx: number) => dotNumber === element.dotNumber ? currIdx = idx : null);
            
            if (currIdx === -1) return;

            let leftIdx = currIdx - 1, rightIdx = currIdx + 1, initialIdx : number = -1, initialDot : any;
            const initialLine = element.line;
            const totalCells : any = document.querySelectorAll(".cell");

            const initialCell = [...totalCells].find(cell => {
                const dots : any = cell.querySelectorAll(".dot p");
                if ([...dots].some((dot : any) => dot.innerText.toString() === element.dotNumber.toString())) {
                    dots.forEach((dot : any, idx : number) => {
                        if (dot.innerText.toString() === element.dotNumber.toString()) {
                            initialIdx = idx;
                            initialDot = dot.parentElement;
                        } 
                    });                    
                    return true;
                }
                return false;
            });

            while (leftIdx >= 0) {
                const currentDotNumber = copySchemeStructure[leftIdx].dotNumber;

                let currentDotIdx : number = -1, currentDot : any;
                const currentCell = [...totalCells].find(cell => {
                    const dots : any = cell.querySelectorAll(".dot p");
                    if ([...dots].some((dot : any) => dot.innerText.toString() === currentDotNumber.toString())) {
                        dots.forEach((dot : any, idx : number) => {
                            if (dot.innerText.toString() === currentDotNumber.toString()) {
                                currentDotIdx = idx;
                                currentDot = dot.parentElement;
                            } 
                        });
                        return true;
                    }
                    else return false;
                });
                const isConsumer = currentCell && (currentCell?.querySelector("img")?.src?.includes("indicator_luminos") || currentCell?.querySelector("img")?.src?.includes("motor") || currentCell?.querySelector("img")?.src?.includes("bobina_releu"));
                const isOpen = currentCell?.querySelector("img")?.src?.includes("deschis");
                if (isOpen) console.log(currentCell, currentDot?.classList, initialDot?.classList, copySchemeStructure);
                if (copySchemeStructure[leftIdx].screw < 1 || copySchemeStructure[leftIdx].defect === "Lipsa tensiune" || (isOpen && ([...currentDot?.classList]?.some((currClass : string) => currClass.includes("left") || currClass.includes("top"))) && (initialCell !== currentCell || ([...initialDot?.classList]?.some((currClass : string) => currClass.includes("right"))))) || (isConsumer && (([...currentDot?.classList]?.some((currClass : string) => currClass.includes("left") || currClass.includes("top")))) && (initialCell !== currentCell || ([...initialDot?.classList]?.some((currClass : string) => currClass.includes("right"))))) || (initialLine !== copySchemeStructure[leftIdx].line && !isBranchLine(initialLine || "", copySchemeStructure[leftIdx].line))) {
                    break;
                }
                leftIdx--;
            }

            leftIdx++;


            while (rightIdx < copySchemeStructure.length) {
                let currentDotIdx : number = -1, currentDot: any;

                const currentDotNumber = copySchemeStructure[rightIdx].dotNumber;
                const currentCell = [...totalCells].find(cell => {
                    const dots : any = cell.querySelectorAll(".dot p");
                    if ([...dots].some((dot : any) => dot.innerText.toString() === currentDotNumber.toString())) {
                        dots.forEach((dot : any, idx : number) => {
                            if (dot.innerText.toString() === currentDotNumber.toString()) {
                                currentDotIdx = idx;
                                currentDot = dot.parentElement;
                            } 
                        });                        
                        return true;
                    }
                    else return false;
                });
                
                const isConsumer = currentCell && (currentCell?.querySelector("img")?.src?.includes("indicator_luminos") || currentCell?.querySelector("img")?.src?.includes("motor") || currentCell?.querySelector("img")?.src?.includes("bobina_releu"));
                const isOpen = currentCell?.querySelector("img")?.src?.includes("deschis");
                if (copySchemeStructure[rightIdx].screw < 1 || copySchemeStructure[rightIdx].defect === "Lipsa tensiune" || (isOpen && ([...currentDot?.classList]?.some((currClass : string) => currClass.includes("right"))) && !isBranchLine(copySchemeStructure[rightIdx].line, copySchemeStructure?.[rightIdx + 1]?.line) && (initialCell !== currentCell || ([...initialDot?.classList]?.some((currClass : string) => currClass.includes("left") || currClass.includes("top"))))) || (isConsumer && ([...currentDot?.classList]?.some((currClass : string) => currClass.includes("right"))) && (initialCell !== currentCell || ([...initialDot?.classList]?.some((currClass : string) => currClass.includes("left") || currClass.includes("top") )))) || (initialLine !== copySchemeStructure[rightIdx].line && !isBranchLine(initialLine || "", copySchemeStructure[rightIdx].line))) break;
                rightIdx++;
            }

            rightIdx--;

            for (let idx = 0; idx < leftIdx; idx++) {
                if (idx < leftIdx) newSchemeStructure.push(copySchemeStructure[idx]);
            }

            newSchemeStructure.push({
                dotNumber: 500,
                line: "Nul protectie",
                defect: null,
                screw: 1,
                solved: false,
                potential: Number(schemeNumber) === 1 ? 3 : 173,
                open: false
            });


            for (let idx = leftIdx; idx <= rightIdx; idx++) {
                const element = copySchemeStructure[idx];
                newSchemeStructure.push({...element,
                    line: "Nul protectie",
                    potential: Number(schemeNumber) === 1 ? 3 : 173,
                });
            }

            for (let idx = rightIdx + 1; idx < copySchemeStructure.length; idx++) {
                newSchemeStructure.push(copySchemeStructure[idx]);
            }
        
            changeSchemeStructure(newSchemeStructure);

        });

        setTimeout(() => changeOpenStructure(), 200);

        shortCircuitFinished = true;
    }, [sessionDataExtracted, signs, screw, unscrew]);


    const changeOpenStructure = () => {
        if (category !== "2") return;
        schemeStructure.forEach((element: { dotNumber: number }) => element.dotNumber);

        const initialSchemeStructure = schemeStructure.map((element : { dotNumber: number }) => {
            changeOpenSchemeStructure(false, element.dotNumber);
            return {...element, open: false };
        });

        
        let currLine : string | null = null;
    
        setTimeout(() => {
            initialSchemeStructure.forEach((element: { dotNumber: number, line: string, defect: string, solved: boolean }, idx : number) => {
                const currentDot = Array.from(document.querySelectorAll('.dot')).find((dot : any) => Number(dot?.querySelector("p")?.innerText || "-1") === element.dotNumber);
                if (element.dotNumber !== 500 && (!currentDot?.parentElement?.querySelector("img")?.src.includes("deschis") || initialSchemeStructure?.[idx - 1]?.defect !== "Scurt circuit") && !currentDot?.parentElement?.querySelector("img")?.src.includes("actionare_prin_apasare_automentinere") && ((currentDot?.parentElement?.querySelector("img")?.src.includes("deschis") &&  (currentDot.classList.contains("right") || currentDot.classList.contains("max-right")) && (element.defect !== "Scurt circuit" || element.solved || Number(schemeNumber) !== 1)) || currLine === element.line)) {
                    
                    currLine = element.line;
                    changeOpenSchemeStructure(true, element.dotNumber);
                } else if (currLine !== element.line) currLine = null;
            });
        }, 250);
     
    };

    useEffect(() => {
        if (!schemeStructure?.length) return;
        // console.log(schemeStructure);
        changeOpenStructure();
    }, [signs]);

    useEffect(() => {
    }, [schemeStructure]);

    // useEffect(() => {
        
    //     if (playAudio) buzzerSound.play();
    //     else buzzerSound.pause();
    //     buzzerSound.loop = true;
    //     setPlayAudio(currPlay => !currPlay);
    // }, [playAudio]);

    const updateProjectData = async () => {
        try {
            const options = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    grid: isGrid,
                    zoom: Number(document.body.getAttribute("zoom")) || 1,
                    xScroll: scrollX,
                    yScroll: scrollY,
                    userId: data.userData.userId,
                    projectId
                })
            };

            const request = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/project/update-project-data`, options);
            const response = await request.json();
            if (!response.success) console.log(response);
            
        } catch (e) {
        }
    };


    useEffect(() => {
        if (!projectData && projectId?.length) return;
        document.body.classList.add("grid-body");
        document.querySelector("html")?.classList.add("grid-body");
        const scrollVisible = document.body.scrollHeight > document.body.clientHeight || document.body.scrollWidth > document.body.clientWidth;

        if (scrollVisible) document.body.classList.remove("grid-scroll");
        else document.body.classList.add("grid-scroll");
    }, [projectData, projectDataSaved, location]);

    useEffect(() => {
        if (category !== "2" || !sessionId || isTeacher) return;

        (async () => {
            const currSessionData = await getSessionData();
           
            if (!currSessionData) {
                return;
            }

            if (debugSchemeNumber === 1) {
                const currentDots: any = document.querySelectorAll(".dot");
                setSchemeMap([...currentDots].map(dot => {
                    return {
                        point: Number(dot.getAttribute("point")) || 0,
                        sign: dot.parentElement?.querySelector("img")?.src || "",
                        line: Number(dot.getAttribute("point")) <= 18 ? "F" : "N",
                        problem: JSON.parse(currSessionData.problems).find((problem: any) => problem.point === Number(dot.getAttribute("point")))?.type || null
                    }
                }));
            } else if (debugSchemeNumber === 2) {
                
            }
        })();

    }, []);

    const replaceAll = (str : string, find : string, replace : string) => {
        return str.split(find).join(replace);
    };

    const actuationAlgorithm = (currIdx : number, currRowIdx : number, open : boolean | null = null, callback : boolean | null = true) => {
        const currSignObj: any = findSignObject(currIdx, currRowIdx);
        const currSign: any = findSign(currIdx, currRowIdx);
        
        if (!currSign) return;
        const source = currSign?.props?.children?.[0]?.[0]?.props?.src;
        if (!(source.includes("siguranta") && !source.includes("siguranta_automata")) && !(source.includes("/contact_normal_deschis") || source.includes("/contact_normal_inchis"))) return;

        if (source.includes("siguranta") && !source.includes("siguranta_automata")) {
            const isOpen = source.includes("/siguranta_deschisa");
            removeSign(currIdx, currRowIdx, page);
            if (isOpen && (open !== null ? open : true)) addSign(currIdx, currRowIdx, page, SCHEME_ELEMENTS["siguranta"].imageSource, currSignObj.flip, currSignObj.texts, currSignObj.signColor || "#000", currSignObj?.signPosition || "");
            else addSign(currIdx, currRowIdx, page, SCHEME_ELEMENTS["siguranta_deschisa"].imageSource, currSignObj.flip, currSignObj.texts, currSignObj.signColor || "#000", currSignObj?.signPosition || "");
        } else if (source.includes("actionare_prin_apasare") && Number(schemeNumber) !== 1) {
            const isOpen = source.includes("/contact_normal_deschis");
            const newSource = isOpen && (open !== null ? open : true) ? replaceAll(source, "deschis", "inchis").slice(14) : replaceAll(source, "inchis", "deschis").slice(14);
            const realNewSource = newSource.split(".")[0];

            removeSign(currIdx, currRowIdx, page);
            addSign(currIdx, currRowIdx, page, SCHEME_ELEMENTS[realNewSource].imageSource, currSignObj.flip, currSignObj.texts, currSignObj.signColor || "#000", currSignObj?.signPosition || "");
            const selfMaintananceQ1 = findSignObjectByName("C.a. Q1");
            const selfMaintananceQ2 = findSignObjectByName("C.a. Q11.2");
            const interlockQ1 = findSignObjectByName("C.i. Q11.1");
            const interlockQ2 = findSignObjectByName("C.i. Q11.2");
            const BP1 = findSignObjectByName(Number(schemeNumber) === 2 ? "B.p." : "B.p.");


            // const selfMaintananceQ1 = findSignObject(selfMaintananceQ1Obj?.x || (currIdx + 1), selfMaintananceQ1Obj?.y || currRowIdx);

            setTimeout(() => {
                if (Number(schemeNumber) === 1) return;
                if (Number(schemeNumber) === 2 || currSignObj.texts.some((text: { name: string }) => text.name === "S1")) {
                    if ((currSignObj.names.some((name: { name: string }) => name.name.includes("automentinere")) && !selfMaintananceQ1.names.some((name: { name: string }) => name.name.includes("inchis"))) || (currSignObj.texts.some((text: { name: string }) => text.name.includes("B.o.")) && selfMaintananceQ1.names.some(( name: { name: string } ) => name.name.includes("inchis")))) {
                        // console.log("Open")
                        actuationAlgorithm(selfMaintananceQ1?.x || (currIdx + 1), selfMaintananceQ1?.y || currRowIdx);
                        // if (callback) setTimeout(() => actuationAlgorithm(BP1?.x || 0, BP1?.y || 0, false, false), 2000);

                        if (interlockQ1?.x !== null) actuationAlgorithm(interlockQ1?.x || (currIdx + 1), interlockQ1?.y || currRowIdx);

                        // For the three parallel contacts
                            // actuationAlgorithm(4, 7);
                            // actuationAlgorithm(5, 7);
                            // actuationAlgorithm(6, 7);
                    }
                }

                if (currSignObj.texts.some((text: { name: string }) => text.name === "S2")) {
                    if ((currSignObj.names.some((name: { name: string } ) => name.name.includes("automentinere")) && !selfMaintananceQ2.names.some((name: { name: string }) => name.name.includes("inchis"))) || (currSignObj.texts.some((text: { name: string }) => text.name.includes("B.o.")) && selfMaintananceQ2.names.some((name: { name: string }) => name.name.includes("inchis")))) {

                        actuationAlgorithm(selfMaintananceQ2?.x || (currIdx + 1), selfMaintananceQ2?.y || currRowIdx);
                        if (interlockQ2?.x !== null) actuationAlgorithm(interlockQ2?.x || (currIdx + 1), interlockQ2?.y || currRowIdx);

                        // For the three parallel contacts
                            // actuationAlgorithm(4, 7);
                            // actuationAlgorithm(5, 7);
                            // actuationAlgorithm(6, 7);
                    }
                }
               
            }, 500);

            setTimeout(() => {
                removeSign(currIdx, currRowIdx, page);
                addSign(currIdx, currRowIdx, page, currSignObj.names, currSignObj.flip, currSignObj.texts, currSignObj.signColor || "#000", currSignObj?.signPosition || "");
            }, 650);

        }
        else if (source.includes("/contact_normal_deschis") || source.includes("/contact_normal_inchis")) {
            const isOpen = source.includes("/contact_normal_deschis");
            const newSource = open === true ? replaceAll(source, "inchis", "deschis").slice(14) : open === false ? replaceAll(source, "deschis", "inchis").slice(14) : isOpen ? replaceAll(source, "deschis", "inchis").slice(14) : replaceAll(source, "inchis", "deschis").slice(14);
            
            removeSign(currIdx, currRowIdx, page);
            addSign(currIdx, currRowIdx, page, SCHEME_ELEMENTS[newSource.split(".")[0]].imageSource, currSignObj.flip, currSignObj.texts, currSignObj.signColor || "#000", currSignObj?.signPosition || "");
        }
 
        setTimeout(() => document.querySelectorAll(".cell").forEach((cell: any) => cell.classList.remove("selected")), 200);
    };

    useEffect(() => {
        const projects = data.userData.projects;
        if (!projects || !projects.length) return;
        const currProject = projects.find((project : { projectId: string }) => projectId === project.projectId);
        if (currProject) setProjectData(currProject);
    }, []);


    useEffect(() => {
        if (!projectData) return;
   
        document.body.setAttribute("zoom", projectData?.zoom || 1);
        setTimeout(() => window.scrollTo({
            top: projectData?.yScroll || 0,
            left: projectData?.xScroll || 0,
            behavior: 'smooth'
        }), 0);

        // setScrollX(projectData?.xScroll || 0);
        // setScrollY(projectData?.yScroll || 0);
        // if (Number(projectData?.grid) == 0) changeGridActivated();
        setProjectDataSaved(true);
    }, [projectData]);

    useEffect(() => {
        if (!problems?.length) return;
        const timer = setTimeout(() => {
            const S1 = findSignObjectByName("F1");
            const S2 = findSignObjectByName("F2");
            const S3 = findSignObjectByName("F3");

            const S4 = findSignObjectByName("F4");
            const S5 = findSignObjectByName("F5");
            const contact = findSignObjectByName("I");

            if (Number(schemeNumber) === 1) {
         

                const firstShortcircuitDefect = problems.find((element: { point: number, type: string | null }) => element.point >= 3 && element.point <= 18 && element.type === "Scurt circuit")?.point || -1;
                
                if (schemeStructure.some((element : { dotNumber: number, screw: number }) => {
                    // if (element.dotNumber < 3 || element.dotNumber > 18) return;
                    return element.dotNumber < firstShortcircuitDefect && element.screw <= .25;
                })) return;
    
                if (S1 && problems.some((element: { point: number, type: string | null }) => element.point >= 3 && element.point <= 10 && element.type === "Scurt circuit")) {
                    actuationAlgorithm(S1.x, S1.y, true);
                } else if (S1 && problems.some((element: { point: number, type: string | null }) => element.point >= 11 && element.point <= 18 && element.type === "Scurt circuit")) {
                    if (contact.names.some((name : { name: string }) => name.name.includes("inchis"))) {
                        actuationAlgorithm(S1.x, S1.y, true);
                    }
                }
    
                // if (schemeStructure.some((element: { dotNumber: number, defect: string | null }) => element.dotNumber >= 19 && element.dotNumber <= 32 && element.defect === "Scurt circuit")) {
                    
                // }
    
    
            } else if (Number(schemeNumber) === 2) {
                const contactS1 = findSignObjectByName("Q1");
                const contactS3 = findSignObjectByName("Q1S3");
                const contactS5 = findSignObjectByName("C.a. Q1");
                const firstTotalLinePoints = [8, 9, 10, 26, 27, 28, 29, 52, 53, 54, 55, 70, 71];
                const firstRestLinePoints = [28, 29, 52, 53, 54, 55, 70, 71];
                const secondTotalLinePoints = [13, 14, 31, 32, 33, 34, 57, 58, 59, 60, 69, 70];
                const secondRestLinePoints = [33, 34, 57, 58, 59, 60, 69, 70];
                const thirdTotalLinePoints = [16, 17, 34, 35, 36, 37, 60, 61, 62, 63, 72, 73];
                const thirdRestLinePoints = [36, 37, 60, 61, 62, 63, 72, 73];
                const fifthTotalLinePoints = [24, 25, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 64, 65, 66, 67, 74, 75];
                const fifthRestLinePoints = [44, 45,  47, 49, 51, 64, 65, 66, 67, 74, 75];

                let firstShortcircuitDefectIdx : number = -1, thirdShortcircuitDefectIdx : number = -1, fifthShortcircuitDefectIdx : number = -1;
                const firstShortcircuitDefect = problems.find((element: { point: number, type: string | null }, idx: number) => {
                    if (firstTotalLinePoints.includes(element.point) && element.type === "Scurt circuit") {
                        firstShortcircuitDefectIdx = idx;
                        return true;
                    }

                    return false;
                });

                const thirdShortcircuitDefect = problems.find((element: { point: number, type: string | null }, idx: number) => {
                    if (thirdTotalLinePoints.includes(element.point) && element.type === "Scurt circuit") {
                        thirdShortcircuitDefectIdx = idx;
                        return true;
                    }

                    return false;
                });

                const fifthShortcircuitDefect = problems.find((element: { point: number, type: string | null }, idx: number) => {
                    if (fifthTotalLinePoints.includes(element.point) && element.type === "Scurt circuit") {
                        fifthShortcircuitDefectIdx = idx;
                        return true;
                    }
                    return false;
                });


                // For S1

                if (!schemeStructure.some((element : { dotNumber: number, screw: number, line: string }, idx : number) => {
                    // if (element.dotNumber < 3 || element.dotNumber > 18) return;
                    return idx < firstShortcircuitDefectIdx && element.screw <= .25 && firstShortcircuitDefect.line === element.line;
                })) {
                    if (problems.some((element: { point: number, type: string | null }) => !firstRestLinePoints.includes(element.point) && firstTotalLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber.toString() === element.point.toString()).solved)) {

                        actuationAlgorithm(S1.x, S1.y, true);
                    } else if (problems.some((element: { point: number, type: string | null }) => firstRestLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber === element.point).solved)) {
                        if (contactS1.names.some((name : { name: string }) => name.name.includes("inchis"))) {
                            actuationAlgorithm(S1.x, S1.y, true);
                        }
                    }
                }


                // For S3
                if (!schemeStructure.some((element : { dotNumber: number, screw: number, line: string }, idx: number) => {
                    // if (element.dotNumber < 3 || element.dotNumber > 18) return;
                    return idx < thirdShortcircuitDefectIdx && element.screw <= .25 && thirdShortcircuitDefect.line === element.line;
                })) {

                    if (problems.some((element: { point: number, type: string | null }) => !thirdRestLinePoints.includes(element.point) && thirdTotalLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber.toString() === element.point.toString()).solved)) {
                        actuationAlgorithm(S3.x, S3.y, true);
                    } else if (problems.some((element: { point: number, type: string | null }) => thirdRestLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber === element.point).solved)) {
                        if (contactS3.names.some((name : { name: string }) => name.name.includes("inchis"))) {
                            actuationAlgorithm(S3.x, S3.y, true);
                        }
                    }
                }


                // For S5
                if (!schemeStructure.some((element : { dotNumber: number, screw: number, line: string }, idx: number) => {
                    return idx < fifthShortcircuitDefectIdx && element.screw <= .25 && fifthShortcircuitDefect.line === element.line;
                })) {
                    if (problems.some((element: { point: number, type: string | null }) => !fifthRestLinePoints.includes(element.point) && fifthTotalLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber.toString() === element.point.toString()).solved)) {
                        
                        actuationAlgorithm(S5.x, S5.y, true);
                    } else if (problems.some((element: { point: number, type: string | null }) => fifthRestLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber === element.point).solved)) {
                        if (contactS5.names.some((name : { name: string }) => name.name.includes("inchis"))) {
                            actuationAlgorithm(S5.x, S5.y, true);
                        }
                    }
                }
            } else if (Number(schemeNumber) === 3) {
                
                const secondContactS1 = findSignObjectByName("Q11.2");
                const secondContactS3 = findSignObjectByName("Q11.2S3");
                const selfMaintananceQ1 = findSignObjectByName("C.i. Q11.1");
                const selfMaintananceQ2 = findSignObjectByName("C.i. Q11.2");

                let currentSecondContact : any, currentSecondContactS3;
                document.querySelectorAll(".cell").forEach((cell: any) => Number(cell.getAttribute("column")) === secondContactS1?.y && Number(cell.getAttribute("row")) === secondContactS1?.x ? currentSecondContact = cell?.querySelector("img")?.src?.includes("deschis") : null);
                // document.querySelectorAll(".cell").forEach((cell: any) => Number(cell.getAttribute("column")) === secondContactS3?.y && Number(cell.getAttribute("row")) === secondContactS3?.x ? currentSecondContactS3 = cell?.querySelector("img")?.src?.includes("deschis") : null);

                const contactS1 = currentSecondContact ? findSignObjectByName("Q11.1") : secondContactS1;
                const contactS3 = currentSecondContact ? findSignObjectByName("Q11.1S3") : secondContactS3;

                const contactS5 = findSignObjectByName("C.a. Q1");

                const firstTotalLinePoints = currentSecondContact ? [6, 7, 8, 9, 50, 51, 30, 31, 32, 33, 44, 45, 82, 83, 84, 85, 104, 105] : [6, 7, 8, 9, 30, 31, 50, 51, 52, 53, 41, 40, 90, 91, 92, 93, 106, 107];
                const firstRestLinePoints = currentSecondContact ?  [32, 33, 44, 45, 82, 83, 84, 85, 104, 105] : [52, 53, 41, 40, 90, 91, 92, 93, 106, 107];
                const secondTotalLinePoints = [10, 11, 12, 13, 46, 47, 34, 35, 36, 37, 48, 49, 86, 87, 88, 89, 102, 103];
                const secondRestLinePoints = [36, 37, 48, 49, 86, 87, 88, 89, 102, 103];
                const thirdTotalLinePoints = currentSecondContact ? [14, 15, 16, 17, 38, 39, 42, 43, 40, 41, 52, 53, 90, 91, 92, 93, 106, 107] : [14, 15, 16, 17, 38, 39, 42, 43, 44, 45, 32, 33, 82, 83, 84, 85, 104, 105];
                const thirdRestLinePoints = currentSecondContact ? [40, 41, 52, 53, 90, 91, 92, 93, 106, 107] : [44, 45, 32, 33, 82, 83, 84, 85, 104, 105];
                // const fifthTotalLinePoints = [24, 25, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 64, 65, 66, 67, 74, 75];
                // const fifthRestLinePoints = [44, 45,  47, 49, 51, 64, 65, 66, 67, 74, 75];

                let firstShortcircuitDefectIdx : number = -1, thirdShortcircuitDefectIdx : number = -1, fifthShortcircuitDefectIdx : number = -1;
                const firstShortcircuitDefect = problems.find((element: { point: number, type: string | null }, idx: number) => {
                    if (firstTotalLinePoints.includes(element.point) && element.type === "Scurt circuit") {
                        firstShortcircuitDefectIdx = idx;
                        return true;
                    }

                    return false;
                });

                const thirdShortcircuitDefect = problems.find((element: { point: number, type: string | null }, idx: number) => {
                    if (thirdTotalLinePoints.includes(element.point) && element.type === "Scurt circuit") {
                        thirdShortcircuitDefectIdx = idx;
                        return true;
                    }

                    return false;
                });

                // const fifthShortcircuitDefect = problems.find((element: { point: number, type: string | null }, idx: number) => {
                //     if (fifthTotalLinePoints.includes(element.point) && element.type === "Scurt circuit") {
                //         fifthShortcircuitDefectIdx = idx;
                //         return true;
                //     }
                //     return false;
                // });


                // For S1

                if (!schemeStructure.some((element : { dotNumber: number, screw: number, line: string }, idx : number) => {
                    // if (element.dotNumber < 3 || element.dotNumber > 18) return;
                    return idx < firstShortcircuitDefectIdx && element.screw <= .25 && firstShortcircuitDefect.line === element.line;
                })) {
                    if (problems.some((element: { point: number, type: string | null }) => !firstRestLinePoints.includes(element.point) && firstTotalLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber.toString() === element.point.toString()).solved)) {
                        actuationAlgorithm(S1.x, S1.y, true);
                    } else if (problems.some((element: { point: number, type: string | null }) => firstRestLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber === element.point).solved)) {
                        let currentContact;
                        document.querySelectorAll(".cell").forEach((cell: any) => Number(cell.getAttribute("column")) === contactS1?.y && Number(cell.getAttribute("row")) === contactS1?.x ? currentContact = cell?.querySelector("img")?.src?.includes("inchis") : null);

                        if (currentContact) {
                            actuationAlgorithm(S1.x, S1.y, true);
                        }
                    }
                }


                // For S3
                if (!schemeStructure.some((element : { dotNumber: number, screw: number, line: string }, idx: number) => {
                    // if (element.dotNumber < 3 || element.dotNumber > 18) return;
                    return idx < thirdShortcircuitDefectIdx && element.screw <= .25 && thirdShortcircuitDefect.line === element.line;
                })) {
                    if (problems.some((element: { point: number, type: string | null }) => !thirdRestLinePoints.includes(element.point) && thirdTotalLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber.toString() === element.point.toString()).solved)) {
                        actuationAlgorithm(S3.x, S3.y, true);
                    } else if (problems.some((element: { point: number, type: string | null }) => thirdRestLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber === element.point).solved)) {
                        let currentContact;
                        document.querySelectorAll(".cell").forEach((cell: any) => Number(cell.getAttribute("column")) === contactS3?.y && Number(cell.getAttribute("row")) === contactS3?.x ? currentContact = cell?.querySelector("img")?.src?.includes("inchis") : null);

                        if (currentContact) {
                            actuationAlgorithm(S3.x, S3.y, true);
                        }
                    }
                }


                // For S5
                // if (!schemeStructure.some((element : { dotNumber: number, screw: number, line: string }, idx: number) => {
                //     return idx < fifthShortcircuitDefectIdx && element.screw <= .25 && fifthShortcircuitDefect.line === element.line;
                // })) {
                //     if (problems.some((element: { point: number, type: string | null }) => !fifthRestLinePoints.includes(element.point) && fifthTotalLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber.toString() === element.point.toString()).solved)) {
                        
                //         actuationAlgorithm(S5.x, S5.y, false);
                //     } else if (problems.some((element: { point: number, type: string | null }) => fifthRestLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber === element.point).solved)) {
                //         if (foundSignObject?.name?.includes("actionare_prin_apasare_automentinere")) {
                //             setTimeout(() => {
                //             // console.log("PASS 2");

                //                 let currentContact;
                //                 document.querySelectorAll(".cell").forEach((cell: any) => Number(cell.getAttribute("column")) === contactS5?.y && Number(cell.getAttribute("row")) === contactS5?.x ? currentContact = cell?.querySelector("img")?.src?.includes("inchis") : null);
                //                 if (currentContact) {
                //                     actuationAlgorithm(S5.x, S5.y, false);
                //                     setTimeout(() => actuationAlgorithm(currentRT?.x, currentRT?.y, true), 4000);
                //                     setTimeout(() => actuationAlgorithm(currentRT?.x, currentRT?.y, false), 5000);
                //                 }
                //             }, 1000);
                            
                //         }
                            
                        
                //     }
                // }
            
            }
        }, 250);

        return () => clearTimeout(timer);
    
    }, [problems]);

    // useLayoutEffect(() => {
    //     if (projectName === "Circuit simplu") {
    //         const S1 = findSignObjectByName("F1");
    //         const S2 = findSignObjectByName("F2");
    //         const contact = findSignObjectByName("I");

    //         const firstShortcircuitDefect = problems.find((element: { point: number, type: string | null }) => element.point >= 3 && element.point <= 18 && element.type === "Scurt circuit")?.point || -1;
            
    //         if (schemeStructure.some((element : { dotNumber: number, screw: number }) => {
    //             // if (element.dotNumber < 3 || element.dotNumber > 18) return;
    //             return element.dotNumber < firstShortcircuitDefect && element.screw <= .25;
    //         })) return;

    //         console.log(problems, S1, contact);
    //         if (problems.some((element: { point: number, type: string | null }) => element.point >= 3 && element.point <= 10 && element.type === "Scurt circuit")) {
    //             actuationAlgorithm(S1.x, S1.y, true);
    //         } else if (problems.some((element: { point: number, type: string | null }) => element.point >= 11 && element.point <= 18 && element.type === "Scurt circuit")) {
    //             if (contact.name.includes("inchis")) {
    //                 actuationAlgorithm(S1.x, S1.y, true);
    //             }
    //         }

    //         // if (schemeStructure.some((element: { dotNumber: number, defect: string | null }) => element.dotNumber >= 19 && element.dotNumber <= 32 && element.defect === "Scurt circuit")) {
                
    //         // }

    //     }
    // }, [schemeStructure]);

    // Disable right click

    // useEffect(() => {
    //     if (!pageRef || !pageRef.current) return;
    //     pageRef.current.addEventListener('contextmenu', event => event.preventDefault());
    // }, [pageRef]);


    const currentSelectedCell = useStore((state: any) => state.selectedCell);
    const removeSelectedCell = useStore((state: any) => state.removeSelectedCell);

    useEffect(() => {
        document.querySelectorAll(".cell").forEach((cell: any) => cell.classList.remove("selected"));
    }, []);

    
    useEffect(() => {
        zoomFunc(Number(document.body.getAttribute("zoom")) || 1, isGrid, format);
    }, [signs, isGrid, location]);

    useLayoutEffect(() => {
        zoomFunc(Number(document.body.getAttribute("zoom")) || 1, isGrid, format);
    }, [projectData, projectDataSaved]);

    useLayoutEffect(() => {
        if (!projectData) return;
        (async () => {
            await updateProjectData();
        })();

    }, [signs, isGrid, scrollX, scrollY]);

   

    const [times, setTimes] = useState(0);


    // useEffect(() => {
    //     if (category !== "0") return;
    //     console.log(isGrid);
    //     if (window.history.state.isGrid === false && isGrid) {
    //         changeGridActivated(false);
    //     } else if (window.history.state.isGrid !== false && !isGrid) changeGridActivated(true);


   
    //     // window.history.replce
    // }, []);

    useEffect(() => {
        if (category !== "0") return;
        if (times <= 2) {
            setTimes(curr => curr + 1);
            return;
        }

        (async () => {
            const currentProject = data.userData.projects.find((project: { projectId: string }) => project.projectId === projectId);
            const options = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    userId: data.userData.userId,
                    projectId,
                    historic: JSON.parse(currentProject.historic) || [],
                    signs,
                    projectName: currentProjectName
                })
            };
            try {
                const request = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/project/update-project`, options);
                const response = await request.json();
                if (!response.success) console.log(response);
            } catch (e) {
            }
        })();
    }, [signs, currentProjectName]);

    const isInViewPort = (element: HTMLDivElement) => {
        const rect = element.getBoundingClientRect();

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    const gotoFirstEmptyCell = (): ({ x: number, y: number, page: number } | null) => {
        if (!cellRef.current) return null;
        for (let idx = 0; idx < cellRef.current.length; idx++) {
            const cell = cellRef.current[idx];
            if (cell) {
                if (isInViewPort(cell) && !cell?.firstChild) return {
                    x: idx % COLUMNS,
                    y: Math.floor(idx / COLUMNS),
                    page: page
                }
            }
        }


        for (let idx = 0; idx < cellRef.current.length; idx++) {
            const cell = cellRef.current[idx];

            if (cell) {
                if (!cell?.firstChild) return {
                    x: idx % COLUMNS,
                    y: Math.floor(idx / COLUMNS),
                    page: page
                }
            }
        }

        return null;
    };

    const getCenterCell = () => {

    };

    const initiateElement = useCallback((event: React.MouseEvent<HTMLDivElement, MouseEvent>, element: HTMLDivElement | null, row: number, col: number) => {
        if (dragElement || isImageLocked || multipleSelectedCells) return;


        const foundSign = signs.find((sign: any) => sign.x === row && sign.y === col && sign.page === page);
        if (foundSign && foundSign?.isLockedSign) return;

        setDragElement(element);
        setDragElementRow(row);
        setDragElementColumn(col);
        // setDragElementX(event.clientX);
        // setDragElementY(event.clientY);

        if (element?.firstChild) {
            const elementImages = element.querySelectorAll("img");
            elementImages.forEach(elementImage => {
                if (elementImage) {
                    elementImage.style.position = 'absolute';
                    element.style.position = 'initial';
                    // elementImage.style.top = `${event.clientY - (elementImage.clientHeight / 2) + window.scrollY}px`;
                    // elementImage.style.left = `${event.clientX - (elementImage.clientWidth / 2) + window.scrollX}px`;
                }
            });
        }

        // requestAnimationFrame(() => moveElement(event));
    }, [signs, dragElement, isImageLocked]);

    const touchInitiateElement = (event: React.TouchEvent<HTMLDivElement>, element: HTMLDivElement | null, row: number, col: number) => {
        if (dragElement || event.touches.length > 1 || isImageLocked || multipleSelectedCells) return;
        const foundSign = signs.find((sign: any) => sign.x === row && sign.y === col && sign.page === page);
        if (foundSign && foundSign?.isLockedSign) return;
        setDragElementRow(row);
        setDragElementColumn(col);
        setDragElement(element);
        // setDragElementX(event.touches[0].clientX);
        // setDragElementY(event.touches[0].clientY);
        if (element?.firstChild) {
            const elementImages = element.querySelectorAll("img");
            elementImages.forEach(elementImage => {
                if (elementImage) {
                    elementImage.style.position = 'absolute';
                    element.style.position = 'initial';
                    document.body.style.overflow = 'hidden';
                    // elementImage.style.top = `${event.clientY - (elementImage.clientHeight / 2) + window.scrollY}px`;
                    // elementImage.style.left = `${event.clientX - (elementImage.clientWidth / 2) + window.scrollX}px`;
                }
            });
          
        }
    };

    const moveElement = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
        if (!dragElement || !pageRef?.current) return;

        event.preventDefault();

        const elementImages = dragElement.querySelectorAll("img");
        elementImages.forEach((elementImage) => {

            if (elementImage) {
                elementImage.style.top = `${event.clientY - ((elementImage.clientHeight)) - (pageRef.current?.getBoundingClientRect()?.top || 0)}px`;
                elementImage.style.left = `${event.clientX - ((elementImage.clientWidth)) - (pageRef.current?.getBoundingClientRect()?.left || 0)}px`;
            }
    
            // setDragElementX(event.clientX);
            // setDragElementY(event.clientY);
    
        });

        if (cellRef?.current) {
            const cellElement = cellRef?.current?.find((cell, idx) => {
                if (cell?.getBoundingClientRect())
                    return cell?.getBoundingClientRect()?.top <= event.clientY && cell?.getBoundingClientRect()?.left <= event.clientX && cell?.getBoundingClientRect()?.right >= event.clientX && cell?.getBoundingClientRect()?.bottom >= event.clientY;
                return false;
            });

            if (cellElement && lastDrag !== cellElement) setLastDrag(cellElement);
        }    
        
        // requestAnimationFrame(() => moveElement(event));
    }, [dragElement, isImageLocked, pageRef, cellRef, lastDrag]);

    const touchMoveElement = useCallback((event: React.TouchEvent<HTMLDivElement>) => {
        if (!dragElement || event.touches.length >= 2 || !pageRef.current) return;
        const elementImages = dragElement.querySelectorAll("img");
        
        elementImages.forEach(elementImage => {
            if (elementImage) {
                elementImage.style.top = `${event.touches[0].clientY - ((elementImage.clientHeight)) + window.scrollY}px`;
                elementImage.style.left = `${event.touches[0].clientX - ((elementImage.clientWidth) + (pageRef.current?.getBoundingClientRect()?.left || 0))}px`;
            }
        });

        
        // setDragElementX(event.touches[0].clientX);
        // setDragElementY(event.touches[0].clientY);

        if (cellRef?.current) {
            const cellElement = cellRef?.current?.find((cell, idx) => {
                if (cell?.getBoundingClientRect())
                    return cell?.getBoundingClientRect()?.top <= event.touches[0].clientY && cell?.getBoundingClientRect()?.left <= event.touches[0].clientX && cell?.getBoundingClientRect()?.right >= event.touches[0].clientX && cell?.getBoundingClientRect()?.bottom >= event.touches[0].clientY;
                return false;
            });
            if (cellElement) setLastDrag(cellElement);
        }
    }, [dragElement, isImageLocked, cellRef, pageRef]);

    const stopElement = useCallback((touchElement = false) => {
        if (!dragElement || !lastDrag) return;
        const elementImages = dragElement.querySelectorAll("img");
        dragElement?.classList?.remove("selected");

        elementImages.forEach((elementImage) => {
            if (touchElement) document.body.style.overflow = 'initial';

            if (elementImage) {
                // elementImage.style.position = 'initial';
                elementImage.style.top = 'initial';
                elementImage.style.left = 'initial';
                dragElement.style.position = 'relative';
            }
        });


        // if (lastDrag?.firstChild) {
        //     setLastDrag(null);
        //     setDragElement(null);
        //     // setDragElementX(0);
        //     // setDragElementY(0);
        //     return;
        // }

        const oldSignObject = findSignObject(dragElementRow || 0, dragElementColumn || 0);
        const oldImages = oldSignObject?.names;

        removeSign(dragElementRow, dragElementColumn, page);
        addSign(Number(lastDrag.getAttribute("row")), Number(lastDrag.getAttribute("column")), page, oldImages, oldSignObject?.flip, oldSignObject?.texts);

        // changeSignPosition(dragElementRow, dragElementColumn, page, Number(lastDrag.getAttribute("row")), Number(lastDrag.getAttribute("column")), page);


        setLastDrag(null);
        setDragElement(null);
        // setDragElementX(0);
        // setDragElementY(0);
        setDragElementRow(null);
        setDragElementColumn(null);
    }, [dragElement, lastDrag, dragElementRow, dragElementColumn]);

       // Throttle function 

 
    const handleDotTouchStart = (e: any, currentDot: HTMLDivElement) => {
        const dots = Array.from(document.querySelectorAll(".dot"));
        if (!dots || !dots.length) return;
        const currentActiveDots : any = dots.filter((currentDot: any) => currentDot.classList.contains("activated"));
        
        if (dots.filter((currentDot: any) => currentDot.classList.contains("activated")).length >= 2) {
            currentActiveDots.forEach((activeDot: any) => {
                activeDot.classList.remove("sync-activated");
                activeDot.classList.remove("activated");
            });
            setDefectsButton(true);
            setActiveDots(null);
            currentDot.classList.add("activated");
            return;
        }

        if (dots.filter((currentDot: any) => currentDot.classList.contains("activated")).length >= 2) return;
        

        currentDot.classList.add("activated");

        const currentActiveDotsNew : any = dots.filter((currentDot: any) => currentDot.classList.contains("activated"));

        // document.body.style.overflow = 'hidden';
        if (currentActiveDotsNew.length === 2 && currentActiveDotsNew) {
            currentActiveDotsNew.forEach((activeDot: any) => activeDot.classList.add("sync-activated"));
            setActiveDots(currentActiveDotsNew);
            setDefectsButton(false);
        } else setDefectsButton(true);


        if (currentActiveDots.length === 1) {
            const problemButton : any = document.querySelector(".problem-button");
            const screwButton : any = document.querySelector(".screw-button");
            
            const currX = e.clientX;
            const currY = e.clientY;

            // if (screwButton) {
            //     screwButton.style.transition = 'none';
            //     screwButton.style.left = `${currX}px`;
            //     screwButton.style.top = `${currY}px`;
            //     // screwButton.style.transition = `all 350ms ease-in-out`;


            //     setTimeout(() => {
            //         screwButton.style.transition = `all 350ms ease-in-out`;
            //         screwButton.style.opacity = 1;
            //         screwButton.style.left = '100px';
            //         screwButton.style.top = '25px';
            //         // screwButton.style.transition = 'none';
            //     }, 350);
            // }

            // if (problemButton) {
            //     screwButton.style.transition = `all 350ms ease-in-out`;
            //     problemButton.style.left = `${currX}px`;
            //     problemButton.style.top = `${currY}px`;

            //     setTimeout(() => {
            //         problemButton.style.transition = `all 350ms ease-in-out`;
            //         problemButton.style.left = 'initial';
            //         problemButton.style.right = '20px';
            //         problemButton.style.top = '20px';
            //         problemButton.style.transition = 'none';
            //     }, 250);
            // }
        }
     
    };

    const handleDotTouchEnd = (e: any, currentDot: HTMLDivElement) => {
        const dots = Array.from(document.querySelectorAll(".dot"));

        const currentActiveDots = dots.filter((currentDot: any) => currentDot.classList.contains("activated"));
        if (currentActiveDots.length === 2) {
            currentActiveDots.forEach((activeDot: any) => {
                // activeDot.classList.remove("activated");
                activeDot.classList.remove("sync-activated");
            });
            setActiveDots(null);
        }

        setDefectsButton(false);

        currentDot.classList.remove("activated");
        const newActiveDots = dots.filter((currentDot: any) => currentDot.classList.contains("activated"));

        if (newActiveDots.length === 0)
            document.body.style.overflow = 'scroll';

    };

    
    let lastX = useMemo(() => -1, []);
    let lastY = useMemo(() => -1, []);
    let inHere = useMemo(() => false, []);

    const screwDot = (dotNumber : number, dotElement : any) => {
        const element = schemeStructure.find((element: { dotNumber: number, screw: number }) => element.dotNumber === Number(dotNumber));
        if (!element) return;
        if (element?.screw === 1) return;
        changeScrewSchemeStructure(dotNumber, element.screw + .25);

        const screwLine = dotElement.querySelector(".screw-driver-container .screw-line");
        const newScrew = element.screw + .25;
        screwLine.style.transform = `rotateZ(${newScrew === .25 ? 90 : newScrew === .5 ? 180 : newScrew === .75 ? 270 : 360}deg) translateY(-50%)`;

    };


    let notFinished = useMemo(() => false, []);

    useEffect(() => {
        if (category.toString() !== "2") return;
        const timer = setTimeout(() => {
            let dotPoint : number = 1;
            document.querySelectorAll(".dot").forEach((dot : any, idx: number) => {
                const currDotNumber = Number(dot.querySelector("p")?.innerText);
                if (currDotNumber !== 500) {
                    const paragraph = dot.querySelector("p");
                    if ((Number(schemeNumber) === 2 && idx === Number(process.env.REACT_APP_SECOND_SCHEME_PROTECTION_POINT)) || (Number(schemeNumber) === 3 && idx === Number(process.env.REACT_APP_THIRD_SCHEME_PROTECTION_POINT))) paragraph.innerText = '500';
                    else {
                        paragraph.innerText = dotPoint.toString();
                        dotPoint++;
                    }
                 
                }
            });
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const getClosestElement = (xPos: number, yPos: number, elements : any) => {

        // Initialize variables to keep track of the closest element and its distance
        let closestElement = null;
        let closestDistance = Number.MAX_SAFE_INTEGER;
    
        // Loop through the elements and calculate the distance from the click coordinates
        
        elements.forEach((element : any) => {
          const rect = element.getBoundingClientRect();
          const elementX = rect.left + rect.width / 2;
          const elementY = rect.top + rect.height / 2;
    
          const distance = Math.sqrt(
            Math.pow(elementX - xPos, 2) + Math.pow(elementY - yPos, 2)
          );
    
          if (distance < closestDistance) {
            closestDistance = distance;
            closestElement = element;
          }
        });
        
        if (closestDistance > Math.max(window.innerWidth, window.innerHeight) / 10) return null;

        return closestElement;
    };

    const getClosestElementIdx = (xPos: number, yPos: number, elements : any) => {

        // Initialize variables to keep track of the closest element and its distance
        let closestElement = null;
        let closestDistance = Number.MAX_SAFE_INTEGER;
    
        // Loop through the elements and calculate the distance from the click coordinates
        elements.forEach((element : any, idx: number) => {
          const rect = element.getBoundingClientRect();
          const elementX = rect.left + window.scrollX + rect.width / 2;
          const elementY = rect.top + window.scrollY + rect.height / 2;
    
          const distance = Math.sqrt(
            Math.pow(elementX - xPos, 2) + Math.pow(elementY - yPos, 2)
          );
    
          if (distance < closestDistance) {
            closestDistance = distance;
            closestElement = idx;
          }
        });
        
        return closestElement;
    };


    useEffect(() => {
        const clickEvent = (e : any) => {
            let currentTarget = e.target;
            while (!currentTarget?.classList?.contains("page-container")) {
                if (currentTarget?.classList?.contains("screw-driver-container")) return;
                currentTarget = currentTarget.parentElement;
            }

            if (!e.target.classList.contains("dot") && !e?.target?.src?.includes("actionare_prin_apasare") && !e?.target?.src?.includes("contact_normal") && !e.target?.src?.includes("siguranta")) {
                const target : any = getClosestElement(e.clientX, e.clientY, document.querySelectorAll(".dot"));
                if (!target) return;
                if (!target.classList.contains("activated")) setDefectsButton(true);
                else setDefectsButton(false);

                if (isTeacher) {
                    document.querySelectorAll(".dot").forEach(dot => dot !== target ? dot.classList.remove("activated") : null);
                    setActiveDot(null);
                }
                
                if (isTeacher) setActiveDot(target);
                if (!isTeacher) {
                    if (!target.classList.contains("activated")) handleDotTouchStart(e, target);
                    else handleDotTouchEnd(e, target);
                }

                if (isTeacher) target.classList.toggle("activated");
            }
        };

        const dotImgs : any = document.querySelectorAll(".cell");
        dotImgs.forEach((dot : any) => {
            dot.addEventListener("click", clickEvent);
        });
        
        return () => {
            dotImgs.forEach((dot : any) => {
                dot.removeEventListener("click", clickEvent);
            });
        };
    }, []);

    useEffect(() => {
        const clickWindow = (e : any) => {
            // setMoveRow(false);
            // setMoveColumn(false);
            let target = e.target;
            while (!target?.classList?.contains('cell') && !target?.classList?.contains("page-container")) {
                
                target = target.parentElement;
            } 

            if (target.classList.contains("cell")) setLastMove("");

        }; 

        window.addEventListener("click", clickWindow);

        return () => {
            window.removeEventListener("click", clickWindow);
        };
    }, []);



    useEffect(() => {

        if (screw === 0 || !screwSoundRef?.current) return;
        
        const [dotNumber, dotElement] = screw;
        if (!dotElement.classList.contains("left") && !dotElement.classList.contains("right")) return;
        // if (dotNumber % 4 !== 2 && dotNumber % 4 !== 3) return;
        const element = schemeStructure.find((element: { dotNumber: number, screw: number }) => element.dotNumber.toString() === Number(dotNumber).toString());
        if (!element) return;
        if (element?.screw === 1) return;
        if (isTeacher) {
            if (element.screw === .75) removeDefect(dotElement);
            else {
                removeDefect(dotElement);
                createDefect(dotElement, "Lipsa tensiune", element.screw + .25);   
            } 
        }
        

        if (!isTeacher && problems.some((problem: any) => problem.point === dotNumber && problem.screw != null) && !schemeStructure.find((element : any) => element.dotNumber === dotNumber)?.solved) {
            if (element.screw === .75) solveDefect(dotNumber, "Lipsa tensiune");
        }
        changeScrewSchemeStructure(dotNumber, element.screw + .25);


        const screwLine = dotElement.querySelector(".screw-driver-container .screw-line");
        const screwPercentage = dotElement.querySelectorAll("h3")[1];
        const initialScrewPercentage = parseInt(screwPercentage.innerText);
        setTimeout(() => {
            setTimeout(() => notFinished = true, 25);
            for (let i = 0; i <= 25; i++) {
                setTimeout(() => {
                    if (i === 25) notFinished = false;
                    screwPercentage.innerText = `${initialScrewPercentage + i}%`;
                }, i * 10);
            }
        }, notFinished ? 350 : 0);
       
        const unScrewPercentage = dotElement.querySelectorAll("h3")[3];
        const initialUnscrewPercentage = parseInt(unScrewPercentage.innerText);
        setTimeout(() => {
            for (let i = 0; i <= 25; i++) {
                setTimeout(() => {
                    if (i === 25) notFinished = false;
                    unScrewPercentage.innerText = `${initialUnscrewPercentage - i}%`;
                }, i * 10);
            }
    
        }, notFinished ? 350 : 0);
      
        const newScrew = element.screw + .25;
        screwLine.style.transform = `rotateZ(${newScrew === .25 ? 90 : newScrew === .5 ? 180 : newScrew === .75 ? 270 : 360}deg) translateY(-50%)`;

        screwSoundRef.current.currentTime = 0;
        screwSoundRef.current.volume = 0.5;
        screwSoundRef.current.play();

        const S1 = findSignObjectByName("F1");
        const S5 = findSignObjectByName("F5");
        const S3 = findSignObjectByName("F3");
        const contact = findSignObjectByName("I");

        if (Number(schemeNumber) === 1) {
            const firstShortcircuitDefect = problems.find((element: { point: number, type: string | null }) => element.point >= 3 && element.point <= 18 && element.type === "Scurt circuit")?.point || -1;
            
            if (schemeStructure.some((element : { dotNumber: number, screw: number }) => {
                // if (element.dotNumber < 3 || element.dotNumber > 18) return;
                return element.dotNumber < firstShortcircuitDefect && element.screw <= 0;
            })) return;
    
            if (problems.some((element: { point: number, type: string | null }) => element.point >= 3 && element.point <= 10 && element.type === "Scurt circuit")) {
                actuationAlgorithm(S1.x, S1.y, false);
            } else if (problems.some((element: { point: number, type: string | null }) => element.point >= 11 && element.point <= 18 && element.type === "Scurt circuit")) {
                if (contact.names.some((name : { name: string }) => name.name.includes("inchis"))) {
                    actuationAlgorithm(S1.x, S1.y, false);
                }
            }
        } else if (Number(schemeNumber) === 2) {
            const contactS1 = findSignObjectByName("Q1");
            const contactS3 = findSignObjectByName("Q1S3");
            const contactS5 = findSignObjectByName("C.a. Q1");
            const firstTotalLinePoints = [8, 9, 10, 26, 27, 28, 29, 52, 53, 54, 55, 70, 71];
            const firstRestLinePoints = [28, 29, 52, 53, 54, 55, 70, 71];
            const secondTotalLinePoints = [13, 14, 31, 32, 33, 34, 57, 58, 59, 60, 69, 70];
            const secondRestLinePoints = [33, 34, 57, 58, 59, 60, 69, 70];
            const thirdTotalLinePoints = [16, 17, 34, 35, 36, 37, 60, 61, 62, 63, 72, 73];
            const thirdRestLinePoints = [36, 37, 60, 61, 62, 63, 72, 73];
            const fifthTotalLinePoints = [24, 25, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 64, 65, 66, 67, 74, 75];
            const fifthRestLinePoints = [44, 45,  47, 49, 51, 64, 65, 66, 67, 74, 75];

            let firstShortcircuitDefectIdx : number = -1, thirdShortcircuitDefectIdx : number = -1, fifthShortcircuitDefectIdx : number = -1;
            const firstShortcircuitDefect = problems.find((element: { point: number, type: string | null }, idx: number) => {
                if (firstTotalLinePoints.includes(element.point) && element.type === "Scurt circuit") {
                    firstShortcircuitDefectIdx = idx;
                    return true;
                }

                return false;
            });

            const thirdShortcircuitDefect = problems.find((element: { point: number, type: string | null }, idx: number) => {
                if (thirdTotalLinePoints.includes(element.point) && element.type === "Scurt circuit") {
                    thirdShortcircuitDefectIdx = idx;
                    return true;
                }

                return false;
            });

            const fifthShortcircuitDefect = problems.find((element: { point: number, type: string | null }, idx: number) => {
                if (fifthTotalLinePoints.includes(element.point) && element.type === "Scurt circuit") {
                    fifthShortcircuitDefectIdx = idx;
                    return true;
                }
                return false;
            });


            // For S1

            if (!schemeStructure.some((element : { dotNumber: number, screw: number, line: string }, idx : number) => {
                // if (element.dotNumber < 3 || element.dotNumber > 18) return;
                return idx < firstShortcircuitDefectIdx && element.screw <= .25 && firstShortcircuitDefect.line === element.line;
            })) {
                if (problems.some((element: { point: number, type: string | null }) => !firstRestLinePoints.includes(element.point) && firstTotalLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber.toString() === element.point.toString()).solved)) {

                    actuationAlgorithm(S1.x, S1.y, false);
                } else if (problems.some((element: { point: number, type: string | null }) => firstRestLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber === element.point).solved)) {
                    if (contactS1.name.includes("inchis")) {
                        actuationAlgorithm(S1.x, S1.y, false);
                    }
                }
            }


            // For S3
            if (!schemeStructure.some((element : { dotNumber: number, screw: number, line: string }, idx: number) => {
                // if (element.dotNumber < 3 || element.dotNumber > 18) return;
                return idx < thirdShortcircuitDefectIdx && element.screw <= .25 && thirdShortcircuitDefect.line === element.line;
            })) {
                if (problems.some((element: { point: number, type: string | null }) => !thirdRestLinePoints.includes(element.point) && thirdTotalLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber.toString() === element.point.toString()).solved)) {
                    
                    actuationAlgorithm(S3.x, S3.y, false);
                } else if (problems.some((element: { point: number, type: string | null }) => thirdRestLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber === element.point).solved)) {
                    if (contactS3.names.some((name : { name: string }) => name.name.includes("inchis"))) {
                        actuationAlgorithm(S3.x, S3.y, false);
                    }
                }
            }


            // For S5
            if (!schemeStructure.some((element : { dotNumber: number, screw: number, line: string }, idx: number) => {
                return idx < fifthShortcircuitDefectIdx && element.screw <= .25 && fifthShortcircuitDefect.line === element.line;
            })) {
                if (problems.some((element: { point: number, type: string | null }) => !fifthRestLinePoints.includes(element.point) && fifthTotalLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber.toString() === element.point.toString()).solved)) {
                    
                    actuationAlgorithm(S5.x, S5.y, false);
                } else if (problems.some((element: { point: number, type: string | null }) => fifthRestLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber === element.point).solved)) {
                    if (contactS5.names.some((name : { name: string }) => name.name.includes("inchis"))) {
                        actuationAlgorithm(S5.x, S5.y, false);
                    }
                }
            }
        } else if (Number(schemeNumber) === 3) {
             
            const secondContactS1 = findSignObjectByName("Q11.2");
            const secondContactS3 = findSignObjectByName("Q11.2S3");
            const selfMaintananceQ1 = findSignObjectByName("C.i. Q11.1");
            const selfMaintananceQ2 = findSignObjectByName("C.i. Q11.2");

            let currentSecondContact : any, currentSecondContactS3;
            document.querySelectorAll(".cell").forEach((cell: any) => Number(cell.getAttribute("column")) === secondContactS1?.y && Number(cell.getAttribute("row")) === secondContactS1?.x ? currentSecondContact = cell?.querySelector("img")?.src?.includes("deschis") : null);
            // document.querySelectorAll(".cell").forEach((cell: any) => Number(cell.getAttribute("column")) === secondContactS3?.y && Number(cell.getAttribute("row")) === secondContactS3?.x ? currentSecondContactS3 = cell?.querySelector("img")?.src?.includes("deschis") : null);

            const contactS1 = currentSecondContact ? findSignObjectByName("Q11.1") : secondContactS1;
            const contactS3 = currentSecondContact ? findSignObjectByName("Q11.1S3") : secondContactS3;

            const contactS5 = findSignObjectByName("C.a. Q1");

            const firstTotalLinePoints = currentSecondContact ? [6, 7, 8, 9, 50, 51, 30, 31, 32, 33, 44, 45, 82, 83, 84, 85, 104, 105] : [6, 7, 8, 9, 30, 31, 50, 51, 52, 53, 41, 40, 90, 91, 92, 93, 106, 107];
            const firstRestLinePoints = currentSecondContact ?  [32, 33, 44, 45, 82, 83, 84, 85, 104, 105] : [52, 53, 41, 40, 90, 91, 92, 93, 106, 107];
            const secondTotalLinePoints = [10, 11, 12, 13, 46, 47, 34, 35, 36, 37, 48, 49, 86, 87, 88, 89, 102, 103];
            const secondRestLinePoints = [36, 37, 48, 49, 86, 87, 88, 89, 102, 103];
            const thirdTotalLinePoints = currentSecondContact ? [14, 15, 16, 17, 38, 39, 42, 43, 40, 41, 52, 53, 90, 91, 92, 93, 106, 107] : [14, 15, 16, 17, 38, 39, 42, 43, 44, 45, 32, 33, 82, 83, 84, 85, 104, 105];
            const thirdRestLinePoints = currentSecondContact ? [40, 41, 52, 53, 90, 91, 92, 93, 106, 107] : [44, 45, 32, 33, 82, 83, 84, 85, 104, 105];
            
            // const fifthTotalLinePoints = [24, 25, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 64, 65, 66, 67, 74, 75];
            // const fifthRestLinePoints = [44, 45,  47, 49, 51, 64, 65, 66, 67, 74, 75];

            let firstShortcircuitDefectIdx : number = -1, thirdShortcircuitDefectIdx : number = -1, fifthShortcircuitDefectIdx : number = -1;
            const firstShortcircuitDefect = problems.find((element: { point: number, type: string | null }, idx: number) => {
                if (firstTotalLinePoints.includes(element.point) && element.type === "Scurt circuit") {
                    firstShortcircuitDefectIdx = idx;
                    return true;
                }

                return false;
            });

            const thirdShortcircuitDefect = problems.find((element: { point: number, type: string | null }, idx: number) => {
                if (thirdTotalLinePoints.includes(element.point) && element.type === "Scurt circuit") {
                    thirdShortcircuitDefectIdx = idx;
                    return true;
                }

                return false;
            });

            // const fifthShortcircuitDefect = problems.find((element: { point: number, type: string | null }, idx: number) => {
            //     if (fifthTotalLinePoints.includes(element.point) && element.type === "Scurt circuit") {
            //         fifthShortcircuitDefectIdx = idx;
            //         return true;
            //     }
            //     return false;
            // });


            // For S1

            if (!schemeStructure.some((element : { dotNumber: number, screw: number, line: string }, idx : number) => {
                // if (element.dotNumber < 3 || element.dotNumber > 18) return;
                return idx < firstShortcircuitDefectIdx && element.screw <= .25 && firstShortcircuitDefect.line === element.line;
            })) {
                if (problems.some((element: { point: number, type: string | null }) => !firstRestLinePoints.includes(element.point) && firstTotalLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber.toString() === element.point.toString()).solved)) {

                    actuationAlgorithm(S1.x, S1.y, false);
                } else if (problems.some((element: { point: number, type: string | null }) => firstRestLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber === element.point).solved)) {
                        
                        setTimeout(() => {
                            // console.log("PASS 2");
                            let currentContact;
                            document.querySelectorAll(".cell").forEach((cell: any) => Number(cell.getAttribute("column")) === contactS1?.y && Number(cell.getAttribute("row")) === contactS1?.x ? currentContact = cell?.querySelector("img")?.src?.includes("inchis") : null);

                            if (currentContact) {
                                actuationAlgorithm(S1.x, S1.y, false);
                                
                            } 
                        }, 1000);
                    
                }
            }


            // For S3
            if (!schemeStructure.some((element : { dotNumber: number, screw: number, line: string }, idx: number) => {
                // if (element.dotNumber < 3 || element.dotNumber > 18) return;
                return idx < thirdShortcircuitDefectIdx && element.screw <= .25 && thirdShortcircuitDefect.line === element.line;
            })) {
                if (problems.some((element: { point: number, type: string | null }) => !thirdRestLinePoints.includes(element.point) && thirdTotalLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber.toString() === element.point.toString()).solved)) {
                    actuationAlgorithm(S3.x, S3.y, false);
                } else if (problems.some((element: { point: number, type: string | null }) => thirdRestLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber === element.point).solved)) {
                   
                    setTimeout(() => {
                    // console.log("PASS 2");

                        let currentContact;
                        document.querySelectorAll(".cell").forEach((cell: any) => Number(cell.getAttribute("column")) === contactS3?.y && Number(cell.getAttribute("row")) === contactS3?.x ? currentContact = cell?.querySelector("img")?.src?.includes("inchis") : null);

                        if (currentContact) {
                            actuationAlgorithm(S3.x, S3.y, false);
                            
                        }
                    }, 1000);
                        
                
                }
            }


            // For S5
            // if (!schemeStructure.some((element : { dotNumber: number, screw: number, line: string }, idx: number) => {
            //     return idx < fifthShortcircuitDefectIdx && element.screw <= .25 && fifthShortcircuitDefect.line === element.line;
            // })) {
            //     if (problems.some((element: { point: number, type: string | null }) => !fifthRestLinePoints.includes(element.point) && fifthTotalLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber.toString() === element.point.toString()).solved)) {
                    
            //         actuationAlgorithm(S5.x, S5.y, false);
            //     } else if (problems.some((element: { point: number, type: string | null }) => fifthRestLinePoints.includes(element.point) && element.type === "Scurt circuit" && !schemeStructure.find((scElement: any) => scElement.dotNumber === element.point).solved)) {
            //         if (foundSignObject?.name?.includes("actionare_prin_apasare_automentinere")) {
            //             setTimeout(() => {
            //             // console.log("PASS 2");

            //                 let currentContact;
            //                 document.querySelectorAll(".cell").forEach((cell: any) => Number(cell.getAttribute("column")) === contactS5?.y && Number(cell.getAttribute("row")) === contactS5?.x ? currentContact = cell?.querySelector("img")?.src?.includes("inchis") : null);
            //                 if (currentContact) {
            //                     actuationAlgorithm(S5.x, S5.y, false);
            //                     setTimeout(() => actuationAlgorithm(currentRT?.x, currentRT?.y, true), 4000);
            //                     setTimeout(() => actuationAlgorithm(currentRT?.x, currentRT?.y, false), 5000);
            //                 }
            //             }, 1000);
                        
            //         }
                        
                    
            //     }
            // }
                                
    
        }

     
    }, [screw]);

    useEffect(() => {
        if (schemeStructure.some((element : any) => element.screw < 1)) console.log(schemeStructure);
    }, [schemeStructure]);


    useEffect(() => {
        if (unscrew === 0 || !screwSoundRef?.current) return;
        const [dotNumber, dotElement] = unscrew;
        if (!dotElement.classList.contains("left") && !dotElement.classList.contains("right")) return;

        const element = schemeStructure.find((element: { dotNumber: number }) => element.dotNumber === dotNumber);
        if (!element) return;
        if (element.screw === 0) return;

        if (isTeacher) {
            removeDefect(dotElement);
            createDefect(dotElement, "Lipsa tensiune", element.screw - .25);
        }

        changeScrewSchemeStructure(dotNumber, element.screw - .25);
        const screwPercentage = dotElement.querySelectorAll("h3")[1];
        const initialScrewPercentage = parseInt(screwPercentage.innerText);
        setTimeout(() => {
            setTimeout(() => notFinished = true, 25);
            for (let i = 0; i <= 25; i++) {
                setTimeout(() => {
                    if (i === 25) notFinished = false;
                    screwPercentage.innerText = `${initialScrewPercentage - i}%`;
                }, i * 10);
            }
        }, notFinished ? 350 : 0);
       
        const unScrewPercentage = dotElement.querySelectorAll("h3")[3];
        const initialUnscrewPercentage = parseInt(unScrewPercentage.innerText);
        setTimeout(() => {
            for (let i = 0; i <= 25; i++) {
                setTimeout(() => {
                    if (i === 25) notFinished = false;
                    unScrewPercentage.innerText = `${initialUnscrewPercentage + i}%`;
                }, i * 10);
            }
    
        }, notFinished ? 350 : 0);
        
        const screwLine = dotElement.querySelector(".screw-driver-container .screw-line");
        const newScrew = element.screw - .25;
        screwLine.style.transform = `rotateZ(${newScrew === 0 ? 0 : newScrew === .25 ? 90 : newScrew === .5 ? 180 : 270}deg) translateY(-50%)`;

        screwSoundRef.current.currentTime = 0;
        screwSoundRef.current.volume = 0.5;
        screwSoundRef.current.play();
    }, [unscrew]);

    useEffect(() => {
        const dots : any = document.querySelectorAll(".dot");

        const event =  (e : any) => {
            e.preventDefault();
            let target = e.target;
            if (target.tagName.toLowerCase() === "p") target = target.parentElement;
            
            if (!target.classList.contains("activated")) setDefectsButton(true);
            else setDefectsButton(false);

            if (isTeacher) {
                document.querySelectorAll(".dot").forEach(dot => dot !== target ? dot.classList.remove("activated") : null);
                setActiveDot(null);
            }
            
            if (isTeacher) setActiveDot(target);
          
            // else handleDotTouchEnd(null, target);

            document.querySelectorAll(".dot").forEach((dot : any) => {
                if (dot !== target && dot.classList.contains("activated")) {
                    handleDotTouchEnd(null, dot);
                }
            });
            
            handleDotTouchStart(e, target);
            

            target.classList.add("activated");
        };

        dots.forEach((dot : any) => {
            dot.addEventListener("contextmenu", event);
        });

        return () => {
            dots.forEach((dot: any) => {
                dot.removeEventListener("contextmenu", event);
            });
        }

    }, [document.querySelectorAll(".dot")]);


    const reduceSigns = () => {

        const removeSignsArr : any = [];

        signs.forEach((sign : any) => {
            const sameSignsCoords = signs.filter((sign2 : any) => sign2.x === sign.x && sign2.y === sign.y && sign2.page === sign.page);
            const maxSign = sameSignsCoords.reduce((acc : any, curr : any) => {
                if (!acc || curr.names.length > acc.names.length) return curr;
                else return acc;
            }, null);

            sameSignsCoords.forEach((sign2 : any) => {
                if (JSON.stringify(sign2) !== JSON.stringify(maxSign) && !removeSignsArr.some((elem : any) => JSON.stringify(elem) === JSON.stringify(sign2))) removeSignsArr.push(sign2);
            });
        });

        removeSignsArr.forEach((sign : any) => {
            removeSign(sign.x, sign.y, sign.page);
        });
    };


    const [startDragText, setStartDragText] = useState<boolean>(false);
    const findSign = (x: number, y: number, idx: number = 0, hasCurrent : Array<boolean> = [false], electricityLine : Array<string | null> = [null]) => {
        // if (dragElement) return;
        const currSign = findAt(x, y, page) || null;

        
        
        if (!currSign?.names) return null;

        const leftMaxPoint = currPoint, leftPoint = currPoint + 1, rightPoint = currPoint + 2, rightMaxPoint = currPoint + 3, topPoint = currPoint, fifthPoint = currPoint + 4, sixthPoint = currPoint + 5;
        
        const dotLeftMaxProp = {
            point: leftMaxPoint
        };

        const dotLeftProp = {
            point: leftPoint
        };

        const dotRightProp = {
            point: rightPoint
        };

        const dotRightMaxProp = {
            point: rightMaxPoint
        };

        const dotTopProp = {
            point: Number(schemeNumber) === 1 ? 500 : Number(schemeNumber) === 2 && topPoint === Number(process.env.REACT_APP_SECOND_SCHEME_PROTECTION_POINT) ? 500 : topPoint
        };

        const dotFifthProp = {
            point: fifthPoint
        };

        const dotSixthProp = {
            point: sixthPoint
        };

        // if (currSign.name.includes("derivatie_din_conductor") && Number(schemeNumber) === 1) {
        //     currPoint += 0.5;
        // }
        
        if (!currSign?.names?.some((name: { name: string }) => name.name.includes("conductor")) && !currSign?.names?.some((name : { name: string }) => name.name.includes("colt")) && !currSign?.names?.some((name : { name: string }) => name.name.includes("contur")) && !currSign?.names?.some((name : { name: string }) => name.name.includes("cruce")) && !currSign?.names?.some((name : { name: string }) => name.name.includes("priza")) && category === "2") {
            // console.log(currSign);
            // currPoint = currPoint + (inHere ? 2 : 4);
            if (!inHere) inHere = true;
        }

        currPoint++;
        // console.log(currSign?.signPosition);

        // if (currSign?.signPosition && currSign.signPosition.includes("engine")) currPoint += 2;


        return (
            <>
                {currSign?.names?.map((name : { name: string, flip : number | null }, currSignIdx : number) => {
                    return (
                        <img 
                            draggable={false} 
                            src={name.name} 
                            style={{ 
                                transform: `rotateZ(${(currSign.flip || 0) + (name?.flip || 0)}deg) ${name.name.includes("consumator") ? "scale(1.7)" : name.name.includes("inalta") ? "scale(1.25)" : name.name.includes("conductor_lung") || name.name.includes("derivatie_din_conductor") || name.name.includes("conductor_diagonal") ? "scaleX(1.1)" : name.name.includes("cruce") ? "scale(1.1)" : name.name.includes("motor") && !name.name.includes("actionare_cu_motor") ? "scale(1.5)" : ""}`, filter: currSign?.signColor || "initial", zIndex: name.name.includes("motor") ? 1000 : name.name.includes("consumator") ? 50 : 1,
                                top:  ( ( ( name?.flip || 0 ) + (currSign?.flip || 0) ) % 360 === 0 &&  name.name.includes("_0") ) || ( ( name?.flip || 0 ) + ( currSign?.flip || 0 ) % 360 === 180 && name.name.includes("_100") ) ? "0" : "initial",
                                bottom:  ( ( ( name?.flip || 0 ) + (currSign?.flip || 0) ) % 360 === 0 &&  name.name.includes("_100") ) || ( ( ( name?.flip || 0 ) + (currSign?.flip || 0) ) % 360 === 180 && name.name.includes("_0") ) ? "0" : "initial",
                                right:  ( ( ( name?.flip || 0 ) + (currSign?.flip || 0) ) % 360 === 90 &&  name.name.includes("_0") ) || ( ( ( name?.flip || 0 ) + (currSign?.flip || 0) ) % 360 === 270 && name.name.includes("_100") ) ? "-12.5%" : "initial",
                                left:  ( ( ( name?.flip || 0 ) + (currSign?.flip || 0) ) % 360 === 90 &&  name.name.includes("_100") ) || ( ( ( name?.flip || 0 ) + (currSign?.flip || 0) ) % 360 === 270 && name.name.includes("_0") ) ? "-12.5%" : "initial",
                            }} 

                            className={`cell-image ${hasCurrent?.[currSignIdx] ? "has-current" : ""} ${electricityLine?.[currSignIdx] ?? ""}`}
                        />
                    );
                })}

                {currSign.texts.length ? currSign.texts.map((text: any, idx: number) => {
                    const textElementAttr = {
                        fontSize: text.fontSize || 10,
                        positionx: text.positionX || 0,
                        positiony: text.positionY || 0,
                    };

                    return <h2 
                        onClick={(e : any) => {
                            e.preventDefault();
                            const target = e.target;
                            console.warn(target);
                            target.classList.toggle("selected");
                        }}

                        onBlur={(e : any) => {
                            const target = e.target;
                            target.classList.remove('selected');
                        }}

                        onKeyDown={(e : any) => {
                            e.preventDefault();
                            const target = e.target;

                          
                            
                            console.warn(e.target, e.key);

                            if (target?.classList?.contains("selected")) {
                                if (e.key === "ArrowDown") {
                                
                                    const newTexts = currSign.texts.map((text : any, textIdx: number) => {
                                        if (textIdx === idx) return {...text, positionY: (text?.positionY || 0) + 0.33};
                                        return text;
                                    });

                                    changeCellName(x, y, page, newTexts);

                                } else if (e.key === "ArrowUp") {

                                    const newTexts = currSign.texts.map((text : any, textIdx: number) => {
                                        if (textIdx === idx) return {...text, positionY: (text?.positionY || 0) - 0.33};
                                        return text;
                                    });

                                    changeCellName(x, y, page, newTexts);

                                } else if (e.key === "ArrowLeft") {

                                    const newTexts = currSign.texts.map((text : any, textIdx: number) => {
                                        if (textIdx === idx) return {...text, positionX: (text?.positionX || 0) - 0.33};
                                        return text;
                                    });

                                    changeCellName(x, y, page, newTexts);

                                } else if (e.key === "ArrowRight") {
                                    const newTexts = currSign.texts.map((text : any, textIdx: number) => {
                                        if (textIdx === idx) return {...text, positionX: (text?.positionX || 0) + 0.33};
                                        return text;
                                    });

                                    changeCellName(x, y, page, newTexts);
                                }
                            }
                        }}

                        tabIndex={0}
                        key={idx}
                        className={`cell-text ${text.textAlignment}`} 
                        style={{ transform: `${text?.centered ? "translateX(-50%) " : ""}rotateZ(${text?.flip || 0}deg)`, fontWeight: text.fontWeight || 400, fontSize: `${Number(text?.fontSize) > 14 ? text?.fontSize : 14}px`, left: text.positionX, top: text.positionY}}
                        {...textElementAttr}
                        
                        >
                            {text.name}
                        </h2>;
                }) : null}

                {!currSign?.names?.some((name : { name: string }) => name.name.includes("conductor")) && !currSign?.names?.some((name : { name: string }) => name.name.includes("colt")) && !currSign?.names?.some((name : { name: string }) => name.name.includes("contur")) && !currSign?.names?.some((name : { name: string }) => name.name.includes("priza")) && !currSign?.names?.some((name : { name: string }) => name.name.includes("cruce")) && category == "2" ? (
                    <>
                        {!currSign.signPosition.includes("right-automention") ? <div
                            className="dot max-left"
                            onTouchStart={(e: any) => handleDotTouchStart(e, e.target)}
                            onTouchEnd={(e: any) => handleDotTouchEnd(e, e.target)}
                            onTouchCancel={(e: any) => handleDotTouchEnd(e, e.target)}
                            onClick={(e: any) => {
                                let target = e.target;
                                if (target.tagName.toLowerCase() === "p") target = target.parentElement;
                                if (!target.classList.contains("activated")) setDefectsButton(true);
                                else setDefectsButton(false);

                                if (isTeacher) {
                                    document.querySelectorAll(".dot").forEach(dot => dot !== target ? dot.classList.remove("activated") : null);
                                    setActiveDot(null);
                                }
                                
                                if (isTeacher) setActiveDot(target);
                                if (!isTeacher) {
                                    if (!target.classList.contains("activated")) handleDotTouchStart(e, target);
                                    else handleDotTouchEnd(null, target);
                                }

                                if (isTeacher) target.classList.toggle("activated");
                            }}
                            
                            
                            {...dotLeftMaxProp}
                        >
                            <p>{dotLeftMaxProp.point - 4}</p>
                        </div> : null}

                        <div
                            className={`dot left`}
                            onTouchStart={(e: any) => handleDotTouchStart(e, e.target)}
                            onTouchEnd={(e: any) => handleDotTouchEnd(e, e.target)}
                            onTouchCancel={(e: any) => handleDotTouchEnd(e, e.target)}
                            onClick={(e: any) => {
                                let target = e.target;
                                if (target.tagName.toLowerCase() === "p") target = target.parentElement;
                                if (target.classList.contains("screw-driver") || target.classList.contains("screw-driver-container") || target.tagName.toLowerCase() === "h3") return;
                                if (!target.classList.contains("activated")) setDefectsButton(true);
                                else setDefectsButton(false);

                                if (isTeacher) {
                                    document.querySelectorAll(".dot").forEach(dot => dot !== target ? dot.classList.remove("activated") : null);
                                    setActiveDot(null);
                                }
                                
                                if (isTeacher) setActiveDot(target);
                                if (!isTeacher) {
                                    if (!target.classList.contains("activated")) handleDotTouchStart(e, target);
                                    else handleDotTouchEnd(e, target);
                                }

                                if (isTeacher) target.classList.toggle("activated");
                            }}
                            {...dotLeftProp}
                        >
                            <p>{dotLeftProp.point}</p>
                           
                            <div className="screw-driver-container">
                                <img className="screw-driver" width={150} src={screwDriver} onClick={(e : any) => {
                                    e.target.nextElementSibling.classList.toggle("show");
                                }}/>

                                <div className="screw-driver-option">
                                    <div className="option" onClick={(e : any) => {
                                        // const dot = Array.from(document.querySelectorAll(".dot")).find((dot : any) => dot.querySelector("p").innerText === (dotLeftProp.point - 4).toString());
                                        let dot = e.target;
                                        while (!dot.classList.contains("dot")) dot = dot.parentElement;
                                        if (dot?.querySelector(".screw-driver-option:not(.show)")) return;

                                        setScrew([Number(dot?.querySelector("p")?.innerText || ""), dot]);
                                    }}>
                                        <h3>{cookies?.language === "en" ? "Screw" : "Înșurubează"}</h3>
                                        <FontAwesomeIcon className="screw-driver-option-icon" icon={faRotateRight} />
                                        <h3>{(getDotDataAlteredPoints(dotLeftProp.point)?.screw == null ? 1 : getDotDataAlteredPoints(dotLeftProp.point)?.screw) * 100}%</h3>
                                    </div>

                                    <div className="option" onClick={(e : any) => {
                                        let dot = e.target;
                                        while (!dot.classList.contains("dot")) dot = dot.parentElement;
                                        if (dot?.querySelector(".screw-driver-option:not(.show)")) return;
                                        // console.log(schemeStructure.find((element : any) => element.dotNumber === dotLeftProp.point - 4)?.screw);
                                        setUnscrew([Number(dot?.querySelector("p")?.innerText || ""), dot]);
                                    }}>
                                        <h3>{cookies?.language === "en" ? "Unscrew" : "Deșurubează"}</h3>
                                        <FontAwesomeIcon className="screw-driver-option-icon" icon={faRotateLeft} />
                                        <h3>{(1 - (getDotDataAlteredPoints(dotLeftProp.point)?.screw == null ? 1 : getDotDataAlteredPoints(dotLeftProp.point)?.screw)) * 100}%</h3>

                                    </div>
                                </div>

                                <div className="screw-line" />
                            </div>
                       
                        </div>

                        <div
                            className={`dot ${currSign?.signPosition && currSign.signPosition.includes("engine") ? "branch-left" : "right"}`}
                            onTouchStart={(e: any) => handleDotTouchStart(e, e.target)}
                            onTouchEnd={(e: any) => handleDotTouchEnd(e, e.target)}
                            onTouchCancel={(e: any) => handleDotTouchEnd(e, e.target)}
                            onClick={(e: any) => {
                                let target = e.target;
                                if (target.tagName.toLowerCase() === "p") target = target.parentElement;
                                if (target.classList.contains("screw-driver") || target.classList.contains("screw-driver-container") || target.tagName.toLowerCase() === "h3") return;
                                if (!target.classList.contains("activated")) setDefectsButton(true);
                                else setDefectsButton(false);

                                if (isTeacher) {
                                    document.querySelectorAll(".dot").forEach(dot => dot !== target ? dot.classList.remove("activated") : null);
                                    setActiveDot(null);
                                }
                                
                                if (isTeacher) setActiveDot(target);
                                if (!isTeacher) {
                                    if (!target.classList.contains("activated")) handleDotTouchStart(e, target);
                                    else handleDotTouchEnd(e, target);
                                }

                                if (isTeacher) target.classList.toggle("activated");
                            }}
                           
                            {...dotRightProp}
                        >
                            <p>{dotRightProp.point}</p>
                            
                            <div className="screw-driver-container">
                                <img className="screw-driver" width={150} src={screwDriver} onClick={(e : any) => {
                                    e.target.nextElementSibling.classList.toggle("show");
                                }}/>

                                <div className="screw-driver-option">
                                    <div className="option" onClick={(e : any) => {
                                        let dot = e.target;
                                        while (!dot.classList.contains("dot")) dot = dot.parentElement;
                                        if (dot?.querySelector(".screw-driver-option:not(.show)")) return;

                                        setScrew([Number(dot?.querySelector("p")?.innerText || ""), dot]);
                                    }}>
                                        <h3>{cookies?.language === "en" ? "Screw" : "Înșurubează"}</h3>
                                        <FontAwesomeIcon className="screw-driver-option-icon" icon={faRotateRight} />
                                        <h3>{(getDotDataAlteredPoints(dotRightProp.point)?.screw == null ? 1 : getDotDataAlteredPoints(dotRightProp.point)?.screw) * 100}%</h3>
                                    </div>

                                    <div className="option" onClick={(e : any) => {
                                        let dot = e.target;
                                        while (!dot.classList.contains("dot")) dot = dot.parentElement;
                                        if (dot?.querySelector(".screw-driver-option:not(.show)")) return;
                                        setUnscrew([Number(dot?.querySelector("p")?.innerText || ""), dot]);
                                    }}>
                                        <h3>{cookies?.language === "en" ? "Unscrew" : "Deșurubează"}</h3>
                                        <FontAwesomeIcon className="screw-driver-option-icon" icon={faRotateLeft} />
                                        <h3>{(1 - (getDotDataAlteredPoints(dotRightProp.point)?.screw == null ? 1 : getDotDataAlteredPoints(dotRightProp.point)?.screw)) * 100}%</h3>

                                    </div>
                                </div>

                                <div className="screw-line" />
                            </div>
                           
                        </div>

                        {!currSign.signPosition.includes("right-automention") ? <div
                            className={`dot ${currSign?.signPosition && currSign.signPosition.includes("engine") ? "branch-left-max" : "max-right"}`}
                            onTouchStart={(e: any) => handleDotTouchStart(e, e.target)}
                            onTouchEnd={(e: any) => handleDotTouchEnd(e, e.target)}
                            onTouchCancel={(e: any) => handleDotTouchEnd(e, e.target)}
                            onClick={(e: any) => {
                                let target = e.target;
                                if (target.tagName.toLowerCase() === "p") target = target.parentElement;
                                if (!target.classList.contains("activated")) setDefectsButton(true);
                                else setDefectsButton(false);

                                if (isTeacher) {
                                    document.querySelectorAll(".dot").forEach(dot => dot !== target ? dot.classList.remove("activated") : null);
                                    setActiveDot(null);
                                }
                                
                                if (isTeacher) setActiveDot(target);
                                if (!isTeacher) {
                                    if (!target.classList.contains("activated")) handleDotTouchStart(e, target);
                                    else handleDotTouchEnd(e, target);
                                }

                                if (isTeacher) target.classList.toggle("activated");
                            }}
                            {...dotRightMaxProp}
                        >
                            <p>{dotRightMaxProp.point - 4}</p>
                        </div> : null}

                        {currSign?.signPosition && currSign.signPosition.includes("-automention") ? (
                            <>
                                <div
                                className={`dot max-left-automention`}
                                onTouchStart={(e: any) => handleDotTouchStart(e, e.target)}
                                onTouchEnd={(e: any) => handleDotTouchEnd(e, e.target)}
                                onTouchCancel={(e: any) => handleDotTouchEnd(e, e.target)}
                                onClick={(e: any) => {
                                    let target = e.target;
                                    if (target.tagName.toLowerCase() === "p") target = target.parentElement;
                                    if (!target.classList.contains("activated")) setDefectsButton(true);
                                    else setDefectsButton(false);

                                    if (isTeacher) {
                                        document.querySelectorAll(".dot").forEach(dot => dot !== target ? dot.classList.remove("activated") : null);
                                        setActiveDot(null);
                                    }
                                    
                                    if (isTeacher) setActiveDot(target);
                                    if (!isTeacher) {
                                        if (!target.classList.contains("activated")) handleDotTouchStart(e, target);
                                        else handleDotTouchEnd(e, target);
                                    }

                                    if (isTeacher) target.classList.toggle("activated");
                                }}
                                style={currSign?.names?.some((name : { name: string }) => name.name.includes("indicator_luminos")) ? { left: "8.5px" } : {}}
                                {...dotFifthProp}
                                >
                                  <p>{dotFifthProp.point - 4}</p>
                                </div>

                                <div
                                    className={`dot max-right-automention`}
                                    onTouchStart={(e: any) => handleDotTouchStart(e, e.target)}
                                    onTouchEnd={(e: any) => handleDotTouchEnd(e, e.target)}
                                    onTouchCancel={(e: any) => handleDotTouchEnd(e, e.target)}
                                    onClick={(e: any) => {
                                        let target = e.target;
                                        if (target.tagName.toLowerCase() === "p") target = target.parentElement;
                                        if (!target.classList.contains("activated")) setDefectsButton(true);
                                        else setDefectsButton(false);

                                        if (isTeacher) {
                                            document.querySelectorAll(".dot").forEach(dot => dot !== target ? dot.classList.remove("activated") : null);
                                            setActiveDot(null);
                                        }
                                        
                                        if (isTeacher) setActiveDot(target);
                                        if (!isTeacher) {
                                            if (!target.classList.contains("activated")) handleDotTouchStart(e, target);
                                            else handleDotTouchEnd(e, target);
                                        }

                                        if (isTeacher) target.classList.toggle("activated");
                                    }}
                                    style={currSign?.names?.some((name : { name: string}) => name.name.includes("indicator_luminos")) ? { right: "5px", left: "initial", transform: "initial" } : {}}
                                    {...dotSixthProp}
                                >
                                    <p>{dotSixthProp.point - 4}</p>
                                </div>
                            </>
                        ) : null}

                        {currSign?.signPosition && currSign.signPosition.includes("engine") ? (
                            <>
                              <div
                                className={`dot branch-right-max`}
                                onTouchStart={(e: any) => handleDotTouchStart(e, e.target)}
                                onTouchEnd={(e: any) => handleDotTouchEnd(e, e.target)}
                                onTouchCancel={(e: any) => handleDotTouchEnd(e, e.target)}
                                onClick={(e: any) => {
                                    let target = e.target;
                                    if (target.tagName.toLowerCase() === "p") target = target.parentElement;
                                    if (!target.classList.contains("activated")) setDefectsButton(true);
                                    else setDefectsButton(false);
    
                                    if (activeDot && isTeacher) {
                                        document.querySelectorAll(".dot").forEach(dot => dot !== target ? dot.classList.remove("activated") : null);
                                        setActiveDot(null);
                                    }
                                    
                                    if (isTeacher) setActiveDot(target);
                                    if (!isTeacher) {
                                        if (!target.classList.contains("activated")) handleDotTouchStart(e, target);
                                        else handleDotTouchEnd(e, target);
                                    }
    
                                    if (isTeacher) target.classList.toggle("activated");
                                }}
                                style={currSign?.names?.some((name : { name: string}) => name.name.includes("indicator_luminos")) ? { left: "8.5px" } : {}}
                                {...dotFifthProp}
                                >
                                    <p>{dotFifthProp.point - 4}</p>
                                </div>

                                <div
                                    className={`dot branch-right`}
                                    onTouchStart={(e: any) => handleDotTouchStart(e, e.target)}
                                    onTouchEnd={(e: any) => handleDotTouchEnd(e, e.target)}
                                    onTouchCancel={(e: any) => handleDotTouchEnd(e, e.target)}
                                    onClick={(e: any) => {
                                        let target = e.target;
                                        if (target.tagName.toLowerCase() === "p") target = target.parentElement;
                                        if (!target.classList.contains("activated")) setDefectsButton(true);
                                        else setDefectsButton(false);
        
                                        if (activeDot && isTeacher) {
                                            document.querySelectorAll(".dot").forEach(dot => dot !== target ? dot.classList.remove("activated") : null);
                                            setActiveDot(null);
                                        }
                                        
                                        if (isTeacher) setActiveDot(target);
                                        if (!isTeacher) {
                                            if (!target.classList.contains("activated")) handleDotTouchStart(e, target);
                                            else handleDotTouchEnd(e, target);
                                        }
        
                                        if (isTeacher) target.classList.toggle("activated");
                                    }}
                                    style={currSign?.names?.some((name : { name: string }) => name.name.includes("indicator_luminos")) ? { right: "5px", left: "initial", transform: "initial" } : {}}
                                    {...dotSixthProp}
                                >
                                    <p>{dotSixthProp.point - 4}</p>
                                </div>
                            </>
                        ) : null}


                    </>
                ) : (currSign?.names?.some((name : { name: string }) => name.name.includes("derivatie_din_conductor"))) && category == "2" ? (
                    <div
                    className="dot top"
                    onTouchStart={(e: any) => handleDotTouchStart(e, e.target)}
                    onTouchEnd={(e: any) => handleDotTouchEnd(e, e.target)}
                    onTouchCancel={(e: any) => handleDotTouchEnd(e, e.target)}
                    onClick={(e: any) => {
                        let target = e.target;
                        if (target.tagName.toLowerCase() === "p") target = target.parentElement;
                        if (!target.classList.contains("activated")) setDefectsButton(true);
                        else setDefectsButton(false);

                        if (activeDot && isTeacher) {
                            document.querySelectorAll(".dot").forEach(dot => dot !== target ? dot.classList.remove("activated") : null);
                            setActiveDot(null);
                        }
                        
                        if (!target.classList.contains("activated") && isTeacher) setActiveDot(target);
                        if (!isTeacher) {
                            if (!target.classList.contains("activated")) handleDotTouchStart(e, target);
                            else handleDotTouchEnd(e, target);
                        }

                        if (isTeacher) target.classList.toggle("activated");
                    }}
                    {...dotTopProp}
                >
                    <p>{dotTopProp.point - (Number(schemeNumber) === 1 || dotTopProp.point === 500 ? 0 : 0.5)}</p>
                </div> 
                ) : null}

            </> 
        );
    };

    const findSignObject = (x: number, y: number, idx: number = 0) => {
        const currSign: {x: number; y: number; page: number; flip: number; names: any[]; signPosition: string, texts: any[]} = findAt(x, y, page);
        return currSign;
    };

    const findSignObjectByName = (name : string) => {
        return signs.find((sign : any) => sign.texts.some((text: { name: string }) => text.name === name));
    };

    const findSignsObjectByName = (name : string) => {
        return signs.filter((sign : any) => sign.texts.some((text: { name: string }) => text?.name === name));
    };

    const selectedCell = useStore((state: any) => state.selectedCell);

    const isSelectedCell = (x: number, y: number) => {
        const currSign: { x: number, y: number, names: Array<any>, page: number, flip: number, isSelectedSign: boolean } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number, isSelected: boolean, page: number }) => sign.x === x && sign.y === y && sign.page === page);

        return currSign?.isSelectedSign || (selectedCell?.y === y && selectedCell?.x === x && selectedCell?.page === page);
    };

    const getSelectedCell = useCallback(() => {
        const element = Array.from(document.querySelectorAll(".cell")).find((cell: any) => cell.classList.contains("selected"));
        if (!element) return null;
        return { x: Number(element.getAttribute("row")), y: Number(element.getAttribute("column")), element };
    }, [changeSelectedCell]);

    const changeName = () => {
        const selectedCell : any = getSelectedCell();
        if (selectedCell?.element?.firstChild) changeCellName(selectedCell.x, selectedCell.y, page, texts);
        else if (selectedCell) addSign(selectedCell?.x, selectedCell?.y, page, SCHEME_ELEMENTS["contur"].imageSource, 0, texts);
        
        // setSignName("");
        // setSignTextAlignment("");
        setNameSignMenu(false);
    };


    // Update element's columns

    useEffect(() => {
        if (!cellRef?.current) return;
        setColumns(currColumns => {
            let currNumber = 0;
            return currColumns.map((column, columnIdx) => {
                let elementOnThisColumn = false;
                for (let row = 0; row < ROWS; row++) {
                    if (cellRef.current[row * COLUMNS + columnIdx]?.firstElementChild) elementOnThisColumn = true;

                }

                if (elementOnThisColumn) return ++currNumber;
                return 0;
            });

        });

    }, [signs, cellRef]);

    useEffect(() => {
        if (!pageRef || !pageRef.current) return;
        pageRef.current.setAttribute("format", format);
    }, [pageRef]);


    let lastElementHereRow : any = useMemo(() => null, []);
    let lastElementHereColumn : any = useMemo(() => null, []);

    const [moveRow, setMoveRow] = useState<boolean>(false);
    const [moveColumn, setMoveColumn] = useState<boolean>(false);
    const [lastMove, setLastMove] = useState<string>("");


    useEffect(() => {
        if (category !== "0") return;

        const keyDownEvent = (e : any) => {
            const selectedCell = getSelectedCell();

            if (e.ctrlKey || e.metaKey) {

                if (e.key.toLowerCase() === "c" && !nameSignMenu && typeof multipleSelectedCells === "object") {
                    removeSelectedCell();
                    removeSelectedSign();
                    document.querySelectorAll(".cell.selected").forEach(cell => cell.classList.remove("selected"));
                } else if (e.key.toLowerCase() === "c" && !nameSignMenu) {
                    if (selectedCell) {
                        const selectedCells : any = document.querySelectorAll(".cell.selected");
                        
                        if (selectedCells?.length > 1) {
                            const currentCopiedSigns = [...selectedCells].map((cell : any) => {
                                const currentSign : { x: number, y: number, names: Array<any>, flip: number, texts: any, signColor: string | null } = signs.find((sign: { x: number, y: number, flip: number, page:number }) => sign.x === Number(cell.getAttribute("row")) && sign.y === Number(cell.getAttribute("column")) && sign.page === page);
                               
                                cell.classList.remove("selected");
                                return currentSign;
                            });

                            setCopiedElements(currentCopiedSigns);
                            setCopiedElement(null);
                            setCuttedElement(null);
                            setCuttedElements(null);
                        } else {
                            const currentSign : { x: number, y: number, names: Array<any>, flip: number, texts: any, signColor: string | null } = signs.find((sign: { x: number, y: number, flip: number, page:number }) => sign.x === selectedCell.x && sign.y === selectedCell.y && sign.page === page);
                            setCopiedElement(currentSign);
                            setCopiedElements(null);
                        }

                        removeSelectedSign();
                        removeSelectedCell();
                        stopElement();
                 
                    }
                } else if (e.key.toLowerCase() === "v" && !nameSignMenu && typeof multipleSelectedCells === "object") {
                    const selectedCells = document.querySelectorAll(".cell.selected");
                    if (!selectedCells?.length) return;
                    selectedCells.forEach(cell => {
                        const x = Number(cell.getAttribute("row") || 0);
                        const y = Number(cell.getAttribute("column") || 0);
                        let lastX = x, lastY = y;
                        multipleSelectedCells.forEach((multipleSelectedCell, idx) => {
                            let currentX, currentY;
                            if (typeof multipleSelectedCell === "object") {
                                if (idx === 0) {
                                    currentX = 0;
                                    currentY = 0;
                                } else {
                                    currentX = multipleSelectedCell.x;
                                    currentY = multipleSelectedCell.y;
                                }

                                const totalX = lastX + currentX;
                                const totalY = lastY + currentY;
                                
                                removeSign(totalX, totalY, page);
                                if (multipleSelectedCell?.sign?.names?.length) addSign(totalX, totalY, page, multipleSelectedCell?.sign?.names, multipleSelectedCell?.sign?.flip, multipleSelectedCell?.sign?.texts);
                                
                                lastX = totalX;
                                lastY = totalY;
                            }
                            
                        });
                    });

                    removeSelectedCell();
                    removeSelectedSign();
                    setMultipleSelectedCells(false);
                    document.querySelectorAll(".cell.selected").forEach(cell => cell.classList.remove("selected"));
                } else if (e.key.toLowerCase() === "v" && !nameSignMenu) {

                    // Ctrl+V was pressed
                    const selectedCells = cellRef.current.filter(cell => cell?.classList.contains("selected"));
                    if (cuttedElement) {
                        selectedCells.forEach(cell => {
                            // const currSign: { x: number, y: number, names: Array<any>, flip: number, textName: string, textAlignment: string, fontSize: number, signColor: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number }) => sign.x === Number(cell?.getAttribute("column")) && sign.y === Number(cell?.getAttribute("row")));
                            addSign(Number(cell?.getAttribute("row")), Number(cell?.getAttribute("column")), page, cuttedElement.names, cuttedElement.flip, cuttedElement.texts, cuttedElement.signColor);
                        });
                    } else if (copiedElement) {
                        selectedCells.forEach(cell => {
                            // const currSign: { x: number, y: number, names: Array<any>, flip: number, textName: string, textAlignment: string, fontSize: number, signColor: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number }) => sign.x === Number(cell?.getAttribute("column")) && sign.y === Number(cell?.getAttribute("row")));
                            addSign(Number(cell?.getAttribute("row")), Number(cell?.getAttribute("column")), page, copiedElement.names, copiedElement.flip, copiedElement.texts, copiedElement.signColor);
                        });
                    } else if (copiedElements) {
                        if (lastMove === "row") {
                            const selectedRow = selectedCell?.y;
                            const newCells = document.querySelectorAll(`.cell[column="${selectedRow}"]`);
                            newCells.forEach((cell : any, idx : number) => {
                                if (copiedElements?.[idx]) {
                                    addSign(Number(cell?.getAttribute("row")), Number(cell?.getAttribute("column")), page, copiedElements[idx].names, copiedElements[idx].flip, copiedElements[idx].texts, copiedElements[idx].signColor);
                                }
                            });
                            
                        } else if (lastMove === "column") {
                            const selectedColumn = selectedCell?.x;
                            const newCells = document.querySelectorAll(`.cell[row="${selectedColumn}"]`);
                            newCells.forEach((cell : any, idx : number) => {
                                if (copiedElements?.[idx]) {
                                    addSign(Number(cell?.getAttribute("row")), Number(cell?.getAttribute("column")), page, copiedElements[idx].names, copiedElements[idx].flip, copiedElements[idx].texts, copiedElements[idx].signColor);
                                }
                            });
                        }
                     
                    } else if (cuttedElements?.length) {

                        if (lastMove === "row") {
                            const selectedRow = selectedCell?.y;
                            const newCells = document.querySelectorAll(`.cell[column="${selectedRow}"]`);
                            newCells.forEach((cell : any, idx : number) => {
                                if (cuttedElements?.[idx]) {
                                    addSign(Number(cell?.getAttribute("row")), Number(cell?.getAttribute("column")), page, cuttedElements[idx].names, cuttedElements[idx].flip, cuttedElements[idx].texts, cuttedElements[idx].signColor);
                                }
                            });
                            
                        } else if (lastMove === "column") {
                            const selectedColumn = selectedCell?.x;
                            const newCells = document.querySelectorAll(`.cell[row="${selectedColumn}"]`);
                            newCells.forEach((cell : any, idx : number) => {
                                if (cuttedElements?.[idx]) {
                                    addSign(Number(cell?.getAttribute("row")), Number(cell?.getAttribute("column")), page, cuttedElements[idx].names, cuttedElements[idx].flip, cuttedElements[idx].texts, cuttedElements[idx].signColor);
                                }
                            });
                        }

                        
                        cuttedElements.forEach((elem : any) => {
                            if (elem) removeSign(elem.x, elem.y, page);  
                        });
                     
                    } 
                  
                    
                    if (copiedElement) setCopiedElement(null);
                    if (cuttedElement) setCuttedElement(null);
                    if (copiedElements) setCopiedElements(null);
                    if (cuttedElements) setCuttedElements(null);

                    
                    // if (copiedElements) setCopiedElements(null);


                } else if (e.key.toLowerCase() === "x" && !nameSignMenu) {
                 
                    const selectedCells = cellRef.current.filter(cell => cell?.classList.contains("selected"));

                    if (selectedCells?.length > 1) {
                        const currentCopiedSigns = [...selectedCells].map((cell : any) => {
                            const currentSign : { x: number, y: number, names: Array<any>, flip: number, texts: any, signColor: string | null } = signs.find((sign: { x: number, y: number, flip: number, page:number }) => sign.x === Number(cell.getAttribute("row")) && sign.y === Number(cell.getAttribute("column")) && sign.page === page);
                           
                            
                            // document.querySelectorAll(".cell").forEach(cell => cell !== document.querySelector(".cell.selected") ? cell.classList.remove("copy") : null);
                            // document.querySelector(".cell.selected")?.classList.add("copy");
                            // console.log(selectedCell);
                            // document.querySelectorAll(".cell").forEach(cell => cell.classList.remove("selected"));
                            cell?.classList?.remove("selected");
                            return currentSign;
                        });

                        setCuttedElements(currentCopiedSigns);
                        setCuttedElement(null);
                        setCopiedElement(null);
                        setCopiedElements(null);
                    } else if (selectedCell) {
                        const currentSign : { x: number, y: number, names: Array<any>, flip: number, texts: any, signColor: string | null } = signs.find((sign: { x: number, y: number, flip: number, page: number }) => sign.x === selectedCell.x && sign.y === selectedCell.y && sign.page === page);
                        setCuttedElement(currentSign);
                        removeSign(currentSign.x, currentSign?.y, page);
                        removeSelectedSign();
                        removeSelectedCell();
                        setCuttedElements(null);
                    }

                    stopElement();
                }
            }

            if ((e.key === "Delete" || e.key === "Backspace") && !nameSignMenu) {
                const selectedCells = document.querySelectorAll(".cell.selected");
                if (selectedCells) {
                    selectedCells.forEach((cell : any) => {
                        const currentSign : { x: number, y: number, names: Array<any>, page: number, flip: number, texts: any, signColor: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number, page: number }) => sign.x === Number(cell.getAttribute("row")) && sign.y === Number(cell.getAttribute("column")) && sign.page === page);
                        removeSign(currentSign?.x, currentSign?.y, page);
                    });

                    selectedCells.forEach((cell : any) => cell.classList.remove("selected"));

                    if (typeof multipleSelectedCells === "object") setMultipleSelectedCells(false);
                }
                
            }

            if (!e.ctrlKey && !e.metaKey && e.key.toLowerCase() === "r" && !nameSignMenu) {
                if (selectedCell) {
                    const { x, y } = selectedCell;  
                    const cellsFromRow = document.querySelectorAll(`.cell[column="${y}"]`);
                    cellsFromRow.forEach((cell : any) => {
                        if (cell !== (lastElementHereRow || selectedCell.element)) cell.classList.toggle('selected');
                    });     

                    setMoveRow(curr => !curr);
                    setMoveColumn(false);
                    setLastMove(curr => curr === "row" ? "" : "row");

                    lastElementHereRow = lastElementHereRow || selectedCell.element;   
                }
            }

            if (!e.ctrlKey && !e.metaKey && e.key.toLowerCase() === "c" && !nameSignMenu) {
                if (selectedCell) {
                    const { x, y } = selectedCell;  
                    const cellsFromRow = document.querySelectorAll(`.cell[row="${x}"]`);
                    cellsFromRow.forEach((cell : any) => {
                        if (cell !== (lastElementHereColumn || selectedCell.element)) {
                            cell.classList.toggle('selected');
                        }
                    });     

                    setMoveColumn(curr => !curr);
                    setMoveRow(false);

                    setLastMove(curr => curr === "column" ? "" : "column");

                    lastElementHereColumn = lastElementHereColumn || selectedCell.element;   
                }
            }
            

            if (!e.ctrlKey && !e.metaKey && e.key === "ArrowUp" && !copiedElement && !cuttedElement && !multipleSelectedCells && !moveColumn && !nameSignMenu) {
                const selectedCells : any = document.querySelectorAll(`.cell.selected`);
                if (selectedCells?.length > 1 && [...selectedCells]?.every((cell) => Number(cell.getAttribute("column")) > 0)) {
                    selectedCells.forEach((cell : any) => {
                        const currentSign : { x: number, y: number, names: Array<any>, page: number, flip: number, texts: any, signColor: string | null, signPosition: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number, page: number }) => sign.x === Number(cell.getAttribute("row")) && sign.y === Number(cell.getAttribute("column")) && sign.page === page);
                        if (currentSign) {
                            removeSign(currentSign.x, currentSign.y - 1, currentSign.page);
                            addSign(currentSign.x, currentSign.y - 1, currentSign.page, currentSign.names, currentSign?.flip, currentSign?.texts, currentSign?.signColor, currentSign?.signPosition);
                            const newCell = document.querySelector(`.cell[row="${currentSign.x}"][column="${currentSign.y - 1}"]`);
                            newCell?.classList.add("selected");
                        }
                       
                    });

                    selectedCells.forEach((cell : any) => {
                        const currentSign : { x: number, y: number, names: Array<any>, page: number, flip: number, texts: any, signColor: string | null, signPosition: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number, page: number }) => sign.x === Number(cell.getAttribute("row")) && sign.y === Number(cell.getAttribute("column")) && sign.page === page);
                        if (currentSign) removeSign(currentSign.x, currentSign.y, currentSign.page);
                        cell.classList.remove("selected");
                    });

                    // document.querySelectorAll(".cell").forEach(cell => cell.classList.remove("selected"));
                    removeSelectedCell();
                    removeSelectedSign();
                    // lastElementHereColumn = lastElementHereColumn || selectedCell.element;   
                }
            }

            if (!e.ctrlKey && !e.metaKey && e.key === "ArrowDown" && !copiedElement && !cuttedElement && !multipleSelectedCells && !moveColumn && !nameSignMenu) {
                const selectedCells : any = document.querySelectorAll(`.cell.selected`);
                if (selectedCells?.length > 1 && [...selectedCells]?.every((cell) => Number(cell.getAttribute("column")) < COLUMNS - 1)) {
                    selectedCells.forEach((cell : any) => {
                        const currentSign : { x: number, y: number, names: Array<any>, page: number, flip: number, texts: any, signColor: string | null, signPosition: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number, page: number }) => sign.x === Number(cell.getAttribute("row")) && sign.y === Number(cell.getAttribute("column")) && sign.page === page);
                        if (currentSign) {
                            removeSign(currentSign.x, currentSign.y + 1, currentSign.page);

                            addSign(currentSign.x, currentSign.y + 1, currentSign.page, currentSign.names, currentSign?.flip, currentSign?.texts, currentSign?.signColor, currentSign?.signPosition);
                            const newCell = document.querySelector(`.cell[row="${currentSign.x}"][column="${currentSign.y + 1}"]`);
                            newCell?.classList.add("selected");
                        }
                        
                    });

                    selectedCells.forEach((cell : any) => {
                        const currentSign : { x: number, y: number, names: Array<any>, page: number, flip: number, texts: any, signColor: string | null, signPosition: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number, page: number }) => sign.x === Number(cell.getAttribute("row")) && sign.y === Number(cell.getAttribute("column")) && sign.page === page);
                        if (currentSign) removeSign(currentSign.x, currentSign.y, currentSign.page);
                        cell.classList.remove("selected");
                    });

                    removeSelectedCell();
                    removeSelectedSign();
                    // lastElementHereColumn = lastElementHereColumn || selectedCell.element;   
                }
            }

            if (!e.ctrlyKey && !e.metaKey && e.key.toLowerCase() === "s" && !moveColumn && !moveRow && !copiedElement && !nameSignMenu) {

                removeSelectedCell();
                removeSelectedSign();
                document.querySelectorAll(".cell.selected").forEach(cell => cell.classList.remove("selected"));

                if (multipleSelectedCells) {
                    setMultipleSelectedCells(false);
                    return;
                }
                
                setMultipleSelectedCells(true);

            }

            // Column shortcuts

            if (!e.ctrlKey && !e.metaKey && e.key === "ArrowLeft" && !copiedElement && !cuttedElement && !multipleSelectedCells && !moveRow && !nameSignMenu) {
                const selectedCells : any = document.querySelectorAll(`.cell.selected`);
                if (selectedCells?.length > 1 && [...selectedCells]?.every((cell) => Number(cell.getAttribute("row")) > 0)) {
                    selectedCells.forEach((cell : any) => {
                        const currentSign : { x: number, y: number, names: Array<any>, page: number, flip: number, texts: any, signColor: string | null, signPosition: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number, page: number }) => sign.x === Number(cell.getAttribute("row")) && sign.y === Number(cell.getAttribute("column")) && sign.page === page);
                        if (currentSign) {
                            removeSign(currentSign.x - 1, currentSign.y, currentSign.page);
                            addSign(currentSign.x - 1, currentSign.y, currentSign.page, currentSign.names, currentSign?.flip, currentSign?.texts, currentSign?.signColor, currentSign?.signPosition);
                            const newCell = document.querySelector(`.cell[row="${currentSign.x - 1}"][column="${currentSign.y}"]`);
                            newCell?.classList.add("selected");
                        }
                       
                    });

                    selectedCells.forEach((cell : any) => {
                        const currentSign : { x: number, y: number, names: Array<any>, page: number, flip: number, texts: any, signColor: string | null, signPosition: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number, page: number }) => sign.x === Number(cell.getAttribute("row")) && sign.y === Number(cell.getAttribute("column")) && sign.page === page);
                        if (currentSign) removeSign(currentSign.x, currentSign.y, currentSign.page);
                        cell.classList.remove("selected");
                    });

                    // document.querySelectorAll(".cell").forEach(cell => cell.classList.remove("selected"));
                    removeSelectedCell();
                    removeSelectedSign();
                    // lastElementHereColumn = lastElementHereColumn || selectedCell.element;   
                }
            }

            if (!e.ctrlKey && !e.metaKey && e.key === "ArrowRight" && !copiedElement && !cuttedElement && !multipleSelectedCells && !moveRow && !nameSignMenu) {
                const selectedCells : any = document.querySelectorAll(`.cell.selected`);
                if (selectedCells?.length > 1 && [...selectedCells]?.every((cell) => Number(cell.getAttribute("rows")) < ROWS - 1)) {
                    selectedCells.forEach((cell : any) => {
                        const currentSign : { x: number, y: number, names: Array<any>, page: number, flip: number, texts: any, signColor: string | null, signPosition: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number, page: number }) => sign.x === Number(cell.getAttribute("row")) && sign.y === Number(cell.getAttribute("column")) && sign.page === page);
                        if (currentSign) {
                            removeSign(currentSign.x + 1, currentSign.y, currentSign.page);
                            addSign(currentSign.x + 1, currentSign.y, currentSign.page, currentSign.names, currentSign?.flip, currentSign?.texts, currentSign?.signColor, currentSign?.signPosition);
                            const newCell = document.querySelector(`.cell[row="${currentSign.x + 1}"][column="${currentSign.y}"]`);
                            newCell?.classList.add("selected");
                        }
                        
                    });

                    selectedCells.forEach((cell : any) => {
                        const currentSign : { x: number, y: number, names: Array<any>, page: number, flip: number, texts: any, signColor: string | null, signPosition: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number, page: number }) => sign.x === Number(cell.getAttribute("row")) && sign.y === Number(cell.getAttribute("column")) && sign.page === page);
                        if (currentSign) removeSign(currentSign.x, currentSign.y, currentSign.page);
                        cell.classList.remove("selected");
                    });

                    removeSelectedCell();
                    removeSelectedSign();
                    // lastElementHereColumn = lastElementHereColumn || selectedCell.element;   
                }
            }
        
        };

    
        window.addEventListener("keydown", keyDownEvent);

        return () => {
            window.removeEventListener("keydown", keyDownEvent);
        };

    }, [copiedElement, cuttedElement, nameSignMenu, signs, moveColumn, moveRow, multipleSelectedCells]);

    useEffect(() => {
    }, [copiedElement]);


    const addSignPressed = () => {
        setFirstEmptyCell(gotoFirstEmptyCell());
        changeEditMenu(false);
        changeOpenMenu(false);
        changeAddSignMenu(true);
    };


    const [lastElementX, setLastElementPosX] = useState(0);
    const [lastElementY, setLastElementPosY] = useState(0);
    const [lastElementPage, setLastElementPage] = useState(1);


    const addedSign = (element : { realSource: Array<string>, align: string | null }, flip : number = 0) => {

        const currCellSelected : any = document.querySelector(".cell.selected");
        const x = Number(currCellSelected?.getAttribute("row") || "-1");
        const y = Number(currCellSelected?.getAttribute("column") || "-1");

        const currX = Number(x) !== -1 ? Number(x) : currentSelectedCell?.x != null ? currentSelectedCell?.x : (lastElementX + 1 >= COLUMNS && lastElementY + 1 >= ROWS ? -1 : lastElementX + 1 >= COLUMNS ? 0 : lastElementX + 1);
        const currY = Number(y) !== -1 ? Number(y) : currentSelectedCell?.y != null ? currentSelectedCell?.y : (lastElementX + 1 >= COLUMNS && lastElementY + 1 >= ROWS ? -1 : lastElementX + 1 >= COLUMNS ? lastElementY + 1 : lastElementY);
        const currPage = page || lastElementPage;
        if (currX !== -1 && currY !== -1) {
            // removeSign(currX, currY, currPage);

            element.realSource.forEach((source : any, idx : number) => {
                // console.log(source);
                if (element?.align === "vertical") addSign(currX, currY + idx, currPage, [ { name: source, flip } ], 0, []);
                else if (element?.align === "same-cell") addSign(currX, currY, currPage, [ { name: source, flip } ], 0, []);
                else addSign(currX - idx, currY, currPage, [ { name: source, flip } ], 0, []);
            });

            setLastElementPosX(currX);
            setLastElementPosY(currY);
            setLastElementPage(currPage);
            document.querySelectorAll(".cell.selected").forEach(cell => cell.classList.remove("selected"));
        }

        // if (currentSelectedCell) {
        //     element.realSource.forEach((source : any, idx : number) => {
        //         addSign(currentSelectedCell.x - idx, currentSelectedCell.y, currentSelectedCell.page, source, 0, []);
        //     });
        // } else if (firstEmptyCell) element.realSource.forEach((source : any, idx : number) => {
        //     addSign(firstEmptyCell.x - idx, firstEmptyCell.y, firstEmptyCell.page, source, 0, []);
        // });

        document.body.classList.add("grid-body");
        document.querySelector("html")?.classList.add("grid-body");

        removeSelectedCell();
        removeSelectedSign();
        // changeAddSignMenu();
        const newPageElement : any = document.querySelector(".new-page");
        if (newPageElement) newPageElement.style.display = 'flex';

    };

    const [currentImages, setCurrentImages] = useState<Array<any>>([]);

    const activateEditName = () => {
        if (!texts.length) setTexts((currTexts : any) => [...currTexts, {}]);
        const currentSign : { x: number, y: number, names: Array<any>, page: number, flip: number, texts: any, signColor: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number, page: number }) => sign.x === selectedCell.x && sign.y === selectedCell.y && sign.page === page);
        setCurrentImages(currentSign?.names || []);
        setNameSignMenu(true);
    };

    const removeTextRow = (idx : number) => {
        setTexts((currTexts : any) => currTexts.filter((text : any, index : number) => index !== idx));
    };

    const replaceSignPressed = (x: number, y: number) => {

    };

    const removeDefect = (target: any) => {
        setDefects(currDefects => currDefects.filter(defect => defect.element !== target));
        target.classList.remove("defect");
    };

    const createDefect = (target: any, type: string, screwPerc : number | null = null) => {
        setDefects(currDefects => [...currDefects, { element: target, type, screw: screwPerc }]);
        target.classList.add("defect");
    };

    const startSessionTeacher = async () => {


        const currentDefects = defects.map((defect) => {
            return {
                type: defect.type,
                point: Number(defect.element.querySelector("p").innerText || '1'),
                problem: true,
                screw: defect?.screw
            }
        });

        try {
            console.log({
                userId: data.userData.userId,
                number: debugSchemeNumber,
                problems: currentDefects
            });

            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    userId: data.userData.userId,
                    number: debugSchemeNumber,
                    problems: currentDefects
                })
            };


            const request = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/session/create-session`, options);
            const response = await request.json();
            
            if (response.success) window.location.replace(`/session/${response.sessionId}/${debugSchemeNumber}/0`);


        } catch (e) {
        }
    };

    const finishSessionStudent = async () => {

        const options = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                sessionId: sessionId,
                teacherId: data.userData.type === "teacher" ? data.userData.userId : data.userData.teacherId,
                studentId: data.userData.userId
            })
        };

        try {
            const request = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/session/finish-session-student`, options);
            const response = await request.json();
            if (response.success) window.location.replace(`/session/${sessionId}/leaderboard`);

        } catch (e) {
        }
    };

    useEffect(() => {
        if (isTeacher || !sessionId || category !== "2" || !sessionData) return;
        (async () => {
            if (isTeacher || !sessionId || category !== "2" || !sessionData) return;
            const options = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    teacherId: data.userData.type === "teacher" ? data.userData.userId : data.userData.teacherId,
                    studentId: data.userData.userId,
                    currResults: defectsResponse,
                    currProblemsSolved: problemsSolved,
                    currNotes: notes,
                    currLogs: logs,
                    sessionId
                })
            };
    
            try {
                const request = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/session/edit-session-student`, options);
                const response = await request.json();
    
                if (!response.success) {
                    // Something to happen when update fails
                } else console.log("Updated data!");
            } catch (e) {
            }
        })();
    }, [defectsResponse, problemsSolved, notes, logs]);

    useEffect(() => console.log(defects), [defects]);

    useEffect(() => {

        const currSolved = schemeStructure.filter((element : { solved: boolean }) => element?.solved);
        setProblemsSolved(currSolved.map((element: { dotNumber: number, defect: string }) => {
            return {
                name: element.dotNumber,
                type: element.defect
            };
        }));

        const currDefects = schemeStructure.filter((element : { defect: string | null }) => element?.defect);
        setDefectsResponse(currDefects.map((element: { dotNumber: number, defect: string }) => {
            return {
                name: element.dotNumber,
                type: element.defect
            };
        }));

    }, [schemeStructure]);

    const getDotData = (dot : any) => {
        const dotNumber = typeof dot === "number" ? "1" : Number(dot.querySelector("p")?.innerText || "1");
        return schemeStructure.find((element: { dotNumber: number }) => element.dotNumber === dotNumber || element.dotNumber === dot);
    };

    const getDotDataAlteredPoints = (currDot: any) => {
        let dotNumber = -1;
     
        document.querySelectorAll(".dot").forEach((dot : any) => {
            if (Number(dot.getAttribute("point")) === Number(currDot)) dotNumber = Number(dot.querySelector("p").innerText || "-1") 
        });
        return schemeStructure.find((element: { dotNumber: number }) => element.dotNumber === dotNumber);
    };

    useLayoutEffect(() => {
        if (isTeacher) return;
        if (!buzzerSoundRef.current) return;
        if (activeDots?.length !== 2) {
            if (deviceActiveOption !== "off") setDeviceValue("ON");
            else setDeviceValue("");
            buzzerSoundRef.current.pause();
            buzzerSoundRef.current.currentTime = 0;
            return;
        }
        const tension = checkTension();
        const continuity = checkContinuity();
        if (deviceActiveOption === "acv-200" && tension) {
            // Somehow animation for burning measurement device
            setDeviceValue("ERROR!");
        }

        else if (deviceActiveOption === "acv-750") {
            const activeDotIData = getDotData(activeDots[0]);
            const activeDotIIData = getDotData(activeDots[1]);
            if (tension) {
                setDeviceValue(`${Math.abs((activeDotIData?.potential !== null ? activeDotIData?.potential : 230) - (activeDotIIData?.potential !== null ? activeDotIIData?.potential : 0)) < 3 ? Math.max((activeDotIData?.potential !== null ? activeDotIData?.potential : 230), (activeDotIIData?.potential !== null ? activeDotIIData?.potential : 0)) : Math.abs((activeDotIData?.potential !== null ? activeDotIData?.potential : 230) - (activeDotIIData?.potential !== null ? activeDotIIData?.potential : 0))} V`);
            }
            else setDeviceValue("0V");
        }

        else if (deviceActiveOption === "continuity-10k") setDeviceValue(continuity ? 1 : 0);
        else if (deviceActiveOption === "buzzer") {
            setDeviceValue("ON");
            if (continuity) {
                buzzerSoundRef.current.volume = 0.25;
                buzzerSoundRef.current.play();
            } else {
                buzzerSoundRef.current.pause();
                buzzerSoundRef.current.currentTime = 0;
            }
        }
        else setDeviceValue("ON");

    }, [activeDots, deviceActiveOption, schemeStructure]);

    const findNeighbour = (dotNumber: number) : number | null => {
        const dot = Array.from(document.querySelectorAll(".dot")).find((dot : any) => Number(dot.querySelector("p").innerText || "-1") === dotNumber);
        if (!dot) return null;
        if (dot.classList.contains("left-max") || dot.classList.contains("right")) return dotNumber - 1;
        if (dot.classList.contains("left") || dot.classList.contains("right-max")) return dotNumber + 1;
        return -1;
    };

    const solveDefect = (dotNumber: number, defectType: string) : boolean => {
        if (isTeacher) return false;


        const currentDot = schemeStructure.find((element: { dotNumber: number }) => element.dotNumber === dotNumber);
        const problem = problems.some(problem => problem.point === dotNumber && problem.type === defectType);
        if (!currentDot) return false;

     
        if ((defectType === currentDot?.defect) || problem) {
            if (defectType !== "Scurt circuit") changeSolvedSchemeStructure(dotNumber, true);
            if (defectType === "Scurt circuit") removeShortCircuitRoute(true);
            
            return true;
        }
        setLogs(currLogs => [...currLogs, cookies?.language === "en" ? `Mistake: Solving dot's number ${dotNumber} with defect's type ${defectType}.` : `Greseala: Rezolvarea punctului cu numarul ${dotNumber} cu defectul de tip ${defectType}.`]);

        return false;
    };

    const nextElement = (dotNumber: number) => {
        let currIdx : number = -1;
        schemeStructure.forEach((element: any, idx : number) => {
            if (dotNumber === element.dotNumber) currIdx = idx + 1;
        });

        if (schemeStructure?.[currIdx] && schemeStructure?.[currIdx]?.dotNumber !== 500) return schemeStructure?.[currIdx]?.dotNumber;
        return -1;

    };

    const compareDotIdx = (dot1 : number, dot2 : number, type : string) => {
        let dot1Idx = -1, dot2Idx = -1;

        schemeStructure.forEach((element : { dotNumber: number }, idx : number) => {
            if (element.dotNumber === dot1) dot1Idx = idx;
            if (element.dotNumber === dot2) dot2Idx = idx;
        });

        if (type === 'smaller') return dot1Idx < dot2Idx ? dot1 : dot2;
        if (type === 'bigger') return dot1Idx > dot2Idx ? dot1 : dot2;
        return dot1;
    };

    const isBranchLine = (line1 : string, line2 : string) : boolean => {
        if ((line1.includes(`${line2}(`) && line1.at(-1) === ")") || (line2.includes(`${line1}(`) && line2.at(-1) === ")")) return true;
        return false;
    };
    

    const checkTension = () : boolean => {
        if (isTeacher) return false;

        if (!schemeStructure) return false;
        if (activeDots?.length !== 2) return false;
        const firstActiveDot = activeDots[0];
        const secondActiveDot = activeDots[1];
        const firstActiveDotNumber = Number(firstActiveDot?.querySelector("p")?.innerText || 0);
        const secondActiveDotNumber = Number(secondActiveDot?.querySelector("p")?.innerText);
        let firstActiveDotIdx : number = -1, secondActiveDotIdx : number = -1;
        const firstActiveDotScheme = schemeStructure.find((element : { line: string, dotNumber: number }, idx : number) => {
            const value = element.dotNumber === firstActiveDotNumber;
            if (value) firstActiveDotIdx = idx;
            return value;
        });

        const secondActiveDotScheme = schemeStructure.find((element : { line: string, dotNumber: number }, idx : number) => {
            const value = element.dotNumber === secondActiveDotNumber;
            if (value) secondActiveDotIdx = idx;
            return value;
        });

        if (firstActiveDotScheme?.line === secondActiveDotScheme?.line || isBranchLine(firstActiveDotScheme?.line, secondActiveDotScheme?.line)) return false;
        // let schemeStructureReverse = schemeStructure;
        // schemeStructureReverse.reverse();

        
        const elementsInLineFirst = [firstActiveDotScheme];
        const elementsInLineSecond = [secondActiveDotScheme];
        let copyFirstIdx = firstActiveDotIdx, copySecondIdx = secondActiveDotIdx;

        while (copyFirstIdx >= 0 && schemeStructure[copyFirstIdx - 1]?.dotNumber !== 500 && (schemeStructure[copyFirstIdx - 1]?.line === firstActiveDotScheme.line || (schemeStructure[copyFirstIdx - 1]?.line ? isBranchLine(schemeStructure[copyFirstIdx - 1]?.line, firstActiveDotScheme.line) : false))) {
            elementsInLineFirst.unshift(schemeStructure[copyFirstIdx - 1]);
            copyFirstIdx--;
        }

        copyFirstIdx = firstActiveDotIdx;

   
        while (copySecondIdx >= 0 && schemeStructure[copySecondIdx - 1]?.dotNumber !== 500 && (schemeStructure[copySecondIdx - 1]?.line === secondActiveDotScheme.line || (schemeStructure[copySecondIdx - 1]?.line ? isBranchLine(schemeStructure[copySecondIdx - 1]?.line, secondActiveDotScheme.line) : false))) {
            elementsInLineSecond.unshift(schemeStructure[copySecondIdx - 1]);
            copySecondIdx--;
        }

        copySecondIdx = secondActiveDotIdx;

  

        
        const continuityFirst = checkContinuity(compareDotIdx(elementsInLineFirst[0]?.dotNumber, elementsInLineFirst[elementsInLineFirst.length - 1]?.dotNumber, 'smaller'), compareDotIdx(elementsInLineFirst[0]?.dotNumber, elementsInLineFirst[elementsInLineFirst.length - 1]?.dotNumber, 'bigger'));
        const continuitySecond = checkContinuity(compareDotIdx(elementsInLineSecond[0]?.dotNumber, elementsInLineSecond[elementsInLineSecond.length - 1]?.dotNumber, 'smaller'), compareDotIdx(elementsInLineSecond[0]?.dotNumber, elementsInLineSecond[elementsInLineSecond.length - 1]?.dotNumber, 'bigger'));
        return continuityFirst && continuitySecond;
    };

    useEffect(() => {
    }, [problems]);

    const checkContinuity = (firstDot : number | null = null, lastDot : number | null = null) : boolean => {
        if (!schemeStructure) return false;
        const firstActiveDot = activeDots?.[0];
        const secondActiveDot = activeDots?.[1];

        const firstActiveDotNumber = firstDot !== null ? firstDot : Number(firstActiveDot?.querySelector("p")?.innerText || 0);
        const secondActiveDotNumber = lastDot !== null ? lastDot : Number(secondActiveDot?.querySelector("p")?.innerText || 0);
        const firstActiveDotScheme = schemeStructure.find((element : { line: string, dotNumber: number }) => element.dotNumber.toString() === firstActiveDotNumber.toString());
        const secondActiveDotScheme = schemeStructure.find((element : { line: string, dotNumber: number }) => element.dotNumber.toString() === secondActiveDotNumber.toString());
        const firstPotential =  (firstActiveDotScheme?.potential == null ? 20 : firstActiveDotScheme?.potential);
        const secondPotential = (secondActiveDotScheme?.potential == null ? 0 : secondActiveDotScheme?.potential);
        if (firstActiveDotScheme?.line !== secondActiveDotScheme?.line && !isBranchLine(firstActiveDotScheme?.line, secondActiveDotScheme?.line) && (Math.abs(firstPotential - secondPotential) >= 20 || (Math.abs(firstPotential - secondPotential) < 3))) return false;
        let startCheck : boolean = false;

        let firstActiveDotIdx : number = -1, secondActiveDotIdx = -1;
        schemeStructure.forEach((element : { dotNumber: number }, idx : number) => {
            if (element.dotNumber === firstActiveDotNumber && firstActiveDotIdx === -1) firstActiveDotIdx = idx;
            if (element.dotNumber === secondActiveDotNumber && secondActiveDotIdx === -1) secondActiveDotIdx = idx;
        });
        

        if (firstActiveDotIdx === -1 || secondActiveDotIdx === -1) return false;

        const filteredSchemeStructure = schemeStructure.filter((element : { dotNumber: number, line: number}, idx : number) => {
            if (element.line !== schemeStructure[firstActiveDotIdx].line && element.line !== schemeStructure[secondActiveDotIdx].line) return false;
            return ((firstActiveDotNumber % 4 === 3 ? idx >= firstActiveDotIdx : idx >= firstActiveDotIdx) && (secondActiveDotNumber % 4 === 2 ? idx <= secondActiveDotIdx : idx <= secondActiveDotIdx));
        });

        return filteredSchemeStructure.every((element: { line: string, open: boolean, dotNumber: number, defect: string | null, screw: number, solved: boolean }) => {
           
            return (!element.open || (element?.line === "Nul protectie" )) && (element.defect !== "Lipsa tensiune" || element.solved) && (problems.every(problem => problem.type !== "Lipsa tensiune" || problem.point !== element.dotNumber) || element.solved) && element.screw > .5;        
        });
        
    };

    // Device drag

    const startDragDevice = (e: any) => {
       
        if (!deviceScreenRef?.current) return;
        setDeviceDrag(true);
        // console.log("e");
        deviceScreenRef.current.style.bottom = `initial`;
        deviceScreenRef.current.style.right = `initial`;
        deviceScreenRef.current.style.left = `${e.clientX - 75}px`;
        deviceScreenRef.current.style.top = `${e.clientY - 50}px`;

    };

    const moveDragDevice = (e : any) => {
        if (!deviceDrag) return;
        if (!deviceScreenRef?.current) return;

        deviceScreenRef.current.style.left = `${e.clientX - 75}px`;
        deviceScreenRef.current.style.top = `${e.clientY - 50}px`;

    };

    const endDragDevice = (e : any) => {
        if (!deviceDrag) return;
        const target = e.target;
        if (!deviceScreenRef.current) return;
        // deviceScreenRef.current.style.left = `initial`;
        // deviceScreenRef.current.style.top = `initial`;
        // deviceScreenRef.current.style.right = `15px`;
        // deviceScreenRef.current.style.bottom = `10px`;
        setDeviceDrag(false);
    };
  
    useEffect(() => {

        const scrollEvent = () => {
            if (Math.abs(window.scrollX - scrollX) >= 0) setScrollX(window.scrollX);
            if (Math.abs(window.scrollY - scrollY) >= 0) setScrollY(window.scrollY);
        };

        window.addEventListener("scroll", scrollEvent);
        return () => window.removeEventListener("scroll", scrollEvent);
    }, []);

    const htmlElement : any = useMemo(() => document.querySelector("html"), []);

    const getDotNumber = (dot : any) : number => {
        return Number(dot.querySelector("p")?.innerText || 0);
    };

    const getSelectedDots = () => {
        return Array.from(document.querySelectorAll(".dot")).filter(dot => dot.classList.contains("activated"));
    };

    const isShortCircuitRoute = () => {
        const selectedDots = getSelectedDots();
        if (selectedDots.length > 1) return;
        const selectedDot : any = selectedDots[0];
        return (selectedDot?.querySelector(".shortcircuit-line") ? true : false);
    };

    const getLastElement = (dotNumber : number) => {
        let start = false;
        for (let elementIdx : number = initialSchemeStructure.length - 1; elementIdx >= 0; elementIdx--) {
            const element = schemeStructure[elementIdx];
            if (element.dotNumber === dotNumber) start = true;
            if (start) {
                if (element.line !== "Nul protectie" && element.line !== "PE") return element;
            }
        }

        return null;
    };

    const isSameDefect = (currDotNumber : number, defectDotNumber : number) => {
        let currDotNumberIdx = -1, defectDotNumberIdx = -1;

        schemeStructure.forEach((elem : { dotNumber: number }, idx : number) => {
            if (elem.dotNumber === currDotNumber) currDotNumberIdx = idx;
            if (elem.dotNumber === defectDotNumber) defectDotNumberIdx = idx;
        });

        for (let idx = Math.min(currDotNumberIdx, defectDotNumberIdx); idx <= Math.max(currDotNumberIdx, defectDotNumberIdx); idx++) {
            if (schemeStructure[idx]?.dotNumber === 500 || schemeStructure[idx]?.line !== schemeStructure[defectDotNumberIdx]?.line) return false;
        }
        

        return true;
    };
 
    const removeShortCircuitRoute = (fromStudent = false) => {
        const selectedDots = getSelectedDots();
        if (selectedDots.length > 1) return;
        const selectedDot : any = selectedDots[0];
        const shortcircuitLine = selectedDot.querySelector(".shortcircuit-line");
        if (!fromStudent) selectedDot.removeChild(shortcircuitLine);
        const dotNumber : number = Number(selectedDot.querySelector("p").innerText || "1");

        if (!fromStudent) {
            setDefects(currDefects => currDefects.filter((defect : any) => Number(defect.element.querySelector("p").innerText || "1") !== dotNumber));
        }
        
        let last500DotIdx = -1;
        schemeStructure.forEach((element : { dotNumber: number }, idx : number) => element.dotNumber === 500 ? last500DotIdx = idx : null);
        const unfilteredScheme = schemeStructure.map((element : { dotNumber: number, line: string, solved: boolean }, idx: number) => {
            if (idx !== last500DotIdx && element.dotNumber === 500) return null;
            if (isSameDefect(element?.dotNumber, dotNumber) && element.line === "Nul protectie" && element.dotNumber !== 500) return {...element,
                line: getLastElement(element.dotNumber)?.line,
                potential: getLastElement(element.dotNumber)?.potential,
                solved: element.dotNumber === dotNumber ? true : element.solved
            };

            return element;
        });

        
        changeSchemeStructure(unfilteredScheme.filter((element : any) => element !== null));
    };

    const possibleShortCircuitRoute = () => {

    };

    const createShortCircuitRoute = () => {
        const selectedDots = getSelectedDots();
        if (selectedDots.length > 1) return;
        const selectedDot : any = selectedDots[0];
        const element = selectedDot.parentElement;
        const elementRow = Number(element.getAttribute("row"));
        const elementColumn = Number(element.getAttribute("column"));

        const shortCircuitLine = document.createElement("div");
        shortCircuitLine.classList.add("shortcircuit-line");
        shortCircuitLine.style.position = 'absolute';
        shortCircuitLine.style.width = '800%';
        shortCircuitLine.style.height = '5px';
        shortCircuitLine.style.background = 'linear-gradient(135deg, rgb(254,161,0), rgb(77,181,59))';


        let addedConductor = false;

        if (findSignObject(elementRow, elementColumn - 1)?.names?.some((name : { name: string }) => name?.name?.includes("conductor_lung_protectie"))) {
            // Create conductor down
            shortCircuitLine.classList.add("conductor-down");
            shortCircuitLine.style.left = '50%';
            shortCircuitLine.style.transform = 'translateX(-50%) rotateZ(90deg) scale(1)';
            shortCircuitLine.style.top = '-425%';
            addedConductor = true;
        } else if (findSignObject(elementRow, elementColumn + 1)?.names?.some((name : { name: string }) => name?.name?.includes("conductor_lung_protectie"))) {
            // Create conductor up
            shortCircuitLine.classList.add("conductor-up");
            shortCircuitLine.style.left = '50%';
            shortCircuitLine.style.transform = 'translateX(-50%) rotateZ(90deg) scale(1)';
            shortCircuitLine.style.top = '425%';
            addedConductor = true;

        } else if (findSignObject(elementRow - 1, elementColumn)?.names?.some((name : { name: string }) => name?.name?.includes("conductor_lung_protectie"))) {
            // Create conductor left
            shortCircuitLine.classList.add("conductor-left");
            shortCircuitLine.style.left = '-800%';
            shortCircuitLine.style.transform = 'translateY(-50%) scale(1)';
            shortCircuitLine.style.top = '50%';
            addedConductor = true;

        } else if (findSignObject(elementRow + 1, elementColumn)?.names?.some((name : { name: string }) => name?.name?.includes("conductor_lung_protectie"))) {
            // Create conductor right
            shortCircuitLine.classList.add("conductor-right");
            shortCircuitLine.style.left = '100%';
            shortCircuitLine.style.transform = 'translateY(-50%) scale(1)';
            shortCircuitLine.style.top = '50%';
            addedConductor = true;

        }

        if (!addedConductor) return;

        selectedDot.appendChild(shortCircuitLine);

        const dotNumber = Number(selectedDot.querySelector("p").innerText || "1");
        const line = schemeStructure.find((element: { dotNumber: number }) => element.dotNumber === dotNumber)?.line;

        if (isTeacher) {
            setDefects(currDefects => [...currDefects, {
                element: selectedDot,
                type: "Scurt circuit",
                screw: null
            }]);

            let currIdx : number = -1;
            const newSchemeStructure = [];
            for (let idx = 0; idx < schemeStructure.length; idx++) {
                if (schemeStructure[idx].dotNumber === dotNumber) {
                    currIdx = idx;
                    break;
                } else newSchemeStructure.push(schemeStructure[idx]);
            }

            if (currIdx === -1) return;

            newSchemeStructure.push({
                dotNumber: 500,
                line: "Nul protectie",
                defect: null,
                screw: 1,
                solved: false,
                potential: Number(schemeNumber) === 1 ? 3 : 173,
                open: false
            });

            
            for (let idx = currIdx; idx < schemeStructure.length; idx++) {
                const element = schemeStructure[idx];
                if (element.dotNumber >= dotNumber && element.line === line) 
                    newSchemeStructure.push({...element,
                        line: "Nul protectie",
                        potential: Number(schemeNumber) === 1 ? 3 : 173
                    });
                else newSchemeStructure.push(element);
            }

            changeSchemeStructure(newSchemeStructure);
        }

    };

    const scrollVisible = () => {
        return document.body.scrollHeight > document.body.clientHeight || document.body.scrollWidth > document.body.clientWidth;
    };

    const isFirstElement = (currDotInit : any, interval : number) => {
        let currDot = currDotInit;
        while (!currDot.classList.contains("dot")) currDot = currDot.parentElement;
        const dotNumber = Number(currDot?.querySelector("p").innerText || "1");
        for (let idx = 0; idx < schemeStructure.length; idx++) {
            const element = schemeStructure[idx];
            if (element.dotNumber === dotNumber) { 
                if (idx < interval) return true;
                
                if (schemeStructure[idx - interval].line !== element.line && !isBranchLine(schemeStructure[idx - interval].line, element.line) && element.line !== "Nul protectie" && element.line !== "PE") return true;
                else return false;
            }
        }

        return false;
    };  

    const [activeCheckElectricity, setActiveCheckElectricity] = useState<boolean>(false);

    const checkElectricity = () => {
        if (!activeCheckElectricity) return;
        if (category?.toString() !== "0") return;

    };

    const checkElectricityPredefinedScheme = () => {
        if (!activeCheckElectricity) return;
        if (category?.toString() === "0") return;
        
    };

    const [ rightClicked, setRightClicked, rightClickPoints, setRightClickPoints ] = useContextMenu();

    const scenarioPaperRef = useRef<HTMLDivElement>(null);
    const [activeGuide, setActiveGuide] = useState<boolean>(category === "2" ? true : false);
    const [activeStep, setActiveStep] = useState<number | null>(null);

    let doubleClickScreenCounter : number = 0;  

    const handleAddPage = () => {
        
    };

    const [startAddDrag, setStartAddDrag] = useState<boolean>(false);
    const [startAddDragFlip, setStartAddDragFlip] = useState<number>(0);
    const [counterPage, setCounterPage] = useState<number>(page);

    const changeCounterPage = (e : any) => {
        setCounterPage(e.target.value);
    };

    const gotoPage = () => {
        if (counterPage >= 1 && counterPage <= (totalPages || 1) && counterPage !== page) {
        
            window.history.pushState(window.history.state, "", `/project/${projectId}/${counterPage - 1}`);
            window.location.reload();
        }
    };

    useEffect(() => {
        
        if (!rightClicked || !selectedCell) return;
        
        const handleClick =  (e : any) => {
            let target = e.target;


            while (!target?.classList?.contains("right-menu-icon"))
                target = target?.parentElement;


            if (target?.classList?.contains("rotate-left")) {
            
                if (selectedCell?.x === undefined || selectedCell?.y === undefined) return;
                flipSign(isSelected.x, isSelected.y, (isSelected.flip - 90 < 0 ? 270 : isSelected.flip - 90) % 360, isSelected.page);
                removeSelectedSign();
                changeIsSelectedSign(isSelected.x, isSelected.y, isSelected.page);
                
            } else {
                if (selectedCell?.x === undefined || selectedCell?.y === undefined) return;
                flipSign(isSelected.x, isSelected.y, (isSelected.flip + 90) % 360, isSelected.page);
                removeSelectedSign();
                changeIsSelectedSign(isSelected.x, isSelected.y, isSelected.page);
            }
        }

        const icons = document.querySelectorAll(".two-icons .right-menu-icon");

        icons.forEach(icon => {
            icon.addEventListener("click", handleClick);
        }); 

        return () => {
            icons.forEach(icon => {
                icon.removeEventListener("click", handleClick);
            }); 
        };

    }, [selectedCell, rightClicked, signs, isSelected]);

    const toggleSimulation = () => {
        setSimulation(curr => !curr);
    };

    const simulationPress = (currIdx : number, currRowIdx : number, names: Array<{ name: string }>, looped : boolean = false) => {   
        const currSign: any = findSign(currIdx, currRowIdx);     
        if (!currSign) return;

        const currSignObj: any = findSignObject(currIdx, currRowIdx);     

        const isActionable = names.some(name => name.name.includes("actionare") || name.name.includes("intreruptor_pentru_oprire_de_urgenta"));
        const isFuse = names.some(name => name.name.includes("siguranta"));
        if (!isActionable && !isFuse) return;
        
        const newNames = names.map(name => {
            if (name.name.includes("contact")) {
                let newName : string = "";
                if (name.name.includes("deschis")) newName = replaceAll(name.name, "deschis", "inchis").slice(14);
                if (name.name.includes("inchis")) newName = replaceAll(name.name, "inchis", "deschis").slice(14);
                const realNewSource = newName.split(".")[0];
                return {
                    ...name,
                    name: SCHEME_ELEMENTS[realNewSource].imageSource
                };
            } else if (name.name.includes("siguranta") && !name.name.includes("siguranta_automata")) {
                if (name.name.includes("deschisa")) return { ...name, name: SCHEME_ELEMENTS["siguranta"].imageSource };
                else return { ...name, name: SCHEME_ELEMENTS["siguranta_deschisa"].imageSource };
            } else if (name.name.includes("siguranta_automata")) {
                let newName : string = "";
                if (name.name.includes("deschis")) newName = replaceAll(name.name, "deschis", "inchis").slice(14);
                if (name.name.includes("inchis")) newName = replaceAll(name.name, "inchis", "deschis").slice(14);
                const realNewSource = newName.split(".")[0];
                return {
                    ...name,
                    name: SCHEME_ELEMENTS[realNewSource].imageSource
                };
            }

            return name;
        });


        removeSign(currIdx, currRowIdx, page);
        addSign(currIdx, currRowIdx, page, newNames, currSignObj.flip, currSignObj.texts, currSignObj.signColor || "#000", currSignObj?.signPosition || "");
        if (!looped && currSignObj.texts.some((text : { name: string }) => text.name.includes("B.p") || text.name.includes("B.o"))) {
            setTimeout(() => {
                simulationPress(currIdx, currRowIdx, newNames, true);

            }, 500);
        }
        
        setTimeout(() => document.querySelectorAll(".cell").forEach(cell => cell.classList.remove('selected')), 30);
    };

    const needsBobineChange = (currIdx : number, currRowIdx : number, names : { name: string }[], isInitialBobine : boolean) => {
        const initialSign = initialSigns.find((sign : any) => sign.x === currIdx && sign.y === currRowIdx && sign.page === page);
        const a = names.some((name, idx) => {
                if (isInitialBobine) {
                    if (initialSign.names[idx].name.includes("deschis") && name.name.includes("inchis")) return true;
                    if (initialSign.names[idx].name.includes("inchis") && name.name.includes("deschis")) return true;
                } else {
                    if (initialSign.names[idx].name.includes("deschis") && name.name.includes("deschis")) return true;
                    if (initialSign.names[idx].name.includes("inchis") && name.name.includes("inchis")) return true;
                }


                return false;
        });
        if (!a) console.log("FALSE");
        else console.log("TRUE");

        return a;

        
    };


    const simulationPressForce = (currIdx : number, currRowIdx : number, names: Array<{ name: string }>, isInitialBobine : boolean) => {  
        
        const currSignObj: any = findSignObject(currIdx, currRowIdx); 

        if (!currSignObj || !simulation) return;
        // if (fromSimulationPressForce) return;


        const initialSign = initialSigns.find((sign : any) => sign.x === currIdx && sign.y === currRowIdx && sign.page === page);
        

        const isContact = names.some(name => name.name.includes("contact") || name.name.includes("intreruptor"));
        const isFuse = names.some(name => name.name.includes("siguranta"));
        if (!isContact && !isFuse) return;

        const newNames = names.map((name, idx) => {
            if (isContact) {
                let newName : string = "";
                if (isInitialBobine) {
                    if (initialSign.names[idx].name.includes("deschis")) newName = replaceAll(name.name, "inchis", "deschis").slice(14);
                    if (initialSign.names[idx].name.includes("inchis")) newName = replaceAll(name.name, "deschis", "inchis").slice(14);
                } else {
                    if (initialSign.names[idx].name.includes("deschis")) newName = replaceAll(name.name, "deschis", "inchis").slice(14);
                    if (initialSign.names[idx].name.includes("inchis")) newName = replaceAll(name.name, "inchis", "deschis").slice(14);
                }
                
                const realNewSource = newName.split(".")[0];
                return {
                    ...name,
                    name: SCHEME_ELEMENTS[realNewSource].imageSource
                };
            } else if (name.name.includes("siguranta") && !name.name.includes("siguranta_automata")) {
                if (name.name.includes("deschisa")) return { ...name, name: SCHEME_ELEMENTS["siguranta"].imageSource };
                else return { ...name, name: SCHEME_ELEMENTS["siguranta_deschisa"].imageSource };
            } else if (name.name.includes("siguranta_automata")) {
                let newName : string = "";
                if (name.name.includes("deschis")) newName = replaceAll(name.name, "deschis", "inchis").slice(14);
                if (name.name.includes("inchis")) newName = replaceAll(name.name, "inchis", "deschis").slice(14);
                const realNewSource = newName.split(".")[0];
                return {
                    ...name,
                    name: SCHEME_ELEMENTS[realNewSource].imageSource
                };
            }

            return name;
        });

        

        fromSimulationPressForce = 1;


        removeSign(currIdx, currRowIdx, page);
        addSign(currIdx, currRowIdx, page, newNames, currSignObj.flip, currSignObj.texts, currSignObj.signColor || "#000", currSignObj?.signPosition || "");
        
       
        
        // getElectricity(false);

        setTimeout(() => document.querySelectorAll(".cell").forEach(cell => cell.classList.remove('selected')), 30);
    };

    return addSignMenu && category === "0" && false ? <SignsMenu useStore={useStore} key="0" randomCell={firstEmptyCell} isContactSigns={false} /> : true ? (
        <>
            <div 
                className="page-container" 
                ref={pageRef}
                onContextMenu={(e : any) => {
                    if (category !== "0") return;
                    if (e.target?.classList?.contains("option") || e.target?.parentElement?.classList?.contains("option") || e.target?.parentElement?.parentElement?.classList?.contains("option")) return;
                    if (e.target?.classList?.contains("shortcut") || e.target?.parentElement?.classList?.contains("shortcut")) return;
                    e.preventDefault();
                    setRightClicked(true);
                    setRightClickPoints({
                        x: e.pageX,
                        y: e.pageY
                    });
                }}
            >

                {category === "2" ? (
                    <div className="debug-container">
                        {isTeacher && defects.find(defect => defect.element === activeDot)?.screw == null ? (
                            <div className={`problem-button ${defectsButton && !isFirstElement(activeDot, 1) ? "show" : ""}`} onClick={() => {
                                if (defectsButton && !defects.find(defect => defect.element === activeDot)) {
                                    setActiveDefectsOption(true) 
                                } else if (defectsButton) {
                                    const defectType = defects.find(defect => defect.element === activeDot)?.type;
                                    if (defectType === "Scurt circuit" || defectType === "Short circuit") removeShortCircuitRoute();
                                    else removeDefect(activeDot);
                                }
                            }}>
                                <FontAwesomeIcon icon={faBug} className="bug-icon" />
                                {!defects.find(defect => defect.element === activeDot) ? <p>{cookies?.language === "en" ? "Create defect" : "Creeaza defect"}</p> : <p>{cookies?.language === "en" ? "Remove defect" : "Sterge defectul"}</p>}
                            </div>
                        ) : null}

                        <div className={`screw-button ${getSelectedDots()?.length === 1 && document?.querySelector(".dot.activated .screw-driver") ? "show" : ""}`} onClick={() => {
                            if (!(getSelectedDots()?.length === 1 && document?.querySelector(".dot.activated .screw-driver"))) return;
                            document?.querySelector(".dot.activated .screw-driver")?.parentElement?.classList.toggle("true-show");
                        }}>
                            <FontAwesomeIcon icon={faScrewdriver} className="bug-icon" />
                            <p>{cookies?.language === "en" ? "Screwdriver" : " Surubelnita"}</p> 
                        </div>
                        

                        {!isTeacher ? (
                            <div className={`problem-button solve ${getSelectedDots()?.length === 1  ? "show" : ""}`} onClick={() => {
                                setDefectsButton(true);
                                setActiveDefectsOption(true);
                            }}>
                                <FontAwesomeIcon icon={faLightbulb} className="bug-icon" style={{ fontSize: 22 }} />
                                <p>{cookies?.language === "en" ? "Solve defect" : "Rezolva defect"}</p>
                            </div>
                        ) : null}

                    
                        {/* {isTeacher ? <div className={`add-conductor ${getSelectedDots()?.length === 1 && !isFirstElement(!isTeacher ? getSelectedDots()[0] : activeDot, 2)  ? "show" : ""}`} onClick={() => {
                
                            if (isShortCircuitRoute()) removeShortCircuitRoute();
                            else createShortCircuitRoute();
                        }}>
                            <FontAwesomeIcon icon={isShortCircuitRoute() ? faTimes : faPlus} className="bug-icon" style={{ fontSize: 22 }} />
                            {isShortCircuitRoute() ? <p>{cookies?.language === "en" ? "Remove cable short-circuit" : "Sterge cablu scurt-circuit"}</p> : <p>{cookies?.language === "en" ? "Add cable short-circuit" : "Adauga cablu scurt-circuit"}</p>}
                        </div> : null} */}

                        {defectsButton && (!defects.find(defect => defect === activeDot)) && activeDefectsOption ? (
                            <div className="defects-options-container">
                                <div className="options-container">
                                    <h2>{cookies.language === "en" ? "Types of defects" : "Tipuri de defecte"}</h2>
                                    {defectsOptions.map((defectsOption: any, idx: number) => (
                                        !isFirstElement(isTeacher ? activeDot : getSelectedDots()[0], idx === 0 ? 1 : 3) && (!activeDot?.querySelector(".screw-driver-container") || idx === 1) ? <div className={`option ${activeDefectsOptionType === defectsOption ? "active" : ""}`} key={idx} onClick={(e: any) => setActiveDefectsOptionType(defectsOption)}>
                                            <div className="circle">
                                                <FontAwesomeIcon icon={faCheck} className={`circle-icon ${activeDefectsOptionType === defectsOption ? "active" : ""}`} /> 
                                            </div>
                                            <p>{defectsOption}</p>
                                        </div> : null
                                    ))}

                                    <div className="save-button" onClick={(e: any) => {
                                        const element = e.target.classList.contains("save-button") ? e.target : e.target.parentElement;
                                        element.classList.add("clicked");
                                        setTimeout(() => {
                                            const currActiveDot : any = Array.from(document.querySelectorAll(".dot")).filter((dot: any) => dot.classList.contains("activated"))[0];

                                            if (!currActiveDot) return;
                                            if (isTeacher) {
                                                if (activeDefectsOptionType === "Scurt circuit" || activeDefectsOptionType === "Short circuit") {
                                                    if (isShortCircuitRoute()) removeShortCircuitRoute();
                                                    else createShortCircuitRoute();
                                                } else createDefect(activeDot, activeDefectsOptionType);
                                            }

                                            if (!isTeacher) {
                                                if (activeDefectsOptionType === "Scurt circuit" || activeDefectsOptionType === "Short circuit") {
                                                    const neighbour = findNeighbour(Number(currActiveDot.querySelector("p").innerText || "1"))
                                                    if (neighbour !== null && neighbour !== -1) solveDefect(neighbour, activeDefectsOptionType);
                                                }
                                                solveDefect(Number(currActiveDot.querySelector("p").innerText || "1"), activeDefectsOptionType);
                                            }
                                            setActiveDefectsOption(currValue => !currValue);
                                        }, 200);
                                    }}>
                                        <p>{cookies?.language === "en" ? "Save" : "Salveaza"}</p>
                                    </div>

                                    <FontAwesomeIcon className="close-icon" icon={faTimes} onClick={() => setActiveDefectsOption(currValue => !currValue)} />
                                </div>

                            </div>
                        ) : null}

                        {defects.length > 0 || !isTeacher ? <div className="start-session-button" onClick={async () => isTeacher ? await startSessionTeacher() : await finishSessionStudent()}>
                            {isTeacher ? <p>{cookies?.language === "en" ? "Start session" : "Incepe sesiunea"}</p> : <p>{cookies?.language === "en" ? "Finish session" : "Termina sesiunea"}</p>}
                            <FontAwesomeIcon icon={faFlagCheckered} className="button-icon" />
                        </div> : null}
                    </div>

                ) : null}

                {activeGuide ? (
                    <div className="steps-guide-container">

                        <div className="close-icon-container" onClick={() => setActiveGuide(false)}>
                            <FontAwesomeIcon className="close-icon" icon={faTimes} />
                        </div>
                        
                        <h2>{cookies?.language === "en" ? "Guide of using" : "Ghid de folosire"}</h2>

                        <div className={`step ${activeStep === 1 ? "active" : ""}`} onClick={() => setActiveStep(1)}>
                            <p>1. {cookies?.language === "en" ? "Creation of a defect" : "Creearea unui defect"}</p>
                        </div>

                        <div className={`step ${activeStep === 2 ? "active" : ""}`} onClick={() => setActiveStep(2)}>
                            <p>2. {cookies?.language === "en" ? "Removing defect" : "Stergerea unui defect"}</p>
                        </div>

                        <div className={`step ${activeStep === 3 ? "active" : ""}`} onClick={() => setActiveStep(3)}>
                            <p>3. {cookies?.language === "en" ? "Leaderboard" : "Clasament"}</p>
                        </div>

                        <div className={`step ${activeStep === 4 ? "active" : ""}`} onClick={() => setActiveStep(4)}>
                            <p>4. {cookies?.language === "en" ? "Debugging" : "Depanarea"}</p>
                        </div>

                    </div>
                ) : null}

                {category === "2" ? <div className="guide-button" onClick={() => setActiveGuide(curr => !curr)}>
                    <FontAwesomeIcon icon={faBookOpen} className="guide-icon" />
                </div> : null}

                <div className={`scenario-paper ${activeStep !== null ? "active" : ""}`} ref={scenarioPaperRef}>
                    {/* <h2>{cookies?.language === "en" ? "" : ""}</h2> */}
                    {activeStep === 1 ? 
                        cookies?.language === "en" ? <p>You are in the debugging mode. <br /> At the moment, you have to create defects on a certain point(s) to test your students. <br /> To create a defect, select a point, and then press the "Create defect" button in the top right. <br /> You can create 2 types of faults: Lack of voltage and Grounding (Short circuit) <br /> After choosing the type of fault, press "Save". </p> : 
                        <p>Te afli in modulul de depanare. <br /> <br /> In momentul de fata, trebuie sa creezi defecte pe un anumit(e) punct(e) pentru a testa elevii. <br /> <br />
                            Doar profesorul poate sa creeze o sesiune de depanare in care sa adauge unul sau mai multe defecte. Elevii trebuie sa intre pe sesiunea de depanare creata de profesor, apoi sa depisteze defectele de pe schema electrica si in final sa le rezolve. <br /> <br />
                            Pentru a crea un defect: <br /> <br />
                            <div className="margin">
                            1) selectati un punct <br /> <br /> 
                            2) apasati in dreapta sus pe butonul <b>Creeaza defect</b> <br /> <br /> 
                            3) Poti crea 2 tipuri de defecte: <br /> <div className="margin">
                                a) Lipsa de tensiune <br /> 
                                b) Punere la masa (Scurt circuit) <br /> <br />
                                </div> 
                            4) Dupa ce ai ales tipul de defect apesi pe <b>Salveaza</b>. <br /> <br /> 
                            </div>
                            După ce ai creat cel puțin un defect, apeși pe butonul de jos <b>Începe sesiunea</b> 
                        </p>
                    : activeStep === 2 ? 
                        cookies?.language === "en" ? <p>In case you have added a defect by mistake or you've selected the wrong type of defect, you will select the dot for which you want to delete the defect, then you will press in the top-right corner on the "Remove defect" button.</p> : <p>In caz ca ai adaugat un defect din greseala sau ai selectat tipul gresit de defect, selectezi punctul pentru care vrei sa stergi defectul, apoi apesi in coltul din dreapta sus pe "Sterge defect".</p>
                    : activeStep === 3 ? 
                        cookies?.language === "en" ? <p>Now that you have created the session, you will be able to see a leaderboard with the students / electricians added by you and statistics about how are they doing in the session (correct, wrong, etc.). Also, you can join the session, as a teacher, as well, by pressing on the button above the leaderboard "Join the session". </p> : <p>Acum ca ai creat sesiunea, vei putea sa vezi un clasament cu elevii / electricieni adaugati de tine si cateva statistici despre cum se descurca in sesiune (corecte, gresite, etc.). De asemenea, poti sa intri si tu, ca profesor, in sesiunea respectiva, apasand pe butonul de deasupra clasamentului "Intra in sesiune".</p>
                    : activeStep === 4 ? 
                        cookies?.language === "en" ? 
                            <p>
                                To debug the electrical diagram, we need to identify the faults with the help of the measuring device in the lower right corner of the screen. <br /> <br />
                                To open / close the measuring device, double click on it. <br /> <br />
                                You can select what to measure the points with (voltage 200V / 750V, continuity with the megometer / buzzer). <br /> <br />

                                To measure two points, click on the two points you want to select, and a value representing the voltage or continuity will appear on the measuring device, depending on what you chose. <br /> <br />

                                After you have detected the defect, press on the point where you think the defect is located, and in the upper right corner press on "Resolve defect". <br /> <br />

                                Also, the measuring device can be drag-at. <br />
                            </p> : 
                            <p>
                                Pentru a depăna schemă electrică, trebuie să identificăm defectele cu ajutorul aparatului de măsură din colțul dreapta-jos al ecranului. <br /> <br />
                                Pentru a deschide / închide aparatul de măsură apăsăm dublu click pe acesta. <br /> <br />
                                Puteți să va selectați cu ce să măsurați punctele (tensiune 200V / 750V, continuitate cu megometrul / buzerul). <br /> <br />

                                Pentru a măsură două puncte dați click pe cele două puncte pe care doriți să le selectați, iar pe aparatul de măsură o să va apară o valoare ce reprezintă tensiunea sau continuatea în funcție de ce ați ales. <br /> <br />

                                După ce ați depistat defectul, apăsați pe punctul unde considerați că se află defectul, iar în colțul din dreapta sus apăsați pe "Rezolva defect". <br /> <br />

                                De asemenea, aparatul de măsură poate fi drag-at. <br />

                            </p>

                    : null}

                    <div className="close-button" onClick={() => setActiveStep(null)}>
                        <FontAwesomeIcon className="close-icon" icon={faTimes}/>
                    </div>

                    {/* {scenario === "shock" ? <img src={electrocutareColeg} alt="electrocutare coleg imagine" /> : null} */}
                </div>


                {category === "2" && !isTeacher ? (
                    <div 
                        className="measurement-device" 
                        
                        onMouseDown={(e : any) =>{
                            if (e.target.tagName.toLowerCase() == "img" || e.target.classList.contains("dot")) return;
                            let isRightMB = false;
                            if ("which" in e)  // Gecko (Firefox), WebKit (Safari/Chrome) & Opera
                                isRightMB = e.which == 3; 
                            else if ("button" in e)  // IE, Opera 
                                isRightMB = e.button == 2; 

                            if (!isRightMB) startDragDevice(e);
                        }}
                        onMouseMove={e => moveDragDevice(e)}
                        onMouseUp={e => endDragDevice(e)}
                        ref={deviceScreenRef}
                        onDoubleClick={() => {
                            doubleClickScreenCounter++;
                            setShowMeasurmentDevice(currValue => !currValue);
                        }}
                        onClick={(e : any) => {
                            let currentDoubleClickScreenCounter = doubleClickScreenCounter;
                            setTimeout(() => {
                                if (currentDoubleClickScreenCounter !== doubleClickScreenCounter) return;
                                if (e.target.classList.contains("dot") || e.target.classList.contains("screen")) return;
                                const closestElement : any = getClosestElement(e.clientX, e.clientY, document.querySelectorAll(".measurement-device .dot"));
                                if (closestElement) setDeviceActiveOption(closestElement.classList[1]?.slice(4));
                            }, 200);
                          
                        }}
                    >
                        <div 
                            className="screen"
                        >
                            <h2>{deviceValue?.toString()?.length ? deviceValue : deviceActiveOption !== "off" ? "ON" : "OFF"}</h2>
                        </div>
                        {showMeasurmentDevice ? (
                            <div className="device">
                                <img src={aparatDeMasura} alt="" />
                                <div className="arrow-element" style={{ transform: `translate(-50%, -50%) rotateZ(${deviceActiveOption === "off" ? 180 : deviceActiveOption === "acv-200" ? 250 : deviceActiveOption === "acv-750" ? 305 : deviceActiveOption === "buzzer" ? 360 : 440}deg)` }}>
                                    <div className="arrow" />
                                    <div className="triangle" />
                                </div>

                                <div className={`dot dot-off ${deviceActiveOption === "off" ? "active" : ""}`} onClick={() => setDeviceActiveOption("off")} />
                                <div className={`dot dot-acv-200 ${deviceActiveOption === "acv-200" ? "active" : ""}`} onClick={() => setDeviceActiveOption("acv-200")} />
                                <div className={`dot dot-acv-750 ${deviceActiveOption === "acv-750" ? "active" : ""}`} onClick={() => setDeviceActiveOption("acv-750")} />
                                <div className={`dot dot-buzzer ${deviceActiveOption === "buzzer" ? "active" : ""}`} onClick={() => setDeviceActiveOption("buzzer")} />
                                <div className={`dot dot-continuity-10k ${deviceActiveOption === "continuity-10k" ? "active" : ""}`} onClick={() => setDeviceActiveOption("continuity-10k")} />

                            </div>
                        ) : null}
                    </div>
                ) : null}

                <OptionsMenu toggleSimulation={toggleSimulation} handleAddPage={handleAddPage} projectId={projectId || ""} page={page} signs={signs} removePage={removePage} printSchemes={printSchemes} addSignPressed={addSignPressed} activateEditName={activateEditName} replaceSignPressed={replaceSignPressed} useStore={useStore} category={category} format={format} />
                <div className="numbers-container">
                    <p className="empty"></p>
                    {columns?.length ? columns.map((column, idx) => (
                        <p key={idx}>{column || ""}</p>
                    )) : null}
                </div>
                <div className="grid-total-container">
                    <div className="letters">
                        <p>A</p>
                        <p>B</p>
                        <p>C</p>
                        <p>D</p>
                        <p>E</p>
                        <p>F</p>
                        <p>G</p>
                        <p>H</p>
                        <p>I</p>
                        <p>J</p>
                        <p>K</p>
                        <p>L</p>
                        <p>M</p>
                        <p>N</p>
                        <p>O</p>
                        <p>P</p>
                        <p>Q</p>
                        <p>R</p>
                        <p>S</p>
                        <p>T</p>
                        {format === "A3" ? (
                            <>
                                <p>U</p>
                                <p>V</p>
                                <p>W</p>
                                <p>X</p>
                                <p>Y</p>
                                <p>Z</p>
                                <p>Z2</p>
                                <p>Z3</p>
                            </>
                        ) : null}
                    </div>
                    <div className="grid-container">
                        <PrintRows 
                            projectName={projectName}
                            COLUMNS={COLUMNS}
                            columns={COLUMNS}
                            useStore={useStore} 
                            isSelectedCell={isSelectedCell}
                            cellRef={cellRef}
                            setSingleElementDrag={setSingleElementDrag}
                            dragElement={dragElement}
                            initiateElement={initiateElement}
                            moveElement={moveElement}
                            stopElement={stopElement}
                            touchInitiateElement={touchInitiateElement} 
                            touchMoveElement={touchMoveElement}
                            category={category}
                            findSign={findSign}
                            findSignObject={findSignObject}  
                            removeSign={removeSign}
                            addSign={addSign}
                            copiedElement={copiedElement}
                            cuttedElement={cuttedElement}
                            isImageLocked={isImageLocked}
                            changeIsSelectedSign={changeIsSelectedSign}
                            removeSelectedSign={removeSelectedSign}
                            changeSelectedCell={changeSelectedCell}
                            dragElementRow={dragElementRow}
                            dragElementColumn={dragElementColumn}
                            rowRef={rowRef}
                            ROWS={ROWS}
                            page={page}
                            problems={problems}
                            currentElectricity={currentElectricity}
                            consumersMap={consumersMap}
                            getElectricity={getElectricity}
                            multipleSelectedCells={multipleSelectedCells}
                            setMultipleSelectedCells={setMultipleSelectedCells}
                            simulation={simulation}
                            thermalRelays={thermalRelays}
                            findSignsObjectByName={findSignsObjectByName}
                            simulationPress={simulationPress}
                            simulationPressForce={simulationPressForce}
                        />
                    </div>
                </div>

                {addSignMenu ? <div className="add-signs-container" ref={addSignsContainerRef}>
                    {activeOptionAdd !== null ? <h2 className="title">{activeOptionAdd === 0 ? (cookies?.language === "en" ? "Conductors" : "Conductori") : activeOptionAdd === 1 ? (cookies?.language === "en" ? "Contacts and buttons" : "Contacte și butoane") : activeOptionAdd === 2 ? (cookies?.language === "en" ? "Protections" : "Protecții") : activeOptionAdd === 3 ? (cookies?.language === "en" ? "Switches and comutators" : "Întrerupătoare și comutatoare") : activeOptionAdd === 4 ? (cookies?.language === "en" ? "Bobines" : "Bobine") : activeOptionAdd === 6 ? (cookies?.language === "en" ? "Engines, Genertors & Transformers" : "Motore, Generatoare & Transformatoare") : activeOptionAdd === 5 ? (cookies?.language === "en" ? "Sockets and sheets" : "Prize și fișe") : activeOptionAdd === 7 ? (cookies?.language === "en" ? "High tension" : "Inalta tensiune") : activeOptionAdd === 8 ? (cookies?.language === "en" ? "Others" : "Altele") : null}</h2> : null}
                    
                    {<div className="back-button" onClick={() => {
                        if (activeOptionAdd === null) changeAddSignMenu(false) 
                        else {
                            if (activeSubCategoryAdd === null) setActiveOptionAdd(null);
                            else setActiveSubCategoryAdd(null);
                        }
                    }}>
                        <FontAwesomeIcon icon={faAngleLeft} className="back-icon" />
                        <h2>{cookies?.language === "en" ? "Go back" : "Inapoi"}</h2>
                    </div>}

                    <div className="elements-container">

                        <div className={`scroll-element ${activeOptionAdd !== null ? "active" : ""}`} onClick={() => {
                            addElementsRef.current?.scrollTo({
                                left: (addElementsRef?.current?.getBoundingClientRect().left || 0) - ((addSignsContainerRef?.current?.clientWidth || 0) / 2),
                                behavior: 'smooth'
                            });
                        }}>
                            <FontAwesomeIcon icon={faAngleLeft} className="scroll-icon" />
                        </div>

                        <div className={`elements ${activeOptionAdd === null ? "category" : ""}`} ref={addElementsRef} onScroll={() => addElementsRef.current ? setElementsWindowScrollX(addElementsRef.current.scrollLeft) : null}>
                        
                        {activeOptionAdd === null ? <div className="element" onClick={() => setActiveOptionAdd(0)}>
                            <div className="element-image">
                                <img src={derivatie_din_conductor_punctat} alt={cookies?.language === "en" ? "Conductors" : "Conductori" } />
                            </div>
                            <p>{cookies?.language === "en" ? "Conductors" : "Conductori"}</p>
                        </div> : null}

                        {activeOptionAdd === null ? <div className="element" onClick={() => setActiveOptionAdd(1)}>
                            <div className="element-image">
                                <img src={contactNormalDeschis} alt={cookies?.language === "en" ? "Contacts and buttons" : "Contacte si butoane" } />
                            </div>
                            <p>{cookies?.language === "en" ? "Contacts and buttons" : "Contacte si butoane"}</p>
                        </div> : null}

                        {activeOptionAdd === null ? <div className="element" onClick={() => setActiveOptionAdd(2)}>
                            <div className="element-image">
                                <img src={siguranta} alt={cookies?.language === "en" ? "Protections" : "Protecții" } />
                            </div>
                            <p>{cookies?.language === "en" ? "Protections" : "Protecții"}</p>
                        </div> : null}

                        {activeOptionAdd === null ? <div className="element" onClick={() => setActiveOptionAdd(3)}>
                            <div className="element-image">
                                <img src={comutator_bipolar} alt={cookies?.language === "en" ? "Switches and comutators" : "Întrerupătoare și comutatoare" } />
                            </div>
                            <p>{cookies?.language === "en" ? "Switches and comutators" : "Întrerupătoare și comutatoare"}</p>
                        </div> : null}

                        {activeOptionAdd === null ? <div className="element" onClick={() => setActiveOptionAdd(4)}>
                            <div className="element-image">
                                <img src={bobinaReleu} alt={cookies?.language === "en" ? "Bobines" : "Bobine" } />
                            </div>
                            <p>{cookies?.language === "en" ? "Bobines" : "Bobine"}</p>
                        </div> : null}


                        {activeOptionAdd === null ? <div className="element" onClick={() => setActiveOptionAdd(5)}>

                            <div className="element-image">
                                <img src={priza_pentru_tensiune_redusa_de_protectie} alt={cookies?.language === "en" ? "Sockets and sheets" : "Prize și fișe"} />
                            </div>

                            <p>{cookies?.language === "en" ? "Sockets and sheets" : "Prize și fișe"}</p>
                        </div> : null}

                        {activeOptionAdd === null ? <div className="element" onClick={() => setActiveOptionAdd(6)}>

                            <div className="element-image">
                                <img src={motor_asincron_trifazat_cu_rotor_cu_inele} alt={cookies?.language === "en" ? "Engines, Generators, Transformers" : "Motoare, Generatoare & Transformatoare"} />
                            </div>

                            <p>{cookies?.language === "en" ? "Engines & Gen" : "Motoare & Gen."}</p>
                        </div> : null}



                        {activeOptionAdd === null ?
                            <div className="element" onClick={() => setActiveOptionAdd(7)}>
                                <div className="element-image">
                                    <img src={generatorInaltaIcon} alt={cookies?.language === "en" ? "High tension" : "Inalta tensiune"} />
                                </div>
                                <p>{cookies?.language === "en" ? "High tension" : "Inalta tensiune"}</p>
                            </div>
                        : null}

                        {activeOptionAdd === null ?
                            <div className="element" onClick={() => setActiveOptionAdd(8)}>
                                <div className="element-image">
                                    <img src={sirDeClame} alt={cookies?.language === "en" ? "Others" : "Altele"} />
                                </div>
                                <p>{cookies?.language === "en" ? "Others" : "Altele"}</p>
                            </div>
                        : null}

                            {activeOptionAdd !== null ? Object.values(SCHEME_ELEMENTS).filter((element : any) => element?.show !== false && (activeSubCategoryAdd ? (element?.collection === activeSubCategoryAdd || element?.subcategory === activeSubCategoryAdd) : !element?.subcategory)).map((element : any, idx) => element.category === CATEGORIES[activeOptionAdd] ?  (
                            <div className="element element-category" 
                                onClick={(e : any) => {
                                    if (!activeSubCategoryAdd && activeOptionAdd !== null && element?.collection) return setActiveSubCategoryAdd(element.collection);
                                    let target = e.target;
                                    
                                    if (target.classList.contains("flip-container") || target.classList.contains("flip-icon") || target.tagName.toLowerCase() === "svg" || target.tagName.toLowerCase() === "path") return;
                                    
                                    while (!target.classList.contains("element")) {
                                        target = target.parentElement;
                                    }

                                    const image = target.querySelector("img");
                                    const rotateZ = ( parseFloat(image.style.transform.match(/rotateZ\((.+)\)/)?.[1]) || 0 );

                                    addedSign(element, rotateZ);
                                }}
                                onDragStart={(e : any) => {
                                    const currentImg = e.target.querySelector("img") || e.target;
                                    const rotateZ = currentImg.style.transform.match(/rotateZ\((\d+)(.+)\)/);
                                    setStartAddDragFlip(Number(rotateZ?.[1] || 0));
                                    setStartAddDrag(true);
                                }}
                                onDragEnd={(event : any) => {
                                    if (!startAddDrag) return;
                                    event.preventDefault();
                                    // Find the element under the pointer
                                    let elementUnderPointer : any = document.elementFromPoint(event.clientX, event.clientY);

                                    while (!elementUnderPointer?.classList.contains("cell") && !elementUnderPointer?.classList?.contains("page-container")) {
                                        elementUnderPointer = elementUnderPointer?.parentElement;
                                    }



                                    if (!elementUnderPointer?.classList?.contains("cell")) return;

                                    const x = elementUnderPointer.getAttribute("row");
                                    const y = elementUnderPointer.getAttribute("column");
                                    // const elementSign = elementUnderPointer?.querySelector("img")?.src;
                                    
                                    element.realSource.forEach((source : any, idx : number) => {
                                        if (element?.align === "vertical") addSign(Number(x), Number(y) + idx, page, [ { name: source, flip: startAddDragFlip } ], 0, []);
                                        else addSign(Number(x) - idx, Number(y), page, [ { name: source, flip: startAddDragFlip } ], 0, []);
                                    });
                                    
                                    setStartAddDrag(false);
                                    setStartAddDragFlip(0);
                                }}
                                draggable={true}
                            >

                                <div className="name-element" style={{ transform: `translateX(${-elementsWindowScrollX}px)` }}>
                                    <p>{element.name[cookies?.language]}</p>
                                </div>

                                <div className="element-inside-container">
                                    <div className="element-image">

                                        <div className={`flip-container left ${element?.collection && !activeSubCategoryAdd ? "collection" : ""}`} onClick={(e : any) => {
                                            let target = e.target;
                                            
                                            while (!target?.classList?.contains("element-image")) {
                                                target = target.parentElement;
                                            }
                                            
                                            const image = target.querySelector("img");
                                            // image.style.transform
                                            const rotateZ = ( parseFloat(image.style.transform.match(/rotateZ\((.+)\)/)?.[1]) || 0 );
                                            
                                            const transforms = image.style.transform.split(" ").filter((element : string) => !element.includes("rotateZ")).join(" ");


                                            image.style.transform = `${transforms} rotateZ(${rotateZ - 90 < 0 ? 360 - rotateZ - 90 : rotateZ - 90}deg)`;
                                            
                                            

                                        }}>
                                            <FontAwesomeIcon icon={faRotateLeft} className="flip-icon" />
                                        </div>

                                        <img 
                                            src={element.imageSource} 
                                            alt={element.name[cookies?.language]} 
                                            
                                        />

                                        <div className={`flip-container right ${element?.collection && !activeSubCategoryAdd ? "collection" : ""}`} onClick={(e : any) => {
                                                let target = e.target;
                                            
                                                while (!target?.classList?.contains("element-image")) {
                                                    target = target?.parentElement;
                                                }
                                                
                                                const image = target.querySelector("img");
                                                // image.style.transform
                                                const rotateZ = ( parseFloat(image.style.transform.match(/rotateZ\((.+)\)/)?.[1]) || 0 );
                                                const transforms = image.style.transform.split(" ").filter((element : string) => !element.includes("rotateZ")).join(" ");

                                                image.style.transform = `${transforms} rotateZ(${rotateZ + 90 > 360 ? 360 - rotateZ + 90 : rotateZ + 90}deg)`;
                                                
                                        }}>
                                            <FontAwesomeIcon icon={faRotateRight} className="flip-icon" />
                                        </div>

                                        {element?.collection && !activeSubCategoryAdd ? <div className="collection-container" onClick={() => {
                                        }}>
                                            <FontAwesomeIcon icon={faEllipsis} className="collection-icon" />
                                        </div> : null}
                                    </div>
                                    {/* <p>{element.name[cookies?.language]}</p> */}
                                </div>

                                
                            </div>
                            ) : null) : null}
                            </div>

                            <div className={`scroll-element ${activeOptionAdd !== null ? "active" : ""}`} onClick={() => {
                                addElementsRef.current?.scrollTo({
                                    left: (addElementsRef?.current?.getBoundingClientRect()?.left || 0) + ((addSignsContainerRef.current?.offsetWidth || 0) / 2),
                                    behavior: 'smooth'
                                });
                            }}>
                                <FontAwesomeIcon icon={faAngleRight} className="scroll-icon" />
                            </div>

                        </div>

                        {/* {activeOptionAdd !== null ? <div className="element" onClick={() => activeOptionAdd === null ? changeAddSignMenu(false) : setActiveOptionAdd(null)}>

                            <div className="element-image"  style={{ height: "10vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <FontAwesomeIcon icon={faAngleLeft} className="back-icon" style={{ fontSize: 40 }} />
                            </div>
                            
                            <p>{cookies?.language === "en" ? "Back" : "Inapoi"}</p>
                        </div> : null} */}
                    </div> : null}

                <div className={`name-sign-container ${nameSignMenu ? "active" : ""}`} ref={nameContainerRef} onClick={(e : any) => {
                    if (!nameSignMenu) return;
                    if (e.target?.classList?.contains("name-sign-container")) setNameSignMenu(false);
                }}>
                    {nameSignMenu ? <div className="name-sign">
                        <div className="name-sign-relative">
                            {texts.map((text: any, idx: number) => {
                                
                                return (
                                    <div className="text-container" key={idx}>

                                        <div className="input">
                                            <h2>{language === "ro" ? "Nume: " : "Name: "}</h2>
                                            <input type="text" autoFocus={true} placeholder={language === "ro" ? "" : ""} value={text?.name?.toString()?.length !== undefined ? text?.name : ""} onChange={e => setTexts((currTexts : any) => currTexts.map((text : { name: string }, textIdx : number) => textIdx === idx ? {...text, name: e.target.value} : text))} />
                                            {/* <div></div> */}
                                        </div>

                                        <div className="input">
                                            <div className="input-text-wrapper">
                                                <h2 style={{ flex: "initial" }}>{language === "ro" ? "Marime font" : "Font size"}</h2> 
                                                <p>({text?.fontSize?.toString() || 10})</p>
                                            </div>
                                            {/* <input type="number" placeholder={language === "ro" ? "" : ""} min={4} max={30} value={text?.fontSize?.toString()?.length !== undefined ? text.fontSize : 14} onChange={e => setTexts((currTexts : any) => currTexts.map((text : { fontSize: number }, textIdx : number) => textIdx === idx ? {...text, fontSize: e.target.value} : text))} /> */}
                                            <div className="text-content">

                                                <div className="text-symbol">
                                                    <p style={{ fontSize: "16px" }}>A</p>
                                                    <FontAwesomeIcon className="text-symbol-icon" icon={faMinus} onClick={() => {
                                                        setTexts((currTexts : any) => currTexts.map((text : { fontSize: number }, textIdx : number) => textIdx === idx ? {...text, fontSize: Number(text?.fontSize || 10) - 1 < 4 ? Number(text?.fontSize || 10) : Number(text?.fontSize || 10) - 1} : text))
                                                    }} />
                                                </div>

                                                <div className="text-content-square">
                                                    <h2 style={{ 
                                                        fontWeight: text?.fontWeight?.toString() || "normal",  
                                                        fontSize: `${(text?.fontSize?.toString() || 10) * 1}px`,
                                                        transform: text?.flip?.toString()?.length !== undefined ? `rotateZ(${text?.flip}deg)` : "none",
                                                        position: "absolute",
                                                        left: text?.positionX?.toString()?.length !== undefined ? `${text?.positionX * 1.5 -1}mm` : "0mm",
                                                        top: text?.positionY?.toString()?.length !== undefined ? `${text?.positionY * 1.5}mm` : "0mm" 
                                                    }}>{text?.name || ""}</h2>

                                                    {currentImages?.map((currentImage, idx : number) => {
                                                        return (
                                                            <img key={idx} src={currentImage.name}/>
                                                        );
                                                    })}
                                                    
                                                </div>

                                                <div className="text-symbol">
                                                    <FontAwesomeIcon className="text-symbol-icon" icon={faPlus} onClick={() => setTexts((currTexts : any) => currTexts.map((text : { fontSize: number }, textIdx : number) => textIdx === idx ? {...text, fontSize: Number(text.fontSize || 10) + 1 > 30 ? Number(text?.fontSize || 10) : Number(text?.fontSize || 10) + 1} : text))} />
                                                    <p style={{ fontSize: "24px" }}>A</p>
                                                </div>

                                            </div>
                                        
                                        </div>

                                        {/* <div className="input">
                                            <h2>{language === "ro" ? "Pozitionare Orizontala (mm)" : "Positioning Horizontally (mm)"}</h2>
                                            <input type="number" placeholder={language === "ro" ? "" : ""} value={text?.positionX?.toString()?.length !== undefined ? text.positionX : 0} onChange={e => setTexts((currTexts : any) => currTexts.map((text : { positionX: number }, textIdx : number) => textIdx === idx ? {...text, positionX: e.target.value} : text))} />
                                            <div></div>
                                        </div> */}

                                        <div className="input">
                                            <h2>{language === "ro" ? "Pozitionare" : "Positioning"}</h2>
                                            <div className="text-content">
                                                <div className="text-symbol">
                                                    {/* <p style={{ fontSize: "8px" }}>A</p> */}
                                                    <p style={{ fontSize: "16px", opacity: "0", userSelect: "none" }}>A</p>
                                                    <FontAwesomeIcon className="text-symbol-icon" icon={faArrowLeft} onClick={() => setTexts((currTexts : any) => currTexts.map((text : { positionX: number | null }, textIdx : number) => textIdx === idx ? {...text, positionX: Number(text?.positionX == null ? 0 : text?.positionX) - 0.5} : text))} />
                                                </div>

                                                <div className="text-content-square-container">

                                                    <div className="text-symbol">
                                                        {/* <p style={{ fontSize: "8px" }}>A</p> */}
                                                        {/* <p style={{ fontSize: "16px", opacity: "0", userSelect: "none" }}>A</p> */}
                                                        <FontAwesomeIcon className="text-symbol-icon" icon={faArrowUp} onClick={() => setTexts((currTexts : any) => currTexts.map((text : { positionY: number | null }, textIdx : number) => textIdx === idx ? {...text, positionY: Number(text?.positionY == null ? 0 : text?.positionY) - 0.5} : text))} />
                                                    </div>

                                                    <div className="text-content-square">
                                                        <h2 style={{ 
                                                            fontWeight: text?.fontWeight?.toString() || "normal",  
                                                            fontSize: `${(text?.fontSize?.toString() || 10) * 1}px`,
                                                            transform: text?.flip?.toString()?.length !== undefined ? `rotateZ(${text?.flip}deg)` : "none",
                                                            position: "absolute",
                                                            left: text?.positionX?.toString()?.length !== undefined ? `${text?.positionX * 1.5 -1}mm` : "0mm",
                                                            top: text?.positionY?.toString()?.length !== undefined ? `${text?.positionY * 1.5}mm` : "0mm" 
                                                        }}>{text?.name || ""}</h2>

                                                        {currentImages?.map((currentImage, idx : number) => {
                                                            return (
                                                                <img key={idx} src={currentImage.name}/>
                                                            );
                                                        })}
                                                    </div>

                                                    <div className="text-symbol">
                                                        {/* <p style={{ fontSize: "8px" }}>A</p> */}
                                                        {/* <p style={{ fontSize: "16px", opacity: "0", userSelect: "none" }}>A</p> */}
                                                        <FontAwesomeIcon className="text-symbol-icon" icon={faArrowDown} onClick={() => setTexts((currTexts : any) => currTexts.map((text : { positionY: number | null }, textIdx : number) => textIdx === idx ? {...text, positionY: Number(text?.positionY == null ? 0 : text?.positionY) + 0.5} : text))} />
                                                    </div>
                                                </div>

                                                <div className="text-symbol">
                                                    {/* <p style={{ fontSize: "20px" }}>A</p> */}
                                                    <FontAwesomeIcon className="text-symbol-icon" icon={faArrowRight} onClick={() => setTexts((currTexts : any) => currTexts.map((text : { positionX: number | null }, textIdx : number) => textIdx === idx ? {...text, positionX: Number(text?.positionX == null ? 0 : text?.positionX) + 0.5} : text))}  />
                                                    <p style={{ fontSize: "16px", opacity: "0", userSelect: "none" }}>A</p>

                                                </div>
                                            </div>                                          
                                        </div>
                                        
                                        <div className="input">
                                            <div className="input-text-wrapper">
                                                <h2 style={{ flex: "initial" }}>{language === "ro" ? "Grosimea fontului" : "Font weight"}</h2>
                                                <p>({ text?.fontWeight?.toString() || 400 })</p>
                                            </div>
                                            <div className="text-content">
                                                <div className="text-symbol">
                                                    <p style={{ fontSize: "20px", fontWeight: "300" }}>A</p>
                                                    <FontAwesomeIcon className="text-symbol-icon" icon={faMinus} onClick={() => setTexts((currTexts : any) => currTexts.map((text : { fontWeight: number | null }, textIdx : number) => textIdx === idx ? {...text, fontWeight: Number(text?.fontWeight || 400) - 50 <= 200 ? 200 : Number(text?.fontWeight || 400) - 100} : text))}  />
                                                </div>

                                                <div className="text-content-square">
                                                    <h2 style={{ 
                                                        fontWeight: text?.fontWeight?.toString() || "normal",  
                                                        fontSize: `${(text?.fontSize?.toString() || 10) * 1}px`,
                                                        transform: text?.flip?.toString()?.length !== undefined ? `rotateZ(${text?.flip}deg)` : "none",
                                                        position: "absolute",
                                                        left: text?.positionX?.toString()?.length !== undefined ? `${text?.positionX * 1.5 - 1}mm` : "0mm",
                                                        top: text?.positionY?.toString()?.length !== undefined ? `${text?.positionY * 1.5}mm` : "0mm" 
                                                    }}>{text?.name || ""}</h2>

                                                    {currentImages?.map((currentImage, idx : number) => {
                                                        return (
                                                            <img key={idx} src={currentImage.name}/>
                                                        );
                                                    })}
                                                </div>

                                                <div className="text-symbol">
                                                    <FontAwesomeIcon className="text-symbol-icon" icon={faPlus} onClick={() => setTexts((currTexts : any) => currTexts.map((text : { fontWeight: number | null }, textIdx : number) => textIdx === idx ? {...text, fontWeight: Number(text?.fontWeight || 400) + 50 > 900 ? 900 : Number(text?.fontWeight || 400) + 100} : text))} />
                                                    <p style={{ fontSize: "20px", fontWeight: "900" }}>A</p>
                                                </div>
                                            </div>                                            {/* <div></div> */}
                                        </div>

                                        <div className="input last-input">
                                            <h2>{language === "ro" ? "Rotire (˚)" : "Rotation (˚)"}</h2>
                                            <div className="text-content">
                                                <div className="text-symbol">
                                                    <p style={{ fontSize: "20px", transform: "rotateZ(0deg)" }}>A</p>
                                                    <FontAwesomeIcon className="text-symbol-icon" icon={faRotateLeft} onClick={() => setTexts((currTexts : any) => currTexts.map((text : { flip: number | null }, textIdx : number) => textIdx === idx ? {...text, flip: Number(text?.flip || 0) - 45 < 0 ? 360 - (Number(text?.flip || 0) + 45) : Number(text?.flip || 0) - 45} : text))} />
                                                </div>
                                                    
                                                <div className="text-content-square">
                                                    <h2 style={{ 
                                                        fontWeight: text?.fontWeight?.toString() || "normal",  
                                                        fontSize: `${(text?.fontSize?.toString() || 10) * 1}px`,
                                                        transform: text?.flip?.toString()?.length !== undefined ? `rotateZ(${text?.flip}deg)` : "none",
                                                        position: "absolute",
                                                        left: text?.positionX?.toString()?.length !== undefined ? `${text?.positionX * 1.5 -1}mm` : "0mm",
                                                        top: text?.positionY?.toString()?.length !== undefined ? `${text?.positionY * 1.5}mm` : "0mm" 
                                                    }}>{text?.name || ""}</h2>

                                                    {currentImages?.map((currentImage, idx : number) => {
                                                        return (
                                                            <img key={idx} src={currentImage.name}/>
                                                        );
                                                    })}
                                                </div>

                                                <div className="text-symbol">
                                                    <FontAwesomeIcon className="text-symbol-icon" icon={faRotateRight} onClick={() => setTexts((currTexts : any) => currTexts.map((text : { flip: number | null }, textIdx : number) => textIdx === idx ? {...text, flip: Number(text?.flip || 0) + 45 > 360 ? 360 - (Number(text?.flip || 0) - 45) : Number(text?.flip || 0) + 45} : text))} />
                                                    <p style={{ fontSize: "20px", transform: "rotateZ(180deg)" }}>A</p>
                                                </div>

                                            </div>                                            {/* <div></div> */}
                                        </div>

                                        {/* <div className="input">
                                            <h2>{language === "ro" ? "Color" : "Culoare"}</h2>
                                            <input type="color" placeholder={language === "ro" ? "Color..." : "Culoare..."} value={text.color || "#000000"} onChange={e => setTexts((currTexts : any) => currTexts.map((text : { color: string }, textIdx : number) => textIdx === idx ? {...text, color: e.target.value} : text))} />
                                        </div> */}

                                        <FontAwesomeIcon icon={faTrashCan} className="close-icon" onClick={() => {
                                            setTexts((currTexts : any) => currTexts.filter((text : any, textIdx : number) => textIdx !== idx));
                                            // changeName();

                                        }} />

                                    </div>
                                );
                            })}

                            {/* <div className="input">
                                <h2>{language === "ro" ? "Aliniament: " : "Alignment: "}</h2>
                                <input type="text" value={signName} onChange={e => setSignName(e.target.value)} />
                                <div className="options">
                                    {alignmentOptions.map((option: string, idx: number) => (
                                        <div className={`option ${idx === alignmentIdx ? "active" : ""}`} onClick={() => setAlignmentIdx(idx)} key={idx}>
                                            <p>{option}</p>
                                        </div>
                                    ))}
                                </div>
                            </div> */}

                           
                            <button type="button" onClick={() => changeName()}>
                                <p>{language === "ro" ? "Salveaza" : "Save"}</p>
                            </button>

                            <button type="button" className="min-button" onClick={() => setTexts((currTexts : any) => [...currTexts, {}])}>
                                <FontAwesomeIcon icon={faPlus} className="add-icon" />
                                <p className="hover-text">{language === "ro" ? "Adauga inca un text" : "Add one more text"}</p>
                            </button>


                            <FontAwesomeIcon icon={faTrashCan} className="delete-icon" onClick={() => {
                                setTexts([]);
                            
                            }} />

                            <FontAwesomeIcon icon={faTimes} className="close-icon" onClick={() => {
                                setNameSignMenu(false);
                            }} />
                        </div>
                    </div> : null}
                </div>

                {category !== "2" ? (
                    <div className="project-name" ref={projectNameRef}>
                        <h2
                        contentEditable={category === "0" ? true : false} 
                        spellCheck={false} 
                        onInput={(e : any) => setCurrentProjectName(e.target.innerText)}
                        onKeyDown={(e: any) => e.key === "Enter" ? e.preventDefault() : null}
                        suppressContentEditableWarning={true}
                        >
                            {projectName}
                        </h2>
                    </div>
                ) : null}

                {/* Audios */}

                <audio src={buzzerSound} ref={buzzerSoundRef} autoPlay={false} loop={true} style={{ display: "none" }} />
                <audio src={screwSound} ref={screwSoundRef} autoPlay={false} style={{ display: "none" }} />

                {/* Change current visibility */}

               

             
                <div className={`current-visibility-container ${isCurrentOnScheme ? "is-current" : ""}`}>
                    <div 
                        className="shortcut" 
                        onClick={() => {
                            if (scrollVisible()) document.body.classList.remove("grid-scroll");
                            else document.body.classList.add("grid-scroll");
                            let newZoom;
                            if (Number(document.body.getAttribute("zoom")) > 0.9) {
                                    if (document.body.getAttribute("zoom")) 
                                        newZoom = (Number(document.body.getAttribute("zoom")) - 0.1).toString();
                                    if (newZoom) {
                                        document.body.setAttribute("zoom", newZoom);
                                        zoomFunc(newZoom, isGrid, format);
                                    }
                            }
                        
                        }}
                        onContextMenu={(e : any) => {
                            e.preventDefault();
                            document.querySelectorAll(".shortcut")[0]?.classList.toggle("active");

                        }}
                        onBlur={() => {
                            document.querySelectorAll(".shortcut")[0]?.classList.remove("active");
                        }}
                        onMouseLeave={() => {
                            document.querySelectorAll(".shortcut")[0]?.classList.remove("active");
                        }}
                        tabIndex={0}
                    >
                        <FontAwesomeIcon icon={faSearchMinus} className="shortcut-icon" />
                        <p>{cookies?.language === "en" ? "Minimize" : "Micșorează"}</p>
                    </div>
                    
                    <div 
                        className="shortcut" 
                        onClick={(e : any) => {
                            if (page - 1 > 0) {
                                window.history.pushState(window.history.state, "", `/project/${projectId}/${page - 2}`);
                                window.location.reload();
                            }
                        }}
                        onContextMenu={(e : any) => {
                            e.preventDefault();
                            document.querySelectorAll(".shortcut")[1]?.classList.toggle("active");

                        }}
                        onBlur={() => {
                            document.querySelectorAll(".shortcut")[1]?.classList.remove("active");
                        }}
                        onMouseLeave={() => {
                            document.querySelectorAll(".shortcut")[1]?.classList.remove("active");
                        }}
                        tabIndex={0}
                    >
                        <FontAwesomeIcon icon={faAngleLeft} className="shortcut-icon" />
                        <p>{cookies?.language === "en" ? "Back" : "Înapoi"}</p>
                    </div>

                  

                    <div className="page-counter-container">
                        <input type="number" value={counterPage} onChange={changeCounterPage} onBlur={gotoPage} onKeyDown={(e : any) => {
                            if ((e.key === "Enter" || e.key === "Escape")) gotoPage();
                        }} />
                        <p>/</p>
                        <p>{totalPages}</p>
                    </div>

                    <div 
                        className="shortcut" 
                        onClick={(e : any) => {
            
                            if (page + 1 <= (totalPages || 1)) {
                                window.history.pushState(window.history.state, "", `/project/${projectId}/${page}`);
                                window.location.reload();
                            }
                        }}
                        onContextMenu={(e : any) => {
                            e.preventDefault();

                            document.querySelectorAll(".shortcut")[2]?.classList.toggle("active");
                        }}
                        onBlur={() => {
                            document.querySelectorAll(".shortcut")[2]?.classList.remove("active");
                        }}
                        onMouseLeave={() => {
                            document.querySelectorAll(".shortcut")[2]?.classList.remove("active");
                        }}
                        tabIndex={0}
                    >
                        <FontAwesomeIcon icon={faAngleRight} className="shortcut-icon" />
                        <p>{cookies?.language === "en" ? "Next" : "Înainte"}</p>
                    </div>

                    <div 
                        className="shortcut" 
                        onClick={() => {
                            if (scrollVisible()) document.body.classList.remove("grid-scroll");
                            else document.body.classList.add("grid-scroll");
                         
                            let newZoom;
                            if (Number(document.body.getAttribute("zoom")) < 5) {
                                if (document.body.getAttribute("zoom")) 
                                    newZoom = (Number(document.body.getAttribute("zoom")) + 0.1).toString();
                                else newZoom = "1.1";

                                document.body.setAttribute("zoom", newZoom);
                                zoomFunc(newZoom, isGrid, format);

                            }
                        }}
                        onContextMenu={(e : any) => {
                            e.preventDefault();
                            document.querySelectorAll(".shortcut")[3]?.classList.toggle("active");
                        }}
                        onBlur={() => {
                            document.querySelectorAll(".shortcut")[3]?.classList.remove("active");
                        }}
                        onMouseLeave={() => {
                            document.querySelectorAll(".shortcut")[3]?.classList.remove("active");
                        }}
                        tabIndex={0}
                    >
                        <FontAwesomeIcon icon={faSearchPlus} className="shortcut-icon" />
                        <p>{cookies?.language === "en" ? "Maximize" : "Mărește"}</p>                   
                    </div>
                </div>

                {simulation ? 
                    <div className="current-visibility-container dynamic-status">
                        <FontAwesomeIcon icon={faPlay} />
                        <p>{cookies?.language === "en" ? "Active simulation" : "Simulare activă"}</p>
                    </div>
                : null}

                {copiedElements?.length || copiedElement || cuttedElements?.length || cuttedElement || multipleSelectedCells ? <div className="current-visibility-container dynamic-status">
                    <FontAwesomeIcon icon={(
                        copiedElements?.length || copiedElement ? faCopy :
                        cuttedElements?.length || cuttedElement ? faScissors :
                        multipleSelectedCells ? faObjectUngroup : faCopy
                    )} />
                    <p>{copiedElements?.length || copiedElement ? (
                        cookies?.language === "en" ? "Active copying" : "Copiat activ"
                    ) : cuttedElements?.length || cuttedElement  ? (
                        cookies?.language === "en" ? "Active cutting" : "Decuparea activă"
                    ) : multipleSelectedCells ? (
                        cookies?.language === "en" ? "Active multiple selection" : "Selecția multiplă activă"
                    ) : ""}</p>
                </div> : null}

                <div className="page-number" ref={pageNumberRef} style={{ display: "none" }}>
                    <h2>{cookies?.language === "en" ? "Page Number" : "Nr. pag:"} {page} / {totalPages}</h2>
                </div>

                {/* 
                    <div className="print-button" onClick={() => printScheme()} ref={printRef}>
                        <FontAwesomeIcon icon={faPrint} className="print-icon" />
                    </div> */}

                {/* {category !== "0" ? <audio src={buzzerSound} ref={buzzerSoundRef}></audio> : null} */}
            </div>
            {rightClicked && getSelectedCell() ? (
                <div className="context-menu" style={{ top: `${rightClickPoints.y - (15 * Number(document.body.getAttribute("zoom")))}px`, left: `${rightClickPoints.x + 15 * Number(document.body.getAttribute("zoom"))}px`  }}>
                    {rightClickData.map((elem, idx) => (
                        <div 
                            key={elem.id} 
                            className={`context-menu-icon ${elem.danger ? "danger" : ""} ${elem?.icon2 ? "two-icons" : ""} ${idx === rightClickData.length - 1 ? "flip-option" : ""}`}
                            onClick={() => {
                                if (elem.id === 1 && !copiedElement && !cuttedElement) {
                                    const currentSign : { x: number, y: number, names: Array<any>, flip: number, texts: any, signColor: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number, page:number }) => sign.x === selectedCell.x && sign.y === selectedCell.y && sign.page === page);
                                    if (!currentSign) return;
                                    setCopiedElement(currentSign);
                                    removeSelectedSign();
                                    removeSelectedCell();
                                    setRightClicked(false);
                                    stopElement();
                                } else if (elem.id === 2) {
                                    const selectedCells = cellRef.current.filter(cell => cell?.classList.contains("selected"));


                                    if (cuttedElement) {
                                        selectedCells.forEach((cell : any) => {
                                            // const currSign: { x: number, y: number, names: Array<any>, flip: number, textName: string, textAlignment: string, fontSize: number, signColor: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number }) => sign.x === Number(cell?.getAttribute("column")) && sign.y === Number(cell?.getAttribute("row")));
                                            if (cell?.querySelector("img")) removeSign(Number(cell?.getAttribute("row")), Number(cell?.getAttribute("column")), page);
                                           
                                            addSign(Number(cell?.getAttribute("row")), Number(cell?.getAttribute("column")), page, cuttedElement.names, cuttedElement.flip, cuttedElement.texts, cuttedElement.signColor);
                                        });
                                        setRightClicked(false);

                                    } else if (copiedElement) {
                                        selectedCells.forEach(cell => {
                                            // const currSign: { x: number, y: number, names: Array<any>, flip: number, textName: string, textAlignment: string, fontSize: number, signColor: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number }) => sign.x === Number(cell?.getAttribute("column")) && sign.y === Number(cell?.getAttribute("row")));
                                            if (cell?.querySelector("img")) removeSign(Number(cell?.getAttribute("row")), Number(cell?.getAttribute("column")), page);
                                            addSign(Number(cell?.getAttribute("row")), Number(cell?.getAttribute("column")), page, copiedElement.names, copiedElement.flip, copiedElement.texts, copiedElement.signColor);
                                        });
                                        setRightClicked(false);
                                    }
                                  
                                    
                                    if (copiedElement) setCopiedElement(null);
                                    else if (cuttedElement) setCuttedElement(null);
                                    removeSelectedSign();
                                    removeSelectedCell();
                                } else if (elem.id === 3 && !cuttedElement && !copiedElement && selectedCell) {
                                    const currentSign : { x: number, y: number, names: Array<any>, flip: number, texts: any, signColor: string | null } = signs.find((sign: { x: number, y: number, flip: number, page: number }) => sign.x === selectedCell.x && sign.y === selectedCell.y && sign.page === page);
                                    if (!currentSign) return;
                                    setCuttedElement(currentSign);
                                    removeSign(currentSign.x, currentSign?.y, page);
                                    removeSelectedSign();
                                    removeSelectedCell();
                                    stopElement();
                                } else if (elem.id === 4 && selectedCell) {
                                    if (!nameSignMenu) {
                                        if (selectedCell?.x == undefined || selectedCell?.y == undefined) return;
                                        const currentSign : { x: number, y: number, names: Array<any>, page: number, flip: number, texts: any, signColor: string | null } = signs.find((sign: { x: number, y: number, names: Array<any>, flip: number, page: number }) => sign.x === selectedCell.x && sign.y === selectedCell.y && sign.page === page);
                                        if (!currentSign) return;
                                        removeSign(currentSign?.x, currentSign?.y, page);
                                    }
                                } else if (elem.id === 6 && selectedCell) {
                                    activateEditName();
                                    setRightClicked(false);
                                } 
                            }}
                        >
                            {elem.icon}
                            <p>{elem.title}</p>
                            {elem?.icon2 ? elem.icon2 : null}
                        </div>
                    ))}
                </div>
            ) : null}
        </>
    ) : <></>;
};

export default memo(Grid);